var _line, _line2, _line3, _line4, _line5, _line6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarouselPublicApi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 459,
    height: 565,
    viewBox: "0 0 459 565",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 113.8,
    y1: 230,
    x2: 113.8,
    y2: 332,
    stroke: "#EFB118",
    strokeWidth: 1.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 128.8,
    y1: 217,
    x2: 128.8,
    y2: 319,
    stroke: "#EFB118",
    strokeWidth: 1.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 189.8,
    y1: 186,
    x2: 189.8,
    y2: 288,
    stroke: "#EFB118",
    strokeWidth: 1.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 255.8,
    y1: 171,
    x2: 255.8,
    y2: 273,
    stroke: "#EFB118",
    strokeWidth: 1.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 204.8,
    y1: 173,
    x2: 204.8,
    y2: 275,
    stroke: "#EFB118",
    strokeWidth: 1.6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 270.8,
    y1: 158,
    x2: 270.8,
    y2: 260,
    stroke: "#EFB118",
    strokeWidth: 1.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.481 148.921L224.223 112.881C230.152 109.425 235.587 104.241 240.034 98.3161C244.481 92.1448 248.187 85.2328 250.164 78.074L312.67 114.115C310.446 121.274 306.987 128.186 302.54 134.357C297.846 140.528 292.411 145.712 286.481 148.921Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M286.481 148.921L224.223 112.881C230.152 109.425 235.587 104.241 240.034 98.3161C244.481 92.1448 248.187 85.2328 250.164 78.074L312.67 114.115C310.446 121.274 306.987 128.186 302.54 134.357C297.846 140.528 292.411 145.712 286.481 148.921Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.236 45.9831L306.495 82.0239C307.73 82.7645 308.966 83.7519 309.954 84.7393C312.919 88.1953 314.895 93.3792 314.895 100.044C314.895 104.488 314.154 109.178 312.672 113.868L250.413 77.8274C251.895 73.1371 252.636 68.4469 252.636 64.0035C252.636 57.3384 250.907 52.1545 247.695 48.6985C246.707 47.7111 245.472 46.7237 244.236 45.9831Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M312.669 114.115L250.41 78.0741C250.657 77.3335 250.904 76.5929 251.151 75.6055L313.41 111.646C312.916 112.634 312.916 113.374 312.669 114.115Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M313.165 111.646L250.906 75.6057C251.894 71.656 252.388 67.7063 252.388 64.0035C252.388 57.3384 250.659 52.1545 247.447 48.6985C246.459 47.4642 245.224 46.7237 243.988 45.9831L306.247 82.0239C307.482 82.7645 308.718 83.7519 309.706 84.7393C312.671 88.1953 314.647 93.3792 314.647 100.044C314.647 103.994 314.153 107.944 313.165 111.646Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M282.776 84.7393L220.517 48.6985C220.023 48.4517 219.529 47.9579 219.529 46.9705C218.294 41.5397 215.576 37.59 211.87 35.3683L274.129 71.4092C277.835 73.6308 280.552 77.5805 281.788 83.0113C281.788 83.9988 282.282 84.4925 282.776 84.7393Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M282.776 84.7393L220.517 48.6985C220.023 48.4517 219.529 47.9579 219.529 46.9705C218.294 41.5397 215.576 37.59 211.87 35.3683L274.129 71.4092C277.835 73.6308 280.552 77.5805 281.788 83.0113C281.788 83.9988 282.282 84.4925 282.776 84.7393Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.422 243.22L61.1631 206.933L224.469 112.881L286.481 148.922L123.422 243.22Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.058 84.7392L175.799 48.6984C175.058 48.2047 174.564 47.2173 174.564 45.983C174.564 45.4893 174.564 44.9956 174.564 44.7487C174.564 33.1466 171.352 24.2598 166.164 18.3353C164.434 16.3604 162.458 14.8793 160.481 13.645L222.74 49.6858C224.964 50.9201 226.693 52.4012 228.423 54.3761C233.611 60.3006 236.823 69.1874 236.823 80.7896C236.823 81.2833 236.823 81.5301 236.823 82.0238C236.823 83.2581 237.317 84.2455 238.058 84.7392Z",
    fill: "url(#paint8_linear)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M238.058 84.7392L175.799 48.6984C175.058 48.2047 174.564 47.2173 174.564 45.983C174.564 45.4893 174.564 44.9956 174.564 44.7487C174.564 33.1466 171.352 24.2598 166.164 18.3353C164.434 16.3604 162.458 14.8793 160.481 13.645L222.74 49.6858C224.964 50.9201 226.693 52.4012 228.423 54.3761C233.611 60.3006 236.823 69.1874 236.823 80.7896C236.823 81.2833 236.823 81.5301 236.823 82.0238C236.823 83.2581 237.317 84.2455 238.058 84.7392Z",
    fill: "url(#paint9_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2695 245.935L32.0107 209.894C35.7166 212.116 40.1637 213.103 45.1048 212.609C50.046 212.116 55.4813 210.388 61.1637 207.179L123.422 243.219C117.74 246.429 112.305 248.157 107.364 248.65C102.422 249.144 97.9754 248.157 94.2695 245.935Z",
    fill: "url(#paint10_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2695 245.936L32.0107 209.895C35.7166 212.116 40.1637 213.104 45.1048 212.61C49.3048 212.363 53.5048 210.882 58.199 208.66L120.458 244.701C115.764 246.923 111.317 248.404 107.364 248.651C102.422 249.145 97.9754 248.157 94.2695 245.936Z",
    fill: "url(#paint11_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.459 244.701L58.4473 208.413C59.4355 207.92 60.1767 207.426 61.1649 206.932L123.424 242.973C122.435 243.714 121.447 244.207 120.459 244.701Z",
    fill: "url(#paint12_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M252.804 160.64L289.725 139.765C290.569 139.282 290.569 138.111 289.725 137.629L252.804 116.753C251.608 116.064 250.061 116.064 248.866 116.753L211.944 137.629C211.101 138.111 211.101 139.282 211.944 139.765L248.866 160.64C250.132 161.329 251.608 161.329 252.804 160.64Z",
    stroke: "white",
    strokeWidth: 0.3726,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M285.295 138.869V137.56L282.904 137.836L282.552 138.249L252.593 121.301C251.538 120.681 250.202 120.681 249.147 121.301L219.399 138.111L219.118 137.698L216.375 137.56V138.869C216.375 139.214 216.586 139.627 216.938 139.834L249.147 158.022C250.202 158.642 251.538 158.642 252.593 158.022L284.802 139.834C285.084 139.627 285.295 139.283 285.295 138.869Z",
    fill: "url(#paint13_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M252.521 156.713L284.73 138.525C285.433 138.111 285.433 137.078 284.73 136.664L252.521 118.476C251.466 117.856 250.13 117.856 249.075 118.476L216.865 136.664C216.162 137.078 216.162 138.111 216.865 138.525L249.075 156.713C250.2 157.333 251.466 157.333 252.521 156.713Z",
    fill: "url(#paint14_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M280.653 137.835V125.503L278.543 125.71L278.262 126.054L252.312 111.379C251.398 110.828 250.272 110.828 249.358 111.379L223.689 125.916L223.478 125.572L221.087 125.503V137.835C221.087 138.18 221.228 138.455 221.579 138.662L249.428 154.371C250.343 154.922 251.468 154.922 252.382 154.371L280.231 138.662C280.513 138.455 280.653 138.111 280.653 137.835Z",
    fill: "url(#paint15_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.311 141.969L280.16 126.261C280.793 125.916 280.793 125.021 280.16 124.676L252.311 108.968C251.397 108.417 250.271 108.417 249.357 108.968L221.508 124.607C220.875 124.952 220.875 125.847 221.508 126.192L249.357 141.9C250.271 142.52 251.397 142.52 252.311 141.969Z",
    fill: "url(#paint16_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M280.16 137.56L252.311 153.268C251.397 153.819 250.271 153.819 249.357 153.268L221.508 137.56C221.227 137.353 221.016 137.078 221.016 136.733V137.767C221.016 138.111 221.156 138.387 221.508 138.593L249.357 154.371C250.271 154.922 251.397 154.922 252.311 154.371L280.16 138.662C280.512 138.456 280.652 138.18 280.652 137.836V136.802C280.652 137.078 280.441 137.353 280.16 137.56Z",
    fill: "url(#paint17_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M278.544 124.745V119.371L276.575 119.578L276.294 119.923L252.172 106.281C251.328 105.799 250.273 105.799 249.429 106.281L225.518 119.785L225.307 119.44L223.127 119.371V124.745C223.127 125.021 223.268 125.365 223.549 125.503L249.429 140.109C250.273 140.592 251.328 140.592 252.172 140.109L278.052 125.503C278.403 125.365 278.544 125.09 278.544 124.745Z",
    fill: "url(#paint18_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M227.418 126.192V124.263L248.235 135.976V137.974L227.418 126.192Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M226.292 125.641V123.643L224.042 122.403V124.332L226.292 125.641Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M274.256 126.192V124.263L253.51 135.975V137.973L274.256 126.192Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M275.382 125.641V123.643L277.703 122.403V124.332L275.382 125.641Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M252.241 134.804L278.121 120.198C278.684 119.854 278.684 119.027 278.121 118.682L252.241 104.007C251.397 103.525 250.342 103.525 249.498 104.007L223.618 118.682C223.056 119.027 223.056 119.854 223.618 120.198L249.498 134.804C250.342 135.286 251.397 135.286 252.241 134.804Z",
    fill: "url(#paint19_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M280.653 118.613V117.511L278.543 117.718L278.262 118.062L252.312 103.387C251.398 102.836 250.272 102.836 249.358 103.387L223.689 117.924L223.478 117.58L221.087 117.511V118.613C221.087 118.958 221.228 119.233 221.579 119.44L249.428 135.148C250.343 135.7 251.468 135.7 252.382 135.148L280.231 119.44C280.513 119.233 280.653 118.958 280.653 118.613Z",
    fill: "url(#paint20_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M252.311 134.046L280.16 118.338C280.793 117.993 280.793 117.098 280.16 116.753L252.311 101.045C251.397 100.494 250.271 100.494 249.357 101.045L221.508 116.684C220.875 117.029 220.875 117.924 221.508 118.269L249.357 133.977C250.271 134.597 251.397 134.597 252.311 134.046Z",
    fill: "url(#paint21_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M278.544 117.029V111.655L276.575 111.862L276.294 112.206L252.172 98.5647C251.328 98.0824 250.273 98.0824 249.429 98.5647L225.518 112.068L225.307 111.724L223.127 111.655V117.029C223.127 117.305 223.268 117.649 223.549 117.787L249.429 132.393C250.273 132.875 251.328 132.875 252.172 132.393L278.052 117.787C278.403 117.58 278.544 117.305 278.544 117.029Z",
    fill: "url(#paint22_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M227.418 118.407V116.409L248.235 128.19V130.119L227.418 118.407Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M226.292 117.787V115.789L224.042 114.549V116.547L226.292 117.787Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M274.256 118.407V116.409L253.51 128.19V130.119L274.256 118.407Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M275.382 117.787V115.789L277.703 114.549V116.547L275.382 117.787Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M252.241 127.019L278.121 112.413C278.684 112.068 278.684 111.241 278.121 110.897L252.241 96.291C251.397 95.8087 250.342 95.8087 249.498 96.291L223.618 110.897C223.056 111.241 223.056 112.068 223.618 112.413L249.498 127.019C250.342 127.501 251.397 127.501 252.241 127.019Z",
    fill: "url(#paint23_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M280.653 110.828V109.726L278.543 109.932L278.262 110.277L252.312 95.602C251.398 95.0509 250.272 95.0509 249.358 95.602L223.689 110.139L223.478 109.795L221.087 109.726V110.828C221.087 111.173 221.228 111.448 221.579 111.655L249.358 127.432C250.272 127.983 251.398 127.983 252.312 127.432L280.161 111.724C280.513 111.448 280.653 111.173 280.653 110.828Z",
    fill: "url(#paint24_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M252.311 126.261L280.16 110.553C280.793 110.208 280.793 109.312 280.16 108.968L252.311 93.2596C251.397 92.7085 250.271 92.7085 249.357 93.2596L221.508 108.899C220.875 109.244 220.875 110.139 221.508 110.484L249.357 126.192C250.271 126.812 251.397 126.812 252.311 126.261Z",
    fill: "url(#paint25_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M278.544 109.244V103.87L276.575 104.076L276.294 104.421L252.172 90.7793C251.328 90.297 250.273 90.297 249.429 90.7793L225.518 104.283L225.307 103.939L223.127 103.87V109.244C223.127 109.519 223.268 109.864 223.549 110.001L249.429 124.607C250.273 125.09 251.328 125.09 252.172 124.607L278.052 110.001C278.403 109.795 278.544 109.519 278.544 109.244Z",
    fill: "url(#paint26_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M227.418 110.621V108.623L248.235 120.336V122.334L227.418 110.621Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M226.292 110.001V108.003L224.042 106.763V108.761L226.292 110.001Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M274.256 110.622V108.624L253.51 120.336V122.334L274.256 110.622Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M275.382 110.001V108.003L277.703 106.763V108.761L275.382 110.001Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M252.241 119.233L278.121 104.627C278.684 104.283 278.684 103.456 278.121 103.112L252.241 88.5056C251.397 88.0234 250.342 88.0234 249.498 88.5056L223.618 103.112C223.056 103.456 223.056 104.283 223.618 104.627L249.498 119.233C250.342 119.716 251.397 119.716 252.241 119.233Z",
    fill: "url(#paint27_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M280.653 103.043V101.94L278.543 102.147L278.262 102.491L252.312 87.8165C251.398 87.2653 250.272 87.2653 249.358 87.8165L223.689 102.354L223.478 102.009L221.087 101.94V103.043C221.087 103.387 221.228 103.663 221.579 103.869L249.428 119.578C250.343 120.129 251.468 120.129 252.382 119.578L280.231 103.869C280.513 103.663 280.653 103.387 280.653 103.043Z",
    fill: "url(#paint28_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M252.311 118.476L280.16 102.767C280.793 102.423 280.793 101.527 280.16 101.183L252.311 85.4053C251.397 84.8542 250.271 84.8542 249.357 85.4053L221.508 101.114C220.875 101.458 220.875 102.354 221.508 102.698L249.357 118.476C250.271 119.027 251.397 119.027 252.311 118.476Z",
    fill: "url(#paint29_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M278.544 101.458V96.0845L276.575 96.2912L276.294 96.6356L252.172 82.9942C251.328 82.5119 250.273 82.5119 249.429 82.9942L225.518 96.4979L225.307 96.1534L223.127 96.0845V101.458C223.127 101.734 223.268 102.078 223.549 102.216L249.429 116.822C250.273 117.305 251.328 117.305 252.172 116.822L278.052 102.216C278.403 102.01 278.544 101.734 278.544 101.458Z",
    fill: "url(#paint30_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M252.241 111.448L278.121 96.8423C278.684 96.4978 278.684 95.6711 278.121 95.3266L252.241 80.7205C251.397 80.2383 250.342 80.2383 249.498 80.7205L223.618 95.3266C223.056 95.6711 223.056 96.4978 223.618 96.8423L249.498 111.448C250.342 111.931 251.397 111.931 252.241 111.448Z",
    fill: "url(#paint31_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M227.418 102.767V100.838L248.235 112.551V114.549L227.418 102.767Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M226.292 102.216V100.218L224.042 98.978V100.907L226.292 102.216Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M274.256 102.767V100.838L253.51 112.551V114.549L274.256 102.767Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M275.382 102.216V100.218L277.703 98.978V100.907L275.382 102.216Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M280.653 95.2576V94.1552L278.543 94.3619L278.262 94.7064L252.312 80.0315C251.398 79.4803 250.272 79.4803 249.358 80.0315L223.689 94.5686L223.478 94.2241L221.087 94.1552V95.2576C221.087 95.6021 221.228 95.8777 221.579 96.0843L249.428 111.862C250.343 112.413 251.468 112.413 252.382 111.862L280.231 96.1532C280.513 95.9466 280.653 95.6021 280.653 95.2576Z",
    fill: "url(#paint32_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M252.311 110.69L280.16 94.9818C280.793 94.6373 280.793 93.7417 280.16 93.3972L252.311 77.6888C251.397 77.1377 250.271 77.1377 249.357 77.6888L221.508 93.3283C220.875 93.6728 220.875 94.5684 221.508 94.9129L249.357 110.621C250.271 111.241 251.397 111.241 252.311 110.69Z",
    fill: "url(#paint33_linear)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M278.544 93.3975V78.447L276.575 78.6536L276.294 78.9981L252.172 65.3566C251.328 64.8744 250.273 64.8744 249.429 65.3566L225.518 78.8603L225.307 78.5159L223.127 78.447V93.3975C223.127 93.6731 223.268 94.0175 223.549 94.1553L249.429 108.761C250.273 109.244 251.328 109.244 252.172 108.761L278.052 94.1553C278.403 93.9486 278.544 93.6731 278.544 93.3975Z",
    fill: "url(#paint34_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M252.242 93.8797L278.122 79.2736C278.685 78.9291 278.685 78.1024 278.122 77.7579L252.242 63.1519C251.398 62.6696 250.343 62.6696 249.499 63.1519L223.619 77.7579C223.057 78.1024 223.057 78.9291 223.619 79.2736L249.499 93.8797C250.343 94.3619 251.398 94.3619 252.242 93.8797Z",
    fill: "url(#paint35_linear)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M252.1 92.4329L275.589 79.1359C276.151 78.8603 276.151 78.1025 275.589 77.758L252.1 64.461C251.326 64.0476 250.342 64.0476 249.568 64.461L226.079 77.758C225.517 78.0336 225.517 78.7914 226.079 79.1359L249.568 92.4329C250.342 92.9152 251.326 92.9152 252.1 92.4329Z",
    stroke: "url(#paint36_linear)",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M278.121 93.1219L252.241 107.728C251.397 108.21 250.342 108.21 249.498 107.728L223.618 93.1219C223.337 92.9841 223.196 92.6396 223.196 92.364V93.3286C223.196 93.6041 223.337 93.9486 223.618 94.0864L249.498 108.692C250.342 109.175 251.397 109.175 252.241 108.692L278.121 94.0864C278.402 93.9486 278.543 93.6041 278.543 93.3286V92.364C278.543 92.7085 278.402 92.9841 278.121 93.1219Z",
    fill: "url(#paint37_linear)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M254.773 96.7044L256.179 95.8777C256.249 95.8088 256.39 95.8777 256.39 96.0155V97.669C256.39 97.8068 256.32 97.9446 256.179 97.9446L254.773 98.7713C254.702 98.8402 254.562 98.7713 254.562 98.6335V97.0489C254.562 96.9111 254.632 96.7733 254.773 96.7044Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M257.587 95.051L258.993 94.2242C259.064 94.1553 259.204 94.2242 259.204 94.362V96.0155C259.204 96.1533 259.134 96.2911 258.993 96.2911L257.587 97.1179C257.517 97.1868 257.376 97.1179 257.376 96.9801V95.3955C257.376 95.2577 257.446 95.1199 257.587 95.051Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M260.469 93.4663L261.875 92.6395C261.946 92.5706 262.086 92.6395 262.086 92.7773V94.4308C262.086 94.5686 262.016 94.7064 261.875 94.7064L260.469 95.5332C260.398 95.6021 260.258 95.5332 260.258 95.3954V93.8108C260.258 93.673 260.328 93.5352 260.469 93.4663Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M263.283 91.8816L264.69 91.0549C264.76 90.986 264.901 91.0549 264.901 91.1927V92.8462C264.901 92.984 264.83 93.1218 264.69 93.1218L263.283 93.9485C263.213 94.0174 263.072 93.9485 263.072 93.8107V92.2261C263.143 92.0883 263.213 91.9505 263.283 91.8816Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M272.496 86.6455L273.903 85.8188C273.973 85.7499 274.114 85.8188 274.114 85.9566V87.6101C274.114 87.7479 274.043 87.8857 273.903 87.8857L272.496 88.7124C272.426 88.7813 272.285 88.7124 272.285 88.5746V86.99C272.285 86.8522 272.355 86.7144 272.496 86.6455Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M275.311 85.061L276.717 84.2342C276.787 84.1653 276.928 84.2342 276.928 84.372V86.0255C276.928 86.1633 276.858 86.3011 276.717 86.3011L275.311 87.1279C275.24 87.1968 275.1 87.1279 275.1 86.9901V85.4055C275.1 85.2677 275.17 85.1299 275.311 85.061Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M254.773 100.7L256.179 99.8736C256.249 99.8048 256.39 99.8736 256.39 100.011V101.665C256.39 101.803 256.32 101.941 256.179 101.941L254.773 102.767C254.702 102.836 254.562 102.767 254.562 102.629V101.045C254.562 100.907 254.632 100.769 254.773 100.7Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M257.587 99.1158L258.993 98.2891C259.064 98.2202 259.204 98.2891 259.204 98.4268V100.08C259.204 100.218 259.134 100.356 258.993 100.356L257.587 101.183C257.517 101.252 257.376 101.183 257.376 101.045V99.4603C257.376 99.3225 257.446 99.1847 257.587 99.1158Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M260.469 97.4621L261.875 96.6354C261.946 96.5665 262.086 96.6354 262.086 96.7732V98.4267C262.086 98.5645 262.016 98.7023 261.875 98.7023L260.469 99.529C260.398 99.5979 260.258 99.529 260.258 99.3912V97.8066C260.258 97.6688 260.328 97.531 260.469 97.4621Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M263.283 95.8775L264.69 95.0508C264.76 94.9819 264.901 95.0508 264.901 95.1886V96.8421C264.901 96.9799 264.83 97.1177 264.69 97.1177L263.283 97.9444C263.213 98.0133 263.072 97.9444 263.072 97.8066V96.222C263.143 96.0842 263.213 95.9464 263.283 95.8775Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M272.496 90.7102L273.903 89.8835C273.973 89.8146 274.114 89.8835 274.114 90.0213V91.6748C274.114 91.8126 274.043 91.9504 273.903 91.9504L272.496 92.7771C272.426 92.846 272.285 92.7771 272.285 92.6393V91.0547C272.285 90.9169 272.355 90.7791 272.496 90.7102Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M275.311 89.1257L276.717 88.2989C276.787 88.23 276.928 88.2989 276.928 88.4367V90.0902C276.928 90.228 276.858 90.3658 276.717 90.3658L275.311 91.1926C275.24 91.2615 275.1 91.1926 275.1 91.0548V89.4702C275.1 89.2635 275.17 89.1946 275.311 89.1257Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M246.967 96.7044L245.561 95.8776C245.49 95.8087 245.35 95.8776 245.35 96.0154V97.6689C245.35 97.8067 245.42 97.9445 245.561 97.9445L246.967 98.7713C247.037 98.8402 247.178 98.7713 247.178 98.6335V97.0489C247.108 96.9111 247.037 96.7733 246.967 96.7044Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M244.081 95.0509L242.675 94.2242C242.605 94.1553 242.464 94.2242 242.464 94.362V96.0155C242.464 96.1533 242.534 96.2911 242.675 96.2911L244.081 97.1178C244.152 97.1867 244.292 97.1178 244.292 96.98V95.3954C244.292 95.2576 244.222 95.1198 244.081 95.0509Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M241.2 93.4663L239.793 92.6395C239.723 92.5706 239.582 92.6395 239.582 92.7773V94.4308C239.582 94.5686 239.652 94.7064 239.793 94.7064L241.2 95.5332C241.27 95.6021 241.411 95.5332 241.411 95.3954V93.8108C241.411 93.673 241.34 93.5352 241.2 93.4663Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M238.388 91.8817L236.981 91.0549C236.911 90.986 236.771 91.0549 236.771 91.1927V92.8462C236.771 92.984 236.841 93.1218 236.981 93.1218L238.388 93.9486C238.458 94.0175 238.599 93.9486 238.599 93.8108V92.2262C238.599 92.0884 238.529 91.9506 238.388 91.8817Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M229.244 86.6458L227.838 85.8191C227.768 85.7502 227.627 85.8191 227.627 85.9569V87.6104C227.627 87.7482 227.697 87.886 227.838 87.886L229.244 88.7127C229.315 88.7816 229.455 88.7127 229.455 88.5749V86.9903C229.455 86.8525 229.385 86.7147 229.244 86.6458Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M226.362 85.061L224.955 84.2342C224.885 84.1653 224.744 84.2342 224.744 84.372V86.0255C224.744 86.1633 224.814 86.3011 224.955 86.3011L226.362 87.1279C226.432 87.1968 226.573 87.1279 226.573 86.9901V85.4055C226.573 85.2677 226.502 85.1299 226.362 85.061Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M246.967 100.7L245.561 99.8737C245.49 99.8048 245.35 99.8737 245.35 100.011V101.665C245.35 101.803 245.42 101.941 245.561 101.941L246.967 102.767C247.037 102.836 247.178 102.767 247.178 102.63V101.045C247.108 100.907 247.037 100.769 246.967 100.7Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M244.081 99.1158L242.675 98.2891C242.605 98.2202 242.464 98.2891 242.464 98.4268V100.08C242.464 100.218 242.534 100.356 242.675 100.356L244.081 101.183C244.152 101.252 244.292 101.183 244.292 101.045V99.4603C244.292 99.3225 244.222 99.1847 244.081 99.1158Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M241.2 97.4625L239.793 96.6358C239.723 96.5669 239.582 96.6358 239.582 96.7736V98.4271C239.582 98.5649 239.652 98.7027 239.793 98.7027L241.2 99.5294C241.27 99.5983 241.411 99.5294 241.411 99.3916V97.807C241.411 97.6692 241.34 97.5314 241.2 97.4625Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M238.388 95.8778L236.981 95.051C236.911 94.9821 236.771 95.051 236.771 95.1888V96.8423C236.771 96.9801 236.841 97.1179 236.981 97.1179L238.388 97.9447C238.458 98.0136 238.599 97.9447 238.599 97.8069V96.2223C238.599 96.0845 238.529 95.9467 238.388 95.8778Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M229.248 90.7106L227.842 89.8838C227.772 89.8149 227.631 89.8838 227.631 90.0216V91.6752C227.631 91.8129 227.701 91.9507 227.842 91.9507L229.248 92.7775C229.319 92.8464 229.459 92.7775 229.459 92.6397V91.0551C229.459 90.9173 229.389 90.7795 229.248 90.7106Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M226.362 89.1261L224.955 88.2993C224.885 88.2304 224.744 88.2993 224.744 88.4371V90.0906C224.744 90.2284 224.814 90.3662 224.955 90.3662L226.362 91.1929C226.432 91.2618 226.573 91.193 226.573 91.0552V89.4705C226.573 89.2639 226.502 89.195 226.362 89.1261Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M272.285 77.8955V77.1376L270.808 77.2754L270.597 77.551L251.96 67.0098C251.328 66.6653 250.484 66.6653 249.851 67.0098L231.355 77.4821L231.214 77.2065L229.526 77.1376V77.9643C229.526 78.171 229.667 78.4466 229.878 78.5844L249.921 89.8834C250.554 90.2279 251.398 90.2279 252.031 89.8834L272.074 78.5844C272.144 78.3777 272.285 78.171 272.285 77.8955Z",
    fill: "url(#paint38_linear)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M251.888 89.0568L271.931 77.7578C272.353 77.4822 272.353 76.8621 271.931 76.5865L251.888 65.2875C251.255 64.9431 250.411 64.9431 249.778 65.2875L229.735 76.5865C229.313 76.8621 229.313 77.4822 229.735 77.7578L249.778 89.0568C250.411 89.4013 251.255 89.4013 251.888 89.0568Z",
    fill: "url(#paint39_linear)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M251.817 87.9543L270.032 77.6887C270.454 77.482 270.454 76.862 270.032 76.6553L251.817 66.3897C251.185 66.0452 250.481 66.0452 249.919 66.3897L231.704 76.6553C231.282 76.862 231.282 77.482 231.704 77.6887L249.919 87.9543C250.481 88.2988 251.185 88.2988 251.817 87.9543Z",
    stroke: "url(#paint40_linear)",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M260.962 76.5178V75.6222L260.259 75.6911L260.188 75.8289L251.327 70.7994C251.046 70.5927 250.624 70.5927 250.343 70.7994L241.622 75.76L241.552 75.6222L240.708 75.5533V76.4489C240.708 76.5867 240.778 76.6556 240.849 76.7245L250.343 82.0984C250.624 82.3051 251.046 82.3051 251.327 82.0984L260.821 76.7245C260.962 76.7934 260.962 76.6556 260.962 76.5178Z",
    fill: "url(#paint41_linear)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M251.328 81.2716L260.822 75.8977C261.033 75.7599 261.033 75.4843 260.822 75.3465L251.328 69.9726C251.047 69.766 250.625 69.766 250.344 69.9726L240.85 75.3465C240.639 75.4843 240.639 75.7599 240.85 75.8977L250.344 81.2716C250.625 81.4783 251.047 81.4783 251.328 81.2716Z",
    fill: "url(#paint42_linear)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M254.771 143.692L256.177 142.865C256.247 142.796 256.388 142.865 256.388 143.003V144.656C256.388 144.794 256.318 144.932 256.177 144.932L254.771 145.759C254.7 145.828 254.56 145.759 254.56 145.621V144.036C254.56 143.899 254.63 143.761 254.771 143.692Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M257.585 142.107L258.992 141.28C259.062 141.212 259.203 141.28 259.203 141.418V143.072C259.203 143.21 259.132 143.347 258.992 143.347L257.585 144.174C257.515 144.243 257.374 144.174 257.374 144.036V142.452C257.374 142.314 257.444 142.176 257.585 142.107Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M260.469 140.453L261.875 139.627C261.946 139.558 262.086 139.627 262.086 139.764V141.418C262.086 141.556 262.016 141.693 261.875 141.693L260.469 142.52C260.398 142.589 260.258 142.52 260.258 142.382V140.798C260.258 140.66 260.328 140.522 260.469 140.453Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M263.283 138.869L264.69 138.042C264.76 137.973 264.901 138.042 264.901 138.18V139.833C264.901 139.971 264.83 140.109 264.69 140.109L263.283 140.936C263.213 141.004 263.072 140.936 263.072 140.798V139.213C263.143 139.075 263.213 138.938 263.283 138.869Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M272.495 133.702L273.902 132.875C273.972 132.806 274.113 132.875 274.113 133.013V134.666C274.113 134.804 274.042 134.942 273.902 134.942L272.495 135.769C272.425 135.838 272.284 135.769 272.284 135.631V134.046C272.284 133.908 272.355 133.771 272.495 133.702Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M275.31 132.048L276.716 131.222C276.786 131.153 276.927 131.222 276.927 131.359V133.013C276.927 133.151 276.857 133.288 276.716 133.288L275.31 134.115C275.239 134.184 275.099 134.115 275.099 133.977V132.393C275.099 132.255 275.169 132.117 275.31 132.048Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M254.771 147.757L256.177 146.93C256.247 146.861 256.388 146.93 256.388 147.068V148.721C256.388 148.859 256.318 148.997 256.177 148.997L254.771 149.824C254.7 149.892 254.56 149.824 254.56 149.686V148.101C254.56 147.894 254.63 147.826 254.771 147.757Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M257.585 146.103L258.992 145.276C259.062 145.207 259.203 145.276 259.203 145.414V147.068C259.203 147.205 259.132 147.343 258.992 147.343L257.585 148.17C257.515 148.239 257.374 148.17 257.374 148.032V146.447C257.374 146.31 257.444 146.172 257.585 146.103Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M260.469 144.519L261.875 143.692C261.946 143.623 262.086 143.692 262.086 143.83V145.483C262.086 145.621 262.016 145.759 261.875 145.759L260.469 146.586C260.398 146.655 260.258 146.586 260.258 146.448V144.863C260.258 144.726 260.328 144.588 260.469 144.519Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M263.283 142.865L264.69 142.038C264.76 141.969 264.901 142.038 264.901 142.176V143.83C264.901 143.967 264.83 144.105 264.69 144.105L263.283 144.932C263.213 145.001 263.072 144.932 263.072 144.794V143.21C263.143 143.072 263.213 142.934 263.283 142.865Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M272.495 137.698L273.902 136.871C273.972 136.802 274.113 136.871 274.113 137.009V138.662C274.113 138.8 274.042 138.938 273.902 138.938L272.495 139.765C272.425 139.834 272.284 139.765 272.284 139.627V138.042C272.284 137.905 272.355 137.767 272.495 137.698Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M275.31 136.113L276.716 135.287C276.786 135.218 276.927 135.287 276.927 135.424V137.078C276.927 137.216 276.857 137.353 276.716 137.353L275.31 138.18C275.239 138.249 275.099 138.18 275.099 138.042V136.458C275.099 136.32 275.169 136.182 275.31 136.113Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M246.967 143.416L245.561 142.589C245.49 142.52 245.35 142.589 245.35 142.727V144.381C245.35 144.518 245.42 144.656 245.561 144.656L246.967 145.483C247.037 145.552 247.178 145.483 247.178 145.345V143.761C247.108 143.623 247.037 143.485 246.967 143.416Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M244.084 141.831L242.678 141.005C242.607 140.936 242.467 141.004 242.467 141.142V142.796C242.467 142.934 242.537 143.071 242.678 143.071L244.084 143.898C244.155 143.967 244.295 143.898 244.295 143.76V142.176C244.295 141.969 244.225 141.9 244.084 141.831Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M241.204 140.178L239.798 139.351C239.728 139.282 239.587 139.351 239.587 139.489V141.142C239.587 141.28 239.657 141.418 239.798 141.418L241.204 142.245C241.275 142.314 241.415 142.245 241.415 142.107V140.522C241.415 140.385 241.345 140.247 241.204 140.178Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M238.39 138.593L236.983 137.767C236.913 137.698 236.772 137.767 236.772 137.904V139.558C236.772 139.696 236.843 139.834 236.983 139.834L238.39 140.66C238.46 140.729 238.601 140.66 238.601 140.523V138.938C238.601 138.8 238.531 138.662 238.39 138.593Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M229.247 133.357L227.841 132.531C227.771 132.462 227.63 132.531 227.63 132.668V134.322C227.63 134.46 227.7 134.597 227.841 134.597L229.247 135.424C229.318 135.493 229.458 135.424 229.458 135.286V133.702C229.458 133.564 229.388 133.426 229.247 133.357Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M226.363 131.773L224.956 130.946C224.886 130.877 224.745 130.946 224.745 131.084V132.737C224.745 132.875 224.815 133.013 224.956 133.013L226.363 133.839C226.433 133.908 226.574 133.839 226.574 133.702V132.117C226.574 131.979 226.503 131.841 226.363 131.773Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M246.967 147.412L245.561 146.585C245.49 146.516 245.35 146.585 245.35 146.723V148.377C245.35 148.514 245.42 148.652 245.561 148.652L246.967 149.479C247.037 149.548 247.178 149.479 247.178 149.341V147.757C247.108 147.619 247.037 147.481 246.967 147.412Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M244.084 145.828L242.678 145.001C242.607 144.932 242.467 145.001 242.467 145.139V146.792C242.467 146.93 242.537 147.068 242.678 147.068L244.084 147.894C244.155 147.963 244.295 147.894 244.295 147.757V146.172C244.295 146.034 244.225 145.896 244.084 145.828Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M241.204 144.243L239.798 143.416C239.728 143.347 239.587 143.416 239.587 143.554V145.207C239.587 145.345 239.657 145.483 239.798 145.483L241.204 146.309C241.275 146.378 241.415 146.309 241.415 146.172V144.587C241.415 144.38 241.345 144.311 241.204 144.243Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M238.39 142.589L236.983 141.762C236.913 141.694 236.772 141.762 236.772 141.9V143.554C236.772 143.692 236.843 143.829 236.983 143.829L238.39 144.656C238.46 144.725 238.601 144.656 238.601 144.518V142.934C238.601 142.796 238.531 142.658 238.39 142.589Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M229.249 137.422L227.843 136.595C227.772 136.527 227.632 136.595 227.632 136.733V138.387C227.632 138.525 227.702 138.662 227.843 138.662L229.249 139.489C229.32 139.558 229.46 139.489 229.46 139.351V137.767C229.46 137.629 229.39 137.491 229.249 137.422Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M226.363 135.837L224.956 135.011C224.886 134.942 224.745 135.011 224.745 135.148V136.802C224.745 136.94 224.815 137.078 224.956 137.078L226.363 137.904C226.433 137.973 226.574 137.904 226.574 137.766V136.182C226.574 136.044 226.503 135.906 226.363 135.837Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M207.52 186.001L244.441 165.125C245.285 164.643 245.285 163.472 244.441 162.99L207.52 142.114C206.324 141.425 204.777 141.425 203.582 142.114L166.66 162.99C165.816 163.472 165.816 164.643 166.66 165.125L203.582 186.001C204.847 186.69 206.324 186.69 207.52 186.001Z",
    stroke: "white",
    strokeWidth: 0.3726,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M240.012 164.23V162.921L237.62 163.196L237.269 163.61L207.31 146.661C206.255 146.041 204.919 146.041 203.864 146.661L174.116 163.472L173.835 163.059L171.092 162.921V164.23C171.092 164.574 171.303 164.988 171.654 165.194L203.864 183.383C204.919 184.003 206.255 184.003 207.31 183.383L239.519 165.194C239.801 164.988 240.012 164.643 240.012 164.23Z",
    fill: "url(#paint43_linear)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M207.239 182.074L239.448 163.885C240.151 163.472 240.151 162.439 239.448 162.025L207.239 143.837C206.184 143.216 204.847 143.216 203.793 143.837L171.583 162.025C170.88 162.439 170.88 163.472 171.583 163.885L203.793 182.074C204.918 182.694 206.184 182.694 207.239 182.074Z",
    fill: "url(#paint44_linear)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M235.369 163.196V150.864L233.259 151.07L232.978 151.415L207.028 136.74C206.113 136.189 204.988 136.189 204.074 136.74L178.405 151.277L178.194 150.933L175.803 150.864V163.196C175.803 163.541 175.943 163.816 176.295 164.023L204.144 179.731C205.058 180.283 206.184 180.283 207.098 179.731L234.947 164.023C235.228 163.816 235.369 163.472 235.369 163.196Z",
    fill: "url(#paint45_linear)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M207.028 167.33L234.877 151.622C235.51 151.277 235.51 150.381 234.877 150.037L207.028 134.329C206.113 133.777 204.988 133.777 204.074 134.329L176.225 149.968C175.592 150.313 175.592 151.208 176.225 151.553L204.074 167.261C204.988 167.881 206.113 167.881 207.028 167.33Z",
    fill: "url(#paint46_linear)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M234.876 162.921L207.027 178.629C206.112 179.18 204.987 179.18 204.073 178.629L176.224 162.921C175.942 162.714 175.731 162.438 175.731 162.094V163.127C175.731 163.472 175.872 163.748 176.224 163.954L204.073 179.731C204.987 180.283 206.112 180.283 207.027 179.731L234.876 164.023C235.227 163.816 235.368 163.541 235.368 163.196V162.163C235.368 162.438 235.157 162.714 234.876 162.921Z",
    fill: "url(#paint47_linear)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M233.26 150.106V144.732L231.291 144.939L231.009 145.283L206.888 131.642C206.044 131.16 204.989 131.16 204.145 131.642L180.234 145.146L180.023 144.801L177.843 144.732V150.106C177.843 150.382 177.983 150.726 178.265 150.864L204.145 165.47C204.989 165.952 206.044 165.952 206.888 165.47L232.768 150.864C233.119 150.726 233.26 150.451 233.26 150.106Z",
    fill: "url(#paint48_linear)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M182.131 151.553V149.624L202.947 161.336V163.334L182.131 151.553Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M181.008 151.002V149.004L178.758 147.764V149.693L181.008 151.002Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M228.971 151.553V149.624L208.225 161.336V163.334L228.971 151.553Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M230.096 151.002V149.004L232.416 147.764V149.693L230.096 151.002Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M206.96 160.165L232.84 145.559C233.402 145.214 233.402 144.388 232.84 144.043L206.96 129.368C206.116 128.886 205.061 128.886 204.217 129.368L178.337 144.043C177.774 144.388 177.774 145.214 178.337 145.559L204.217 160.165C205.061 160.647 206.116 160.647 206.96 160.165Z",
    fill: "url(#paint49_linear)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M235.369 143.974V142.872L233.259 143.078L232.978 143.423L207.028 128.748C206.113 128.197 204.988 128.197 204.074 128.748L178.405 143.285L178.194 142.941L175.803 142.872V143.974C175.803 144.319 175.943 144.594 176.295 144.801L204.144 160.509C205.058 161.06 206.184 161.06 207.098 160.509L234.947 144.801C235.228 144.594 235.369 144.319 235.369 143.974Z",
    fill: "url(#paint50_linear)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M207.028 159.407L234.877 143.699C235.51 143.354 235.51 142.459 234.877 142.114L207.028 126.406C206.113 125.855 204.988 125.855 204.074 126.406L176.225 142.045C175.592 142.39 175.592 143.285 176.225 143.63L204.074 159.338C204.988 159.958 206.113 159.958 207.028 159.407Z",
    fill: "url(#paint51_linear)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M233.26 142.39V137.016L231.291 137.223L231.009 137.567L206.888 123.926C206.044 123.443 204.989 123.443 204.145 123.926L180.234 137.429L180.023 137.085L177.843 137.016V142.39C177.843 142.665 177.983 143.01 178.265 143.148L204.145 157.754C204.989 158.236 206.044 158.236 206.888 157.754L232.768 143.148C233.119 142.941 233.26 142.665 233.26 142.39Z",
    fill: "url(#paint52_linear)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M182.131 143.768V141.77L202.947 153.551V155.48L182.131 143.768Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M181.008 143.148V141.15L178.758 139.91V141.908L181.008 143.148Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M228.971 143.768V141.77L208.225 153.551V155.48L228.971 143.768Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M230.096 143.148V141.15L232.416 139.909V141.907L230.096 143.148Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M206.96 152.38L232.84 137.774C233.402 137.429 233.402 136.602 232.84 136.258L206.96 121.652C206.116 121.17 205.061 121.17 204.217 121.652L178.337 136.258C177.774 136.602 177.774 137.429 178.337 137.774L204.217 152.38C205.061 152.862 206.116 152.862 206.96 152.38Z",
    fill: "url(#paint53_linear)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M235.369 136.189V135.087L233.259 135.293L232.978 135.638L207.028 120.963C206.113 120.412 204.988 120.412 204.074 120.963L178.405 135.5L178.194 135.155L175.803 135.087V136.189C175.803 136.533 175.943 136.809 176.295 137.016L204.074 152.793C204.988 153.344 206.113 153.344 207.028 152.793L234.877 137.085C235.228 136.809 235.369 136.533 235.369 136.189Z",
    fill: "url(#paint54_linear)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M207.028 151.622L234.877 135.913C235.51 135.569 235.51 134.673 234.877 134.329L207.028 118.62C206.113 118.069 204.988 118.069 204.074 118.62L176.225 134.26C175.592 134.604 175.592 135.5 176.225 135.845L204.074 151.553C204.988 152.173 206.113 152.173 207.028 151.622Z",
    fill: "url(#paint55_linear)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M233.26 134.604V129.23L231.291 129.437L231.009 129.782L206.888 116.14C206.044 115.658 204.989 115.658 204.145 116.14L180.234 129.644L180.023 129.299L177.843 129.23V134.604C177.843 134.88 177.983 135.224 178.265 135.362L204.145 149.968C204.989 150.45 206.044 150.45 206.888 149.968L232.768 135.362C233.119 135.155 233.26 134.88 233.26 134.604Z",
    fill: "url(#paint56_linear)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M182.131 135.982V133.984L202.947 145.697V147.695L182.131 135.982Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M181.008 135.362V133.364L178.758 132.124V134.122L181.008 135.362Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M228.971 135.982V133.984L208.225 145.697V147.695L228.971 135.982Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M230.096 135.362V133.364L232.416 132.124V134.122L230.096 135.362Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M206.96 144.594L232.84 129.988C233.402 129.644 233.402 128.817 232.84 128.472L206.96 113.866C206.116 113.384 205.061 113.384 204.217 113.866L178.337 128.472C177.774 128.817 177.774 129.644 178.337 129.988L204.217 144.594C205.061 145.077 206.116 145.077 206.96 144.594Z",
    fill: "url(#paint57_linear)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M235.369 128.404V127.301L233.259 127.508L232.978 127.852L207.028 113.177C206.113 112.626 204.988 112.626 204.074 113.177L178.405 127.715L178.194 127.37L175.803 127.301V128.404C175.803 128.748 175.943 129.024 176.295 129.23L204.144 144.939C205.058 145.49 206.184 145.49 207.098 144.939L234.947 129.23C235.228 129.024 235.369 128.748 235.369 128.404Z",
    fill: "url(#paint58_linear)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M207.028 143.836L234.877 128.128C235.51 127.784 235.51 126.888 234.877 126.543L207.028 110.766C206.113 110.215 204.988 110.215 204.074 110.766L176.225 126.474C175.592 126.819 175.592 127.715 176.225 128.059L204.074 143.836C204.988 144.388 206.113 144.388 207.028 143.836Z",
    fill: "url(#paint59_linear)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M233.26 126.819V121.445L231.291 121.652L231.009 121.996L206.888 108.355C206.044 107.873 204.989 107.873 204.145 108.355L180.234 121.859L180.023 121.514L177.843 121.445V126.819C177.843 127.095 177.983 127.439 178.265 127.577L204.145 142.183C204.989 142.665 206.044 142.665 206.888 142.183L232.768 127.577C233.119 127.37 233.26 127.095 233.26 126.819Z",
    fill: "url(#paint60_linear)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M206.96 136.809L232.84 122.203C233.402 121.858 233.402 121.032 232.84 120.687L206.96 106.081C206.116 105.599 205.061 105.599 204.217 106.081L178.337 120.687C177.774 121.032 177.774 121.858 178.337 122.203L204.217 136.809C205.061 137.291 206.116 137.291 206.96 136.809Z",
    fill: "url(#paint61_linear)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M182.131 128.128V126.199L202.947 137.911V139.909L182.131 128.128Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M181.008 127.577V125.579L178.758 124.339V126.268L181.008 127.577Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M228.971 128.128V126.199L208.225 137.911V139.909L228.971 128.128Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M230.096 127.577V125.579L232.416 124.339V126.268L230.096 127.577Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M235.369 120.618V119.516L233.259 119.723L232.978 120.067L207.028 105.392C206.113 104.841 204.988 104.841 204.074 105.392L178.405 119.929L178.194 119.585L175.803 119.516V120.618C175.803 120.963 175.943 121.238 176.295 121.445L204.144 137.222C205.058 137.774 206.184 137.774 207.098 137.222L234.947 121.514C235.228 121.307 235.369 120.963 235.369 120.618Z",
    fill: "url(#paint62_linear)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M207.028 136.051L234.877 120.343C235.51 119.998 235.51 119.103 234.877 118.758L207.028 103.05C206.113 102.499 204.988 102.499 204.074 103.05L176.225 118.689C175.592 119.034 175.592 119.929 176.225 120.274L204.074 135.982C204.988 136.602 206.113 136.602 207.028 136.051Z",
    fill: "url(#paint63_linear)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M233.26 118.758V103.808L231.291 104.014L231.009 104.359L206.888 90.7174C206.044 90.2351 204.989 90.2351 204.145 90.7174L180.234 104.221L180.023 103.877L177.843 103.808V118.758C177.843 119.034 177.983 119.378 178.265 119.516L204.145 134.122C204.989 134.604 206.044 134.604 206.888 134.122L232.768 119.516C233.119 119.309 233.26 119.034 233.26 118.758Z",
    fill: "url(#paint64_linear)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M206.958 119.24L232.838 104.634C233.401 104.29 233.401 103.463 232.838 103.119L206.958 88.5126C206.114 88.0304 205.059 88.0304 204.215 88.5126L178.335 103.119C177.772 103.463 177.772 104.29 178.335 104.634L204.215 119.24C205.059 119.723 206.114 119.723 206.958 119.24Z",
    fill: "url(#paint65_linear)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M206.816 117.794L230.305 104.497C230.867 104.221 230.867 103.463 230.305 103.119L206.816 89.8219C206.042 89.4085 205.058 89.4085 204.284 89.8219L180.795 103.119C180.232 103.394 180.232 104.152 180.795 104.497L204.284 117.794C205.058 118.276 206.042 118.276 206.816 117.794Z",
    stroke: "url(#paint66_linear)",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M232.837 118.483L206.957 133.089C206.113 133.571 205.058 133.571 204.214 133.089L178.334 118.483C178.053 118.345 177.912 118 177.912 117.725V118.689C177.912 118.965 178.053 119.309 178.334 119.447L204.214 134.053C205.058 134.535 206.113 134.535 206.957 134.053L232.837 119.447C233.118 119.309 233.259 118.965 233.259 118.689V117.725C233.259 118.069 233.118 118.345 232.837 118.483Z",
    fill: "url(#paint67_linear)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M209.486 122.065L210.893 121.238C210.963 121.169 211.104 121.238 211.104 121.376V123.03C211.104 123.168 211.034 123.305 210.893 123.305L209.486 124.132C209.416 124.201 209.275 124.132 209.275 123.994V122.41C209.275 122.272 209.346 122.134 209.486 122.065Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M212.301 120.412L213.707 119.585C213.778 119.516 213.918 119.585 213.918 119.723V121.376C213.918 121.514 213.848 121.652 213.707 121.652L212.301 122.479C212.23 122.547 212.09 122.479 212.09 122.341V120.756C212.09 120.618 212.16 120.481 212.301 120.412Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M215.184 118.827L216.59 118C216.66 117.931 216.801 118 216.801 118.138V119.791C216.801 119.929 216.731 120.067 216.59 120.067L215.184 120.894C215.113 120.963 214.973 120.894 214.973 120.756V119.171C214.973 119.034 215.043 118.896 215.184 118.827Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M217.998 117.242L219.405 116.415C219.475 116.347 219.616 116.415 219.616 116.553V118.207C219.616 118.345 219.545 118.482 219.405 118.482L217.998 119.309C217.928 119.378 217.787 119.309 217.787 119.171V117.587C217.857 117.449 217.928 117.311 217.998 117.242Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M227.208 112.006L228.615 111.179C228.685 111.11 228.826 111.179 228.826 111.317V112.971C228.826 113.108 228.755 113.246 228.615 113.246L227.208 114.073C227.138 114.142 226.997 114.073 226.997 113.935V112.351C226.997 112.213 227.067 112.075 227.208 112.006Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M230.023 110.422L231.429 109.595C231.499 109.526 231.64 109.595 231.64 109.733V111.386C231.64 111.524 231.57 111.662 231.429 111.662L230.023 112.488C229.952 112.557 229.812 112.488 229.812 112.351V110.766C229.812 110.628 229.882 110.49 230.023 110.422Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M209.486 126.061L210.893 125.234C210.963 125.165 211.104 125.234 211.104 125.372V127.025C211.104 127.163 211.034 127.301 210.893 127.301L209.486 128.128C209.416 128.197 209.275 128.128 209.275 127.99V126.405C209.275 126.268 209.346 126.13 209.486 126.061Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M212.301 124.476L213.707 123.65C213.778 123.581 213.918 123.65 213.918 123.787V125.441C213.918 125.579 213.848 125.716 213.707 125.716L212.301 126.543C212.23 126.612 212.09 126.543 212.09 126.405V124.821C212.09 124.683 212.16 124.545 212.301 124.476Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M215.184 122.823L216.59 121.996C216.66 121.927 216.801 121.996 216.801 122.134V123.788C216.801 123.925 216.731 124.063 216.59 124.063L215.184 124.89C215.113 124.959 214.973 124.89 214.973 124.752V123.167C214.973 123.03 215.043 122.892 215.184 122.823Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M217.998 121.238L219.405 120.412C219.475 120.343 219.616 120.412 219.616 120.549V122.203C219.616 122.341 219.545 122.478 219.405 122.478L217.998 123.305C217.928 123.374 217.787 123.305 217.787 123.167V121.583C217.857 121.445 217.928 121.307 217.998 121.238Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M227.208 116.071L228.615 115.244C228.685 115.175 228.826 115.244 228.826 115.382V117.035C228.826 117.173 228.755 117.311 228.615 117.311L227.208 118.138C227.138 118.207 226.997 118.138 226.997 118V116.415C226.997 116.278 227.067 116.14 227.208 116.071Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M230.023 114.486L231.429 113.66C231.499 113.591 231.64 113.66 231.64 113.797V115.451C231.64 115.589 231.57 115.726 231.429 115.726L230.023 116.553C229.952 116.622 229.812 116.553 229.812 116.415V114.831C229.812 114.624 229.882 114.555 230.023 114.486Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M201.679 122.065L200.272 121.238C200.202 121.17 200.062 121.238 200.062 121.376V123.03C200.062 123.168 200.132 123.305 200.272 123.305L201.679 124.132C201.749 124.201 201.89 124.132 201.89 123.994V122.41C201.82 122.272 201.749 122.134 201.679 122.065Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M198.798 120.412L197.392 119.585C197.321 119.516 197.181 119.585 197.181 119.723V121.376C197.181 121.514 197.251 121.652 197.392 121.652L198.798 122.479C198.868 122.548 199.009 122.479 199.009 122.341V120.756C199.009 120.618 198.939 120.481 198.798 120.412Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M195.914 118.827L194.508 118C194.438 117.931 194.297 118 194.297 118.138V119.792C194.297 119.929 194.367 120.067 194.508 120.067L195.914 120.894C195.985 120.963 196.125 120.894 196.125 120.756V119.172C196.125 119.034 196.055 118.896 195.914 118.827Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M193.101 117.242L191.694 116.416C191.624 116.347 191.483 116.416 191.483 116.553V118.207C191.483 118.345 191.554 118.483 191.694 118.483L193.101 119.309C193.171 119.378 193.312 119.309 193.312 119.172V117.587C193.312 117.449 193.242 117.311 193.101 117.242Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M183.955 112.006L182.549 111.18C182.479 111.111 182.338 111.18 182.338 111.317V112.971C182.338 113.109 182.408 113.247 182.549 113.247L183.955 114.073C184.026 114.142 184.166 114.073 184.166 113.935V112.351C184.166 112.213 184.096 112.075 183.955 112.006Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M181.075 110.422L179.668 109.595C179.598 109.526 179.457 109.595 179.457 109.733V111.386C179.457 111.524 179.527 111.662 179.668 111.662L181.075 112.489C181.145 112.557 181.286 112.489 181.286 112.351V110.766C181.286 110.628 181.215 110.491 181.075 110.422Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M201.679 126.061L200.272 125.234C200.202 125.166 200.062 125.234 200.062 125.372V127.026C200.062 127.164 200.132 127.301 200.272 127.301L201.679 128.128C201.749 128.197 201.89 128.128 201.89 127.99V126.406C201.82 126.268 201.749 126.13 201.679 126.061Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M198.798 124.477L197.392 123.65C197.321 123.581 197.181 123.65 197.181 123.788V125.441C197.181 125.579 197.251 125.717 197.392 125.717L198.798 126.543C198.868 126.612 199.009 126.543 199.009 126.406V124.821C199.009 124.683 198.939 124.545 198.798 124.477Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M195.914 122.823L194.508 121.996C194.438 121.927 194.297 121.996 194.297 122.134V123.788C194.297 123.925 194.367 124.063 194.508 124.063L195.914 124.89C195.985 124.959 196.125 124.89 196.125 124.752V123.168C196.125 123.03 196.055 122.892 195.914 122.823Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M193.101 121.238L191.694 120.412C191.624 120.343 191.483 120.412 191.483 120.549V122.203C191.483 122.341 191.554 122.478 191.694 122.478L193.101 123.305C193.171 123.374 193.312 123.305 193.312 123.167V121.583C193.312 121.445 193.242 121.307 193.101 121.238Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M183.957 116.071L182.551 115.244C182.48 115.176 182.34 115.244 182.34 115.382V117.036C182.34 117.174 182.41 117.311 182.551 117.311L183.957 118.138C184.028 118.207 184.168 118.138 184.168 118V116.416C184.168 116.278 184.098 116.14 183.957 116.071Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M181.075 114.487L179.668 113.66C179.598 113.591 179.457 113.66 179.457 113.798V115.451C179.457 115.589 179.527 115.727 179.668 115.727L181.075 116.553C181.145 116.622 181.286 116.553 181.286 116.416V114.831C181.286 114.624 181.215 114.555 181.075 114.487Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M227 103.256V102.498L225.523 102.636L225.312 102.912L206.675 92.3707C206.042 92.0262 205.198 92.0262 204.566 92.3707L186.07 102.843L185.929 102.567L184.241 102.498V103.325C184.241 103.532 184.382 103.808 184.593 103.945L204.636 115.244C205.269 115.589 206.113 115.589 206.746 115.244L226.789 103.945C226.859 103.739 227 103.532 227 103.256Z",
    fill: "url(#paint68_linear)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M206.604 114.418L226.647 103.119C227.069 102.843 227.069 102.223 226.647 101.947L206.604 90.6484C205.971 90.3039 205.127 90.3039 204.494 90.6484L184.451 101.947C184.029 102.223 184.029 102.843 184.451 103.119L204.494 114.418C205.127 114.762 205.971 114.762 206.604 114.418Z",
    fill: "url(#paint69_linear)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M206.532 113.315L224.747 103.05C225.169 102.843 225.169 102.223 224.747 102.016L206.532 91.7505C205.899 91.406 205.196 91.406 204.634 91.7505L186.419 102.016C185.997 102.223 185.997 102.843 186.419 103.05L204.634 113.315C205.196 113.66 205.899 113.66 206.532 113.315Z",
    stroke: "url(#paint70_linear)",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M215.678 101.879V100.983L214.975 101.052L214.904 101.19L206.043 96.1603C205.762 95.9536 205.34 95.9536 205.059 96.1603L196.338 101.121L196.268 100.983L195.424 100.914V101.81C195.424 101.948 195.494 102.017 195.564 102.085L205.059 107.459C205.34 107.666 205.762 107.666 206.043 107.459L215.537 102.085C215.678 102.154 215.678 102.017 215.678 101.879Z",
    fill: "url(#paint71_linear)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M206.044 106.632L215.538 101.259C215.749 101.121 215.749 100.845 215.538 100.707L206.044 95.3335C205.763 95.1268 205.341 95.1268 205.06 95.3335L195.565 100.707C195.354 100.845 195.354 101.121 195.565 101.259L205.06 106.632C205.341 106.839 205.763 106.839 206.044 106.632Z",
    fill: "url(#paint72_linear)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M209.484 169.053L210.891 168.226C210.961 168.157 211.102 168.226 211.102 168.364V170.017C211.102 170.155 211.032 170.293 210.891 170.293L209.484 171.12C209.414 171.189 209.273 171.12 209.273 170.982V169.397C209.273 169.259 209.344 169.122 209.484 169.053Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M212.299 167.468L213.705 166.641C213.776 166.572 213.916 166.641 213.916 166.779V168.433C213.916 168.57 213.846 168.708 213.705 168.708L212.299 169.535C212.229 169.604 212.088 169.535 212.088 169.397V167.813C212.088 167.675 212.158 167.537 212.299 167.468Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M215.183 165.815L216.589 164.988C216.66 164.919 216.8 164.988 216.8 165.126V166.779C216.8 166.917 216.73 167.055 216.589 167.055L215.183 167.881C215.112 167.95 214.972 167.881 214.972 167.744V166.159C214.972 166.021 215.042 165.883 215.183 165.815Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M217.997 164.23L219.404 163.403C219.474 163.334 219.615 163.403 219.615 163.541V165.194C219.615 165.332 219.544 165.47 219.404 165.47L217.997 166.297C217.927 166.366 217.786 166.297 217.786 166.159V164.574C217.856 164.437 217.927 164.299 217.997 164.23Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M227.211 159.063L228.618 158.236C228.688 158.167 228.828 158.236 228.828 158.374V160.027C228.828 160.165 228.758 160.303 228.618 160.303L227.211 161.13C227.141 161.198 227 161.13 227 160.992V159.407C227 159.269 227.07 159.132 227.211 159.063Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M230.025 157.409L231.432 156.582C231.502 156.514 231.643 156.582 231.643 156.72V158.374C231.643 158.512 231.573 158.649 231.432 158.649L230.025 159.476C229.955 159.545 229.814 159.476 229.814 159.338V157.754C229.814 157.616 229.885 157.478 230.025 157.409Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M209.484 173.118L210.891 172.291C210.961 172.222 211.102 172.291 211.102 172.429V174.082C211.102 174.22 211.032 174.358 210.891 174.358L209.484 175.185C209.414 175.254 209.273 175.185 209.273 175.047V173.462C209.273 173.256 209.344 173.187 209.484 173.118Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M212.299 171.464L213.705 170.637C213.776 170.569 213.916 170.637 213.916 170.775V172.429C213.916 172.567 213.846 172.704 213.705 172.704L212.299 173.531C212.229 173.6 212.088 173.531 212.088 173.393V171.809C212.088 171.671 212.158 171.533 212.299 171.464Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M215.183 169.879L216.589 169.053C216.66 168.984 216.8 169.053 216.8 169.19V170.844C216.8 170.982 216.73 171.119 216.589 171.119L215.183 171.946C215.112 172.015 214.972 171.946 214.972 171.808V170.224C214.972 170.086 215.042 169.948 215.183 169.879Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M217.997 168.226L219.404 167.399C219.474 167.33 219.615 167.399 219.615 167.537V169.19C219.615 169.328 219.544 169.466 219.404 169.466L217.997 170.293C217.927 170.362 217.786 170.293 217.786 170.155V168.57C217.856 168.433 217.927 168.295 217.997 168.226Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M227.211 163.059L228.618 162.232C228.688 162.163 228.828 162.232 228.828 162.37V164.023C228.828 164.161 228.758 164.299 228.618 164.299L227.211 165.126C227.141 165.195 227 165.126 227 164.988V163.403C227 163.265 227.07 163.128 227.211 163.059Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M230.025 161.474L231.432 160.647C231.502 160.578 231.643 160.647 231.643 160.785V162.439C231.643 162.576 231.573 162.714 231.432 162.714L230.025 163.541C229.955 163.61 229.814 163.541 229.814 163.403V161.819C229.814 161.681 229.885 161.543 230.025 161.474Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M201.679 168.777L200.272 167.95C200.202 167.881 200.062 167.95 200.062 168.088V169.741C200.062 169.879 200.132 170.017 200.272 170.017L201.679 170.844C201.749 170.913 201.89 170.844 201.89 170.706V169.121C201.82 168.984 201.749 168.846 201.679 168.777Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M198.797 167.192L197.391 166.365C197.32 166.296 197.18 166.365 197.18 166.503V168.157C197.18 168.294 197.25 168.432 197.391 168.432L198.797 169.259C198.868 169.328 199.008 169.259 199.008 169.121V167.537C199.008 167.33 198.938 167.261 198.797 167.192Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M195.916 165.539L194.51 164.712C194.439 164.643 194.299 164.712 194.299 164.85V166.503C194.299 166.641 194.369 166.779 194.51 166.779L195.916 167.606C195.987 167.675 196.127 167.606 196.127 167.468V165.883C196.127 165.745 196.057 165.608 195.916 165.539Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M193.103 163.954L191.696 163.127C191.626 163.058 191.485 163.127 191.485 163.265V164.919C191.485 165.056 191.556 165.194 191.696 165.194L193.103 166.021C193.173 166.09 193.314 166.021 193.314 165.883V164.299C193.314 164.161 193.244 164.023 193.103 163.954Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M183.959 158.718L182.553 157.891C182.482 157.822 182.342 157.891 182.342 158.029V159.683C182.342 159.82 182.412 159.958 182.553 159.958L183.959 160.785C184.03 160.854 184.17 160.785 184.17 160.647V159.062C184.17 158.925 184.1 158.787 183.959 158.718Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M181.077 157.133L179.671 156.307C179.601 156.238 179.46 156.307 179.46 156.444V158.098C179.46 158.236 179.53 158.374 179.671 158.374L181.077 159.2C181.148 159.269 181.288 159.2 181.288 159.062V157.478C181.288 157.34 181.218 157.202 181.077 157.133Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M201.679 172.773L200.272 171.946C200.202 171.877 200.062 171.946 200.062 172.084V173.737C200.062 173.875 200.132 174.013 200.272 174.013L201.679 174.84C201.749 174.909 201.89 174.84 201.89 174.702V173.117C201.82 172.979 201.749 172.842 201.679 172.773Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M198.797 171.188L197.391 170.361C197.32 170.293 197.18 170.361 197.18 170.499V172.153C197.18 172.291 197.25 172.428 197.391 172.428L198.797 173.255C198.868 173.324 199.008 173.255 199.008 173.117V171.533C199.008 171.395 198.938 171.257 198.797 171.188Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M195.916 169.604L194.51 168.777C194.439 168.708 194.299 168.777 194.299 168.915V170.568C194.299 170.706 194.369 170.844 194.51 170.844L195.916 171.67C195.987 171.739 196.127 171.67 196.127 171.533V169.948C196.127 169.741 196.057 169.672 195.916 169.604Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M193.103 167.95L191.696 167.123C191.626 167.054 191.485 167.123 191.485 167.261V168.915C191.485 169.052 191.556 169.19 191.696 169.19L193.103 170.017C193.173 170.086 193.314 170.017 193.314 169.879V168.294C193.314 168.157 193.244 168.019 193.103 167.95Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M183.96 162.783L182.554 161.956C182.483 161.887 182.343 161.956 182.343 162.094V163.747C182.343 163.885 182.413 164.023 182.554 164.023L183.96 164.85C184.031 164.919 184.171 164.85 184.171 164.712V163.127C184.171 162.99 184.101 162.852 183.96 162.783Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M181.076 161.198L179.67 160.371C179.6 160.303 179.459 160.371 179.459 160.509V162.163C179.459 162.301 179.529 162.438 179.67 162.438L181.076 163.265C181.147 163.334 181.287 163.265 181.287 163.127V161.543C181.287 161.405 181.217 161.267 181.076 161.198Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M163.384 211.362L200.305 190.486C201.149 190.004 201.149 188.833 200.305 188.351L163.384 167.475C162.189 166.786 160.641 166.786 159.446 167.475L122.525 188.351C121.681 188.833 121.681 190.004 122.525 190.486L159.446 211.362C160.712 212.051 162.189 212.051 163.384 211.362Z",
    stroke: "white",
    strokeWidth: 0.3726,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M195.875 189.591V188.282L193.484 188.558L193.132 188.971L163.173 172.022C162.118 171.402 160.782 171.402 159.727 172.022L129.979 188.833L129.698 188.42L126.955 188.282V189.591C126.955 189.935 127.166 190.349 127.518 190.555L159.727 208.744C160.782 209.364 162.118 209.364 163.173 208.744L195.383 190.555C195.664 190.349 195.875 190.004 195.875 189.591Z",
    fill: "url(#paint73_linear)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M163.103 207.435L195.312 189.246C196.015 188.833 196.015 187.8 195.312 187.386L163.103 169.198C162.048 168.578 160.712 168.578 159.657 169.198L127.447 187.386C126.744 187.8 126.744 188.833 127.447 189.246L159.657 207.435C160.782 208.055 162.048 208.055 163.103 207.435Z",
    fill: "url(#paint74_linear)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M191.232 188.557V176.225L189.123 176.431L188.841 176.776L162.891 162.101C161.977 161.55 160.851 161.55 159.937 162.101L134.268 176.638L134.057 176.293L131.666 176.225V188.557C131.666 188.902 131.807 189.177 132.158 189.384L160.008 205.092C160.922 205.643 162.047 205.643 162.961 205.092L190.81 189.384C191.092 189.177 191.232 188.833 191.232 188.557Z",
    fill: "url(#paint75_linear)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M162.891 192.691L190.74 176.982C191.373 176.638 191.373 175.742 190.74 175.398L162.891 159.689C161.977 159.138 160.851 159.138 159.937 159.689L132.088 175.329C131.455 175.673 131.455 176.569 132.088 176.914L159.937 192.622C160.851 193.242 161.977 193.242 162.891 192.691Z",
    fill: "url(#paint76_linear)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M190.74 188.282L162.891 203.99C161.977 204.541 160.851 204.541 159.937 203.99L132.088 188.282C131.807 188.075 131.596 187.799 131.596 187.455V188.488C131.596 188.833 131.736 189.108 132.088 189.315L159.937 205.092C160.851 205.644 161.977 205.644 162.891 205.092L190.74 189.384C191.092 189.177 191.232 188.902 191.232 188.557V187.524C191.232 187.799 191.021 188.075 190.74 188.282Z",
    fill: "url(#paint77_linear)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M189.12 175.467V170.093L187.151 170.3L186.87 170.644L162.748 157.003C161.904 156.52 160.849 156.52 160.005 157.003L136.094 170.506L135.883 170.162L133.703 170.093V175.467C133.703 175.742 133.844 176.087 134.125 176.225L160.005 190.831C160.849 191.313 161.904 191.313 162.748 190.831L188.628 176.225C188.98 176.087 189.12 175.811 189.12 175.467Z",
    fill: "url(#paint78_linear)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M137.992 176.914V174.985L158.809 186.697V188.695L137.992 176.914Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M136.869 176.363V174.365L134.618 173.124V175.054L136.869 176.363Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M184.83 176.914V174.985L164.084 186.697V188.695L184.83 176.914Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M185.955 176.363V174.365L188.276 173.124V175.054L185.955 176.363Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M162.82 185.526L188.7 170.92C189.263 170.575 189.263 169.749 188.7 169.404L162.82 154.729C161.976 154.247 160.921 154.247 160.077 154.729L134.197 169.404C133.635 169.749 133.635 170.575 134.197 170.92L160.077 185.526C160.921 186.008 161.976 186.008 162.82 185.526Z",
    fill: "url(#paint79_linear)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M191.232 169.335V168.233L189.123 168.439L188.841 168.784L162.891 154.109C161.977 153.558 160.851 153.558 159.937 154.109L134.268 168.646L134.057 168.302L131.666 168.233V169.335C131.666 169.679 131.807 169.955 132.158 170.162L160.008 185.87C160.922 186.421 162.047 186.421 162.961 185.87L190.81 170.162C191.092 169.955 191.232 169.679 191.232 169.335Z",
    fill: "url(#paint80_linear)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M162.891 184.768L190.74 169.06C191.373 168.715 191.373 167.819 190.74 167.475L162.891 151.767C161.977 151.215 160.851 151.215 159.937 151.767L132.088 167.406C131.455 167.75 131.455 168.646 132.088 168.991L159.937 184.699C160.851 185.319 161.977 185.319 162.891 184.768Z",
    fill: "url(#paint81_linear)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M189.12 167.751V162.377L187.151 162.583L186.87 162.928L162.748 149.286C161.904 148.804 160.849 148.804 160.005 149.286L136.094 162.79L135.883 162.446L133.703 162.377V167.751C133.703 168.026 133.844 168.371 134.125 168.508L160.005 183.114C160.849 183.597 161.904 183.597 162.748 183.114L188.628 168.508C188.98 168.302 189.12 168.026 189.12 167.751Z",
    fill: "url(#paint82_linear)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M137.992 169.128V167.13L158.809 178.912V180.841L137.992 169.128Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M136.869 168.509V166.511L134.618 165.27V167.268L136.869 168.509Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M184.83 169.129V167.131L164.084 178.912V180.841L184.83 169.129Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M185.955 168.509V166.511L188.276 165.27V167.268L185.955 168.509Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M162.82 177.741L188.7 163.135C189.263 162.79 189.263 161.963 188.7 161.619L162.82 147.013C161.976 146.531 160.921 146.531 160.077 147.013L134.197 161.619C133.635 161.963 133.635 162.79 134.197 163.135L160.077 177.741C160.921 178.223 161.976 178.223 162.82 177.741Z",
    fill: "url(#paint83_linear)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M191.232 161.55V160.448L189.123 160.654L188.841 160.999L162.891 146.324C161.977 145.773 160.851 145.773 159.937 146.324L134.268 160.861L134.057 160.516L131.666 160.448V161.55C131.666 161.894 131.807 162.17 132.158 162.377L159.937 178.154C160.851 178.705 161.977 178.705 162.891 178.154L190.74 162.446C191.092 162.17 191.232 161.894 191.232 161.55Z",
    fill: "url(#paint84_linear)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M162.891 176.983L190.74 161.274C191.373 160.93 191.373 160.034 190.74 159.69L162.891 143.981C161.977 143.43 160.851 143.43 159.937 143.981L132.088 159.621C131.455 159.965 131.455 160.861 132.088 161.205L159.937 176.914C160.851 177.534 161.977 177.534 162.891 176.983Z",
    fill: "url(#paint85_linear)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M189.12 159.965V154.591L187.151 154.798L186.87 155.142L162.748 141.501C161.904 141.018 160.849 141.018 160.005 141.501L136.094 155.004L135.883 154.66L133.703 154.591V159.965C133.703 160.24 133.844 160.585 134.125 160.723L160.005 175.329C160.849 175.811 161.904 175.811 162.748 175.329L188.628 160.723C188.98 160.516 189.12 160.24 189.12 159.965Z",
    fill: "url(#paint86_linear)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M137.992 161.343V159.345L158.809 171.057V173.055L137.992 161.343Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M136.869 160.723V158.725L134.618 157.485V159.483L136.869 160.723Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M184.83 161.343V159.345L164.084 171.058V173.056L184.83 161.343Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M185.955 160.723V158.725L188.276 157.485V159.483L185.955 160.723Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M162.82 169.955L188.7 155.349C189.263 155.005 189.263 154.178 188.7 153.833L162.82 139.227C161.976 138.745 160.921 138.745 160.077 139.227L134.197 153.833C133.635 154.178 133.635 155.005 134.197 155.349L160.077 169.955C160.921 170.437 161.976 170.437 162.82 169.955Z",
    fill: "url(#paint87_linear)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M191.232 153.765V152.662L189.123 152.869L188.841 153.213L162.891 138.539C161.977 137.987 160.851 137.987 159.937 138.539L134.268 153.076L134.057 152.731L131.666 152.662V153.765C131.666 154.109 131.807 154.385 132.158 154.591L160.008 170.3C160.922 170.851 162.047 170.851 162.961 170.3L190.81 154.591C191.092 154.385 191.232 154.109 191.232 153.765Z",
    fill: "url(#paint88_linear)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M162.891 169.197L190.74 153.489C191.373 153.145 191.373 152.249 190.74 151.904L162.891 136.127C161.977 135.576 160.851 135.576 159.937 136.127L132.088 151.836C131.455 152.18 131.455 153.076 132.088 153.42L159.937 169.197C160.851 169.749 161.977 169.749 162.891 169.197Z",
    fill: "url(#paint89_linear)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M189.12 152.18V146.806L187.151 147.013L186.87 147.357L162.748 133.716C161.904 133.234 160.849 133.234 160.005 133.716L136.094 147.22L135.883 146.875L133.703 146.806V152.18C133.703 152.456 133.844 152.8 134.125 152.938L160.005 167.544C160.849 168.026 161.904 168.026 162.748 167.544L188.628 152.938C188.98 152.731 189.12 152.456 189.12 152.18Z",
    fill: "url(#paint90_linear)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M162.82 162.17L188.7 147.564C189.263 147.219 189.263 146.393 188.7 146.048L162.82 131.442C161.976 130.96 160.921 130.96 160.077 131.442L134.197 146.048C133.635 146.393 133.635 147.219 134.197 147.564L160.077 162.17C160.921 162.652 161.976 162.652 162.82 162.17Z",
    fill: "url(#paint91_linear)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M137.992 153.489V151.56L158.809 163.272V165.27L137.992 153.489Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M136.869 152.938V150.94L134.618 149.7V151.629L136.869 152.938Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M184.83 153.489V151.56L164.084 163.272V165.27L184.83 153.489Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M185.955 152.938V150.94L188.276 149.7V151.629L185.955 152.938Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M191.232 145.979V144.877L189.123 145.084L188.841 145.428L162.891 130.753C161.977 130.202 160.851 130.202 159.937 130.753L134.268 145.29L134.057 144.946L131.666 144.877V145.979C131.666 146.324 131.807 146.599 132.158 146.806L160.008 162.583C160.922 163.134 162.047 163.134 162.961 162.583L190.81 146.875C191.092 146.668 191.232 146.324 191.232 145.979Z",
    fill: "url(#paint92_linear)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M162.891 161.412L190.74 145.704C191.373 145.359 191.373 144.463 190.74 144.119L162.891 128.411C161.977 127.859 160.851 127.859 159.937 128.411L132.088 144.05C131.455 144.395 131.455 145.29 132.088 145.635L159.937 161.343C160.851 161.963 161.977 161.963 162.891 161.412Z",
    fill: "url(#paint93_linear)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M189.12 144.119V129.169L187.151 129.375L186.87 129.72L162.748 116.078C161.904 115.596 160.849 115.596 160.005 116.078L136.094 129.582L135.883 129.238L133.703 129.169V144.119C133.703 144.395 133.844 144.739 134.125 144.877L160.005 159.483C160.849 159.965 161.904 159.965 162.748 159.483L188.628 144.877C188.98 144.67 189.12 144.395 189.12 144.119Z",
    fill: "url(#paint94_linear)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M162.82 144.601L188.7 129.995C189.263 129.651 189.263 128.824 188.7 128.48L162.82 113.874C161.976 113.391 160.921 113.391 160.077 113.874L134.197 128.48C133.635 128.824 133.635 129.651 134.197 129.995L160.077 144.601C160.921 145.084 161.976 145.084 162.82 144.601Z",
    fill: "url(#paint95_linear)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M162.676 143.155L186.165 129.858C186.728 129.582 186.728 128.824 186.165 128.48L162.676 115.183C161.902 114.769 160.918 114.769 160.144 115.183L136.655 128.48C136.093 128.755 136.093 129.513 136.655 129.858L160.144 143.155C160.918 143.637 161.902 143.637 162.676 143.155Z",
    stroke: "url(#paint96_linear)",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M188.697 143.843L162.817 158.45C161.973 158.932 160.918 158.932 160.074 158.45L134.194 143.843C133.913 143.706 133.772 143.361 133.772 143.086V144.05C133.772 144.326 133.913 144.67 134.194 144.808L160.074 159.414C160.918 159.896 161.973 159.896 162.817 159.414L188.697 144.808C188.979 144.67 189.119 144.326 189.119 144.05V143.086C189.119 143.43 188.979 143.706 188.697 143.843Z",
    fill: "url(#paint97_linear)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M165.352 147.426L166.758 146.599C166.828 146.531 166.969 146.599 166.969 146.737V148.391C166.969 148.529 166.899 148.666 166.758 148.666L165.352 149.493C165.281 149.562 165.141 149.493 165.141 149.355V147.771C165.141 147.633 165.211 147.495 165.352 147.426Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M168.166 145.773L169.573 144.946C169.643 144.877 169.784 144.946 169.784 145.084V146.737C169.784 146.875 169.713 147.013 169.573 147.013L168.166 147.84C168.096 147.909 167.955 147.84 167.955 147.702V146.117C167.955 145.979 168.025 145.842 168.166 145.773Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M171.047 144.188L172.453 143.361C172.524 143.292 172.664 143.361 172.664 143.499V145.152C172.664 145.29 172.594 145.428 172.453 145.428L171.047 146.255C170.977 146.324 170.836 146.255 170.836 146.117V144.532C170.836 144.395 170.906 144.257 171.047 144.188Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M173.861 142.603L175.268 141.776C175.338 141.707 175.479 141.776 175.479 141.914V143.568C175.479 143.705 175.409 143.843 175.268 143.843L173.861 144.67C173.791 144.739 173.65 144.67 173.65 144.532V142.948C173.721 142.81 173.791 142.672 173.861 142.603Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M183.076 137.367L184.483 136.54C184.553 136.471 184.694 136.54 184.694 136.678V138.332C184.694 138.469 184.623 138.607 184.483 138.607L183.076 139.434C183.006 139.503 182.865 139.434 182.865 139.296V137.711C182.865 137.574 182.936 137.436 183.076 137.367Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M185.891 135.782L187.297 134.956C187.368 134.887 187.508 134.956 187.508 135.093V136.747C187.508 136.885 187.438 137.023 187.297 137.023L185.891 137.849C185.82 137.918 185.68 137.849 185.68 137.711V136.127C185.68 135.989 185.75 135.851 185.891 135.782Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M165.352 151.422L166.758 150.595C166.828 150.526 166.969 150.595 166.969 150.733V152.386C166.969 152.524 166.899 152.662 166.758 152.662L165.352 153.489C165.281 153.557 165.141 153.489 165.141 153.351V151.766C165.141 151.628 165.211 151.491 165.352 151.422Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M168.166 149.837L169.573 149.01C169.643 148.941 169.784 149.01 169.784 149.148V150.802C169.784 150.939 169.713 151.077 169.573 151.077L168.166 151.904C168.096 151.973 167.955 151.904 167.955 151.766V150.182C167.955 150.044 168.025 149.906 168.166 149.837Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M171.047 148.184L172.453 147.357C172.524 147.288 172.664 147.357 172.664 147.495V149.148C172.664 149.286 172.594 149.424 172.453 149.424L171.047 150.251C170.977 150.32 170.836 150.251 170.836 150.113V148.528C170.836 148.391 170.906 148.253 171.047 148.184Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M173.861 146.599L175.268 145.772C175.338 145.704 175.479 145.772 175.479 145.91V147.564C175.479 147.702 175.409 147.839 175.268 147.839L173.861 148.666C173.791 148.735 173.65 148.666 173.65 148.528V146.944C173.721 146.806 173.791 146.668 173.861 146.599Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M183.076 141.432L184.483 140.605C184.553 140.536 184.694 140.605 184.694 140.743V142.396C184.694 142.534 184.623 142.672 184.483 142.672L183.076 143.499C183.006 143.568 182.865 143.499 182.865 143.361V141.776C182.865 141.639 182.936 141.501 183.076 141.432Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M185.891 139.847L187.297 139.02C187.368 138.952 187.508 139.02 187.508 139.158V140.812C187.508 140.95 187.438 141.087 187.297 141.087L185.891 141.914C185.82 141.983 185.68 141.914 185.68 141.776V140.192C185.68 139.985 185.75 139.916 185.891 139.847Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M157.542 147.426L156.136 146.599C156.065 146.53 155.925 146.599 155.925 146.737V148.391C155.925 148.528 155.995 148.666 156.136 148.666L157.542 149.493C157.613 149.562 157.753 149.493 157.753 149.355V147.77C157.683 147.633 157.613 147.495 157.542 147.426Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M154.661 145.773L153.255 144.946C153.185 144.877 153.044 144.946 153.044 145.084V146.737C153.044 146.875 153.114 147.013 153.255 147.013L154.661 147.839C154.732 147.908 154.872 147.839 154.872 147.702V146.117C154.872 145.979 154.802 145.842 154.661 145.773Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M151.777 144.188L150.37 143.361C150.3 143.292 150.159 143.361 150.159 143.499V145.153C150.159 145.29 150.23 145.428 150.37 145.428L151.777 146.255C151.847 146.324 151.988 146.255 151.988 146.117V144.532C151.988 144.395 151.917 144.257 151.777 144.188Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M148.965 142.603L147.559 141.776C147.488 141.708 147.348 141.776 147.348 141.914V143.568C147.348 143.706 147.418 143.843 147.559 143.843L148.965 144.67C149.035 144.739 149.176 144.67 149.176 144.532V142.948C149.176 142.81 149.106 142.672 148.965 142.603Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M139.818 137.367L138.411 136.54C138.341 136.472 138.2 136.54 138.2 136.678V138.332C138.2 138.47 138.271 138.607 138.411 138.607L139.818 139.434C139.888 139.503 140.029 139.434 140.029 139.296V137.712C140.029 137.574 139.958 137.436 139.818 137.367Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M136.939 135.783L135.532 134.956C135.462 134.887 135.321 134.956 135.321 135.094V136.747C135.321 136.885 135.392 137.023 135.532 137.023L136.939 137.849C137.009 137.918 137.15 137.849 137.15 137.712V136.127C137.15 135.989 137.079 135.851 136.939 135.783Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M157.542 151.422L156.136 150.595C156.065 150.526 155.925 150.595 155.925 150.733V152.387C155.925 152.524 155.995 152.662 156.136 152.662L157.542 153.489C157.613 153.558 157.753 153.489 157.753 153.351V151.766C157.683 151.629 157.613 151.491 157.542 151.422Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M154.661 149.837L153.255 149.011C153.185 148.942 153.044 149.011 153.044 149.148V150.802C153.044 150.94 153.114 151.078 153.255 151.078L154.661 151.904C154.732 151.973 154.872 151.904 154.872 151.766V150.182C154.872 150.044 154.802 149.906 154.661 149.837Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M151.777 148.184L150.37 147.357C150.3 147.288 150.159 147.357 150.159 147.495V149.149C150.159 149.286 150.23 149.424 150.37 149.424L151.777 150.251C151.847 150.32 151.988 150.251 151.988 150.113V148.528C151.988 148.391 151.917 148.253 151.777 148.184Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M148.965 146.599L147.559 145.773C147.488 145.704 147.348 145.773 147.348 145.91V147.564C147.348 147.702 147.418 147.839 147.559 147.839L148.965 148.666C149.035 148.735 149.176 148.666 149.176 148.528V146.944C149.176 146.806 149.106 146.668 148.965 146.599Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M139.821 141.432L138.414 140.605C138.344 140.536 138.203 140.605 138.203 140.743V142.397C138.203 142.534 138.273 142.672 138.414 142.672L139.821 143.499C139.891 143.568 140.032 143.499 140.032 143.361V141.776C140.032 141.639 139.961 141.501 139.821 141.432Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M136.939 139.847L135.532 139.021C135.462 138.952 135.321 139.021 135.321 139.158V140.812C135.321 140.95 135.392 141.088 135.532 141.088L136.939 141.914C137.009 141.983 137.15 141.914 137.15 141.776V140.192C137.15 139.985 137.079 139.916 136.939 139.847Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M182.865 128.617V127.859L181.388 127.997L181.177 128.273L162.541 117.732C161.908 117.387 161.064 117.387 160.431 117.732L141.935 128.204L141.794 127.928L140.106 127.859V128.686C140.106 128.893 140.247 129.168 140.458 129.306L160.501 140.605C161.134 140.95 161.978 140.95 162.611 140.605L182.654 129.306C182.724 129.1 182.865 128.893 182.865 128.617Z",
    fill: "url(#paint98_linear)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M162.468 139.779L182.511 128.48C182.933 128.204 182.933 127.584 182.511 127.308L162.468 116.009C161.835 115.665 160.991 115.665 160.358 116.009L140.315 127.308C139.894 127.584 139.894 128.204 140.315 128.48L160.358 139.779C160.991 140.123 161.835 140.123 162.468 139.779Z",
    fill: "url(#paint99_linear)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M162.399 138.676L180.613 128.411C181.035 128.204 181.035 127.584 180.613 127.377L162.399 117.112C161.766 116.767 161.062 116.767 160.5 117.112L142.285 127.377C141.863 127.584 141.863 128.204 142.285 128.411L160.5 138.676C161.062 139.021 161.766 139.021 162.399 138.676Z",
    stroke: "url(#paint100_linear)",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M171.543 127.24V126.344L170.84 126.413L170.769 126.551L161.908 121.521C161.627 121.315 161.205 121.315 160.924 121.521L152.203 126.482L152.133 126.344L151.289 126.275V127.171C151.289 127.309 151.359 127.377 151.43 127.446L160.924 132.82C161.205 133.027 161.627 133.027 161.908 132.82L171.402 127.446C171.543 127.515 171.543 127.377 171.543 127.24Z",
    fill: "url(#paint101_linear)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M161.908 131.993L171.402 126.62C171.613 126.482 171.613 126.206 171.402 126.068L161.908 120.694C161.627 120.488 161.205 120.488 160.924 120.694L151.43 126.068C151.219 126.206 151.219 126.482 151.43 126.62L160.924 131.993C161.205 132.2 161.627 132.2 161.908 131.993Z",
    fill: "url(#paint102_linear)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M165.356 194.414L166.762 193.587C166.832 193.518 166.973 193.587 166.973 193.725V195.378C166.973 195.516 166.903 195.654 166.762 195.654L165.356 196.481C165.285 196.55 165.145 196.481 165.145 196.343V194.758C165.145 194.62 165.215 194.483 165.356 194.414Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M168.17 192.829L169.576 192.002C169.647 191.933 169.787 192.002 169.787 192.14V193.794C169.787 193.931 169.717 194.069 169.576 194.069L168.17 194.896C168.1 194.965 167.959 194.896 167.959 194.758V193.173C167.959 193.036 168.029 192.898 168.17 192.829Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M171.051 191.175L172.457 190.349C172.528 190.28 172.668 190.348 172.668 190.486V192.14C172.668 192.278 172.598 192.415 172.457 192.415L171.051 193.242C170.98 193.311 170.84 193.242 170.84 193.104V191.52C170.84 191.382 170.91 191.244 171.051 191.175Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M173.865 189.591L175.272 188.764C175.342 188.695 175.483 188.764 175.483 188.902V190.555C175.483 190.693 175.412 190.831 175.272 190.831L173.865 191.658C173.795 191.726 173.654 191.658 173.654 191.52V189.935C173.725 189.797 173.795 189.66 173.865 189.591Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M183.075 184.424L184.482 183.597C184.552 183.528 184.693 183.597 184.693 183.735V185.388C184.693 185.526 184.622 185.664 184.482 185.664L183.075 186.491C183.005 186.56 182.864 186.491 182.864 186.353V184.768C182.864 184.63 182.935 184.493 183.075 184.424Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M185.89 182.77L187.296 181.943C187.367 181.874 187.507 181.943 187.507 182.081V183.735C187.507 183.872 187.437 184.01 187.296 184.01L185.89 184.837C185.819 184.906 185.679 184.837 185.679 184.699V183.115C185.679 182.977 185.749 182.839 185.89 182.77Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M165.356 198.479L166.762 197.652C166.832 197.583 166.973 197.652 166.973 197.79V199.443C166.973 199.581 166.903 199.719 166.762 199.719L165.356 200.546C165.285 200.614 165.145 200.545 165.145 200.408V198.823C165.145 198.616 165.215 198.548 165.356 198.479Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M168.17 196.825L169.576 195.998C169.647 195.929 169.787 195.998 169.787 196.136V197.789C169.787 197.927 169.717 198.065 169.576 198.065L168.17 198.892C168.1 198.961 167.959 198.892 167.959 198.754V197.169C167.959 197.032 168.029 196.894 168.17 196.825Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M171.051 195.24L172.457 194.413C172.528 194.345 172.668 194.413 172.668 194.551V196.205C172.668 196.343 172.598 196.48 172.457 196.48L171.051 197.307C170.98 197.376 170.84 197.307 170.84 197.169V195.585C170.84 195.447 170.91 195.309 171.051 195.24Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M173.865 193.587L175.272 192.76C175.342 192.691 175.483 192.76 175.483 192.898V194.551C175.483 194.689 175.412 194.827 175.272 194.827L173.865 195.654C173.795 195.723 173.654 195.654 173.654 195.516V193.931C173.725 193.793 173.795 193.656 173.865 193.587Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M183.075 188.419L184.482 187.593C184.552 187.524 184.693 187.593 184.693 187.73V189.384C184.693 189.522 184.622 189.66 184.482 189.66L183.075 190.486C183.005 190.555 182.864 190.486 182.864 190.349V188.764C182.864 188.626 182.935 188.488 183.075 188.419Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M185.89 186.835L187.296 186.008C187.367 185.939 187.507 186.008 187.507 186.146V187.799C187.507 187.937 187.437 188.075 187.296 188.075L185.89 188.902C185.819 188.971 185.679 188.902 185.679 188.764V187.179C185.679 187.042 185.749 186.904 185.89 186.835Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M157.542 194.138L156.136 193.311C156.065 193.242 155.925 193.311 155.925 193.449V195.102C155.925 195.24 155.995 195.378 156.136 195.378L157.542 196.205C157.613 196.274 157.753 196.205 157.753 196.067V194.482C157.683 194.344 157.613 194.207 157.542 194.138Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M154.661 192.553L153.255 191.726C153.185 191.657 153.044 191.726 153.044 191.864V193.518C153.044 193.655 153.114 193.793 153.255 193.793L154.661 194.62C154.732 194.689 154.872 194.62 154.872 194.482V192.897C154.872 192.691 154.802 192.622 154.661 192.553Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M151.778 190.9L150.371 190.073C150.301 190.004 150.16 190.073 150.16 190.211V191.864C150.16 192.002 150.23 192.14 150.371 192.14L151.778 192.966C151.848 193.035 151.989 192.966 151.989 192.829V191.244C151.989 191.106 151.918 190.968 151.778 190.9Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M148.965 189.315L147.559 188.488C147.488 188.419 147.348 188.488 147.348 188.626V190.28C147.348 190.417 147.418 190.555 147.559 190.555L148.965 191.382C149.035 191.451 149.176 191.382 149.176 191.244V189.659C149.176 189.522 149.106 189.384 148.965 189.315Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M139.822 184.079L138.415 183.252C138.345 183.183 138.204 183.252 138.204 183.39V185.043C138.204 185.181 138.274 185.319 138.415 185.319L139.822 186.146C139.892 186.215 140.033 186.146 140.033 186.008V184.423C140.033 184.286 139.962 184.148 139.822 184.079Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M136.942 182.494L135.535 181.668C135.465 181.599 135.324 181.668 135.324 181.805V183.459C135.324 183.597 135.395 183.734 135.535 183.734L136.942 184.561C137.012 184.63 137.153 184.561 137.153 184.423V182.839C137.153 182.701 137.082 182.563 136.942 182.494Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M157.542 198.134L156.136 197.307C156.065 197.238 155.925 197.307 155.925 197.445V199.098C155.925 199.236 155.995 199.374 156.136 199.374L157.542 200.201C157.613 200.27 157.753 200.201 157.753 200.063V198.478C157.683 198.34 157.613 198.203 157.542 198.134Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M154.661 196.549L153.255 195.722C153.185 195.653 153.044 195.722 153.044 195.86V197.514C153.044 197.651 153.114 197.789 153.255 197.789L154.661 198.616C154.732 198.685 154.872 198.616 154.872 198.478V196.894C154.872 196.756 154.802 196.618 154.661 196.549Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M151.778 194.964L150.371 194.138C150.301 194.069 150.16 194.138 150.16 194.275V195.929C150.16 196.067 150.23 196.205 150.371 196.205L151.778 197.031C151.848 197.1 151.989 197.031 151.989 196.894V195.309C151.989 195.102 151.918 195.033 151.778 194.964Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M148.965 193.311L147.559 192.484C147.488 192.415 147.348 192.484 147.348 192.622V194.275C147.348 194.413 147.418 194.551 147.559 194.551L148.965 195.378C149.035 195.447 149.176 195.378 149.176 195.24V193.655C149.176 193.518 149.106 193.38 148.965 193.311Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M139.821 188.144L138.414 187.317C138.344 187.248 138.203 187.317 138.203 187.455V189.108C138.203 189.246 138.273 189.384 138.414 189.384L139.821 190.211C139.891 190.28 140.032 190.211 140.032 190.073V188.488C140.032 188.351 139.961 188.213 139.821 188.144Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M136.939 186.559L135.532 185.732C135.462 185.663 135.321 185.732 135.321 185.87V187.524C135.321 187.661 135.392 187.799 135.532 187.799L136.939 188.626C137.009 188.695 137.15 188.626 137.15 188.488V186.904C137.15 186.766 137.079 186.628 136.939 186.559Z",
    fill: "white"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M118.755 236.723L155.676 215.847C156.52 215.365 156.52 214.194 155.676 213.711L118.755 192.836C117.56 192.147 116.012 192.147 114.817 192.836L77.8956 213.711C77.0517 214.194 77.0517 215.365 77.8956 215.847L114.817 236.723C116.083 237.412 117.56 237.412 118.755 236.723Z",
    stroke: "white",
    strokeWidth: 0.3726,
    strokeMiterlimit: 10
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M151.246 214.951V213.642L148.855 213.918L148.503 214.331L118.544 197.383C117.489 196.763 116.153 196.763 115.098 197.383L85.3502 214.194L85.0689 213.78L82.3262 213.642V214.951C82.3262 215.296 82.5372 215.709 82.8888 215.916L115.098 234.105C116.153 234.725 117.489 234.725 118.544 234.105L150.754 215.916C151.035 215.709 151.246 215.365 151.246 214.951Z",
    fill: "url(#paint103_linear)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M118.474 232.796L150.683 214.607C151.387 214.194 151.387 213.16 150.683 212.747L118.474 194.558C117.419 193.938 116.083 193.938 115.028 194.558L82.8185 212.747C82.1152 213.16 82.1152 214.194 82.8185 214.607L115.028 232.796C116.153 233.416 117.419 233.416 118.474 232.796Z",
    fill: "url(#paint104_linear)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M146.604 213.918V201.585L144.495 201.792L144.213 202.136L118.263 187.461C117.349 186.91 116.223 186.91 115.309 187.461L89.6402 201.999L89.4292 201.654L87.0381 201.585V213.918C87.0381 214.262 87.1787 214.538 87.5304 214.744L115.38 230.453C116.294 231.004 117.419 231.004 118.333 230.453L146.182 214.744C146.464 214.538 146.604 214.193 146.604 213.918Z",
    fill: "url(#paint105_linear)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M118.262 218.051L146.111 202.343C146.744 201.999 146.744 201.103 146.111 200.758L118.262 185.05C117.348 184.499 116.223 184.499 115.308 185.05L87.4591 200.69C86.8261 201.034 86.8261 201.93 87.4591 202.274L115.308 217.983C116.223 218.603 117.348 218.603 118.262 218.051Z",
    fill: "url(#paint106_linear)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M146.111 213.642L118.262 229.351C117.348 229.902 116.223 229.902 115.308 229.351L87.4591 213.642C87.1778 213.436 86.9668 213.16 86.9668 212.816V213.849C86.9668 214.194 87.1074 214.469 87.4591 214.676L115.308 230.453C116.223 231.004 117.348 231.004 118.262 230.453L146.111 214.745C146.463 214.538 146.603 214.263 146.603 213.918V212.885C146.603 213.16 146.392 213.436 146.111 213.642Z",
    fill: "url(#paint107_linear)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M144.498 200.828V195.454L142.529 195.66L142.248 196.005L118.126 182.363C117.282 181.881 116.227 181.881 115.383 182.363L91.4721 195.867L91.2612 195.523L89.0811 195.454V200.828C89.0811 201.103 89.2217 201.448 89.503 201.586L115.383 216.192C116.227 216.674 117.282 216.674 118.126 216.192L144.006 201.586C144.358 201.448 144.498 201.172 144.498 200.828Z",
    fill: "url(#paint108_linear)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3711 202.275V200.345L114.188 212.058V214.056L93.3711 202.275Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2465 201.723V199.725L89.9961 198.485V200.414L92.2465 201.723Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M140.207 202.275V200.345L119.461 212.058V214.056L140.207 202.275Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M141.332 201.723V199.725L143.653 198.485V200.414L141.332 201.723Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M118.195 210.886L144.075 196.28C144.638 195.936 144.638 195.109 144.075 194.765L118.195 180.09C117.351 179.608 116.296 179.608 115.452 180.09L89.5723 194.765C89.0097 195.109 89.0097 195.936 89.5723 196.28L115.452 210.886C116.296 211.369 117.351 211.369 118.195 210.886Z",
    fill: "url(#paint109_linear)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M146.604 194.696V193.594L144.495 193.8L144.213 194.145L118.263 179.47C117.349 178.919 116.223 178.919 115.309 179.47L89.6402 194.007L89.4292 193.662L87.0381 193.594V194.696C87.0381 195.04 87.1787 195.316 87.5304 195.523L115.38 211.231C116.294 211.782 117.419 211.782 118.333 211.231L146.182 195.523C146.464 195.316 146.604 195.04 146.604 194.696Z",
    fill: "url(#paint110_linear)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M118.262 210.129L146.111 194.42C146.744 194.076 146.744 193.18 146.111 192.836L118.262 177.127C117.348 176.576 116.223 176.576 115.308 177.127L87.4591 192.767C86.8261 193.111 86.8261 194.007 87.4591 194.351L115.308 210.06C116.223 210.68 117.348 210.68 118.262 210.129Z",
    fill: "url(#paint111_linear)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M144.498 193.111V187.737L142.529 187.944L142.248 188.288L118.126 174.647C117.282 174.165 116.227 174.165 115.383 174.647L91.4721 188.151L91.2612 187.806L89.0811 187.737V193.111C89.0811 193.387 89.2217 193.731 89.503 193.869L115.383 208.475C116.227 208.957 117.282 208.957 118.126 208.475L144.006 193.869C144.358 193.662 144.498 193.387 144.498 193.111Z",
    fill: "url(#paint112_linear)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3711 194.489V192.491L114.188 204.272V206.202L93.3711 194.489Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2465 193.869V191.871L89.9961 190.631V192.629L92.2465 193.869Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M140.207 194.489V192.491L119.461 204.272V206.201L140.207 194.489Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M141.332 193.869V191.871L143.653 190.631V192.629L141.332 193.869Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M118.195 203.101L144.075 188.495C144.638 188.151 144.638 187.324 144.075 186.979L118.195 172.373C117.351 171.891 116.296 171.891 115.452 172.373L89.5723 186.979C89.0097 187.324 89.0097 188.151 89.5723 188.495L115.452 203.101C116.296 203.583 117.351 203.583 118.195 203.101Z",
    fill: "url(#paint113_linear)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M146.604 186.911V185.808L144.495 186.015L144.213 186.359L118.263 171.685C117.349 171.133 116.223 171.133 115.309 171.685L89.6402 186.222L89.4292 185.877L87.0381 185.808V186.911C87.0381 187.255 87.1787 187.531 87.5304 187.737L115.309 203.515C116.223 204.066 117.349 204.066 118.263 203.515L146.112 187.806C146.464 187.531 146.604 187.255 146.604 186.911Z",
    fill: "url(#paint114_linear)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M118.262 202.343L146.111 186.635C146.744 186.291 146.744 185.395 146.111 185.05L118.262 169.342C117.348 168.791 116.223 168.791 115.308 169.342L87.4591 184.982C86.8261 185.326 86.8261 186.222 87.4591 186.566L115.308 202.275C116.223 202.895 117.348 202.895 118.262 202.343Z",
    fill: "url(#paint115_linear)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M144.498 185.326V179.952L142.529 180.159L142.248 180.503L118.126 166.862C117.282 166.379 116.227 166.379 115.383 166.862L91.4721 180.365L91.2612 180.021L89.0811 179.952V185.326C89.0811 185.602 89.2217 185.946 89.503 186.084L115.383 200.69C116.227 201.172 117.282 201.172 118.126 200.69L144.006 186.084C144.358 185.877 144.498 185.602 144.498 185.326Z",
    fill: "url(#paint116_linear)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3711 186.704V184.706L114.188 196.418V198.416L93.3711 186.704Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2465 186.084V184.086L89.9961 182.846V184.844L92.2465 186.084Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M140.207 186.704V184.706L119.461 196.418V198.416L140.207 186.704Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M141.332 186.084V184.086L143.653 182.846V184.844L141.332 186.084Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M118.195 195.316L144.075 180.71C144.638 180.365 144.638 179.538 144.075 179.194L118.195 164.588C117.351 164.106 116.296 164.106 115.452 164.588L89.5723 179.194C89.0097 179.538 89.0097 180.365 89.5723 180.71L115.452 195.316C116.296 195.798 117.351 195.798 118.195 195.316Z",
    fill: "url(#paint117_linear)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M146.604 179.125V178.023L144.495 178.229L144.213 178.574L118.263 163.899C117.349 163.348 116.223 163.348 115.309 163.899L89.6402 178.436L89.4292 178.092L87.0381 178.023V179.125C87.0381 179.47 87.1787 179.745 87.5304 179.952L115.38 195.66C116.294 196.211 117.419 196.211 118.333 195.66L146.182 179.952C146.464 179.745 146.604 179.47 146.604 179.125Z",
    fill: "url(#paint118_linear)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M118.262 194.558L146.111 178.85C146.744 178.505 146.744 177.61 146.111 177.265L118.262 161.488C117.348 160.937 116.223 160.937 115.308 161.488L87.4591 177.196C86.8261 177.541 86.8261 178.436 87.4591 178.781L115.308 194.558C116.223 195.109 117.348 195.109 118.262 194.558Z",
    fill: "url(#paint119_linear)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M144.498 177.541V172.167L142.529 172.373L142.248 172.718L118.126 159.076C117.282 158.594 116.227 158.594 115.383 159.076L91.4721 172.58L91.2612 172.236L89.0811 172.167V177.541C89.0811 177.816 89.2217 178.161 89.503 178.299L115.383 192.905C116.227 193.387 117.282 193.387 118.126 192.905L144.006 178.299C144.358 178.092 144.498 177.816 144.498 177.541Z",
    fill: "url(#paint120_linear)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M118.195 187.531L144.075 172.925C144.638 172.58 144.638 171.753 144.075 171.409L118.195 156.803C117.351 156.32 116.296 156.32 115.452 156.803L89.5723 171.409C89.0097 171.753 89.0097 172.58 89.5723 172.925L115.452 187.531C116.296 188.013 117.351 188.013 118.195 187.531Z",
    fill: "url(#paint121_linear)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3711 178.85V176.92L114.188 188.633V190.631L93.3711 178.85Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2465 178.298V176.3L89.9961 175.06V176.989L92.2465 178.298Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M140.207 178.85V176.92L119.461 188.633V190.631L140.207 178.85Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M141.332 178.298V176.3L143.653 175.06V176.989L141.332 178.298Z",
    stroke: "white",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M146.604 171.34V170.238L144.495 170.444L144.213 170.789L118.263 156.114C117.349 155.563 116.223 155.563 115.309 156.114L89.6402 170.651L89.4292 170.306L87.0381 170.238V171.34C87.0381 171.684 87.1787 171.96 87.5304 172.167L115.38 187.944C116.294 188.495 117.419 188.495 118.333 187.944L146.182 172.236C146.464 172.029 146.604 171.684 146.604 171.34Z",
    fill: "url(#paint122_linear)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M118.262 186.773L146.111 171.064C146.744 170.72 146.744 169.824 146.111 169.48L118.262 153.771C117.348 153.22 116.223 153.22 115.308 153.771L87.4591 169.411C86.8261 169.755 86.8261 170.651 87.4591 170.995L115.308 186.704C116.223 187.324 117.348 187.324 118.262 186.773Z",
    fill: "url(#paint123_linear)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M144.493 169.48V154.529L142.524 154.736L142.243 155.08L118.121 141.439C117.277 140.957 116.222 140.957 115.378 141.439L91.4673 154.943L91.2563 154.598L89.0762 154.529V169.48C89.0762 169.755 89.2168 170.1 89.4981 170.238L115.378 184.844C116.222 185.326 117.277 185.326 118.121 184.844L144.001 170.238C144.353 170.031 144.493 169.755 144.493 169.48Z",
    fill: "url(#paint124_linear)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M118.193 169.962L144.073 155.356C144.636 155.012 144.636 154.185 144.073 153.84L118.193 139.234C117.349 138.752 116.294 138.752 115.45 139.234L89.5704 153.84C89.0078 154.185 89.0078 155.012 89.5704 155.356L115.45 169.962C116.294 170.444 117.349 170.444 118.193 169.962Z",
    fill: "url(#paint125_linear)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M118.049 168.515L141.538 155.218C142.101 154.943 142.101 154.185 141.538 153.84L118.049 140.543C117.276 140.13 116.291 140.13 115.517 140.543L92.0284 153.84C91.4658 154.116 91.4658 154.874 92.0284 155.218L115.517 168.515C116.291 168.998 117.276 168.998 118.049 168.515Z",
    stroke: "url(#paint126_linear)",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M144.07 169.204L118.19 183.81C117.346 184.293 116.291 184.293 115.448 183.81L89.5675 169.204C89.2862 169.066 89.1455 168.722 89.1455 168.446V169.411C89.1455 169.687 89.2862 170.031 89.5675 170.169L115.448 184.775C116.291 185.257 117.346 185.257 118.19 184.775L144.07 170.169C144.352 170.031 144.492 169.687 144.492 169.411V168.446C144.492 168.791 144.352 169.066 144.07 169.204Z",
    fill: "url(#paint127_linear)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M120.725 172.787L122.131 171.96C122.202 171.891 122.342 171.96 122.342 172.098V173.751C122.342 173.889 122.272 174.027 122.131 174.027L120.725 174.854C120.654 174.923 120.514 174.854 120.514 174.716V173.131C120.514 172.993 120.584 172.856 120.725 172.787Z",
    fill: "white"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M123.539 171.133L124.946 170.307C125.016 170.238 125.157 170.307 125.157 170.444V172.098C125.157 172.236 125.086 172.373 124.946 172.373L123.539 173.2C123.469 173.269 123.328 173.2 123.328 173.062V171.478C123.328 171.34 123.398 171.202 123.539 171.133Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M126.42 169.549L127.826 168.722C127.897 168.653 128.037 168.722 128.037 168.86V170.513C128.037 170.651 127.967 170.789 127.826 170.789L126.42 171.615C126.35 171.684 126.209 171.615 126.209 171.478V169.893C126.209 169.755 126.279 169.617 126.42 169.549Z",
    fill: "white"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M129.234 167.964L130.641 167.137C130.711 167.068 130.852 167.137 130.852 167.275V168.928C130.852 169.066 130.782 169.204 130.641 169.204L129.234 170.031C129.164 170.1 129.023 170.031 129.023 169.893V168.308C129.094 168.171 129.164 168.033 129.234 167.964Z",
    fill: "white"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M138.445 162.728L139.852 161.901C139.922 161.832 140.063 161.901 140.063 162.039V163.692C140.063 163.83 139.993 163.968 139.852 163.968L138.445 164.795C138.375 164.863 138.234 164.795 138.234 164.657V163.072C138.234 162.934 138.305 162.797 138.445 162.728Z",
    fill: "white"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M141.26 161.143L142.666 160.316C142.737 160.247 142.877 160.316 142.877 160.454V162.108C142.877 162.245 142.807 162.383 142.666 162.383L141.26 163.21C141.189 163.279 141.049 163.21 141.049 163.072V161.488C141.049 161.35 141.119 161.212 141.26 161.143Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M120.725 176.783L122.131 175.956C122.202 175.887 122.342 175.956 122.342 176.094V177.747C122.342 177.885 122.272 178.023 122.131 178.023L120.725 178.849C120.654 178.918 120.514 178.849 120.514 178.712V177.127C120.514 176.989 120.584 176.851 120.725 176.783Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M123.539 175.198L124.946 174.371C125.016 174.302 125.157 174.371 125.157 174.509V176.162C125.157 176.3 125.086 176.438 124.946 176.438L123.539 177.265C123.469 177.334 123.328 177.265 123.328 177.127V175.542C123.328 175.405 123.398 175.267 123.539 175.198Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M126.42 173.544L127.826 172.718C127.897 172.649 128.037 172.718 128.037 172.855V174.509C128.037 174.647 127.967 174.785 127.826 174.785L126.42 175.611C126.35 175.68 126.209 175.611 126.209 175.474V173.889C126.209 173.751 126.279 173.613 126.42 173.544Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M129.234 171.96L130.641 171.133C130.711 171.064 130.852 171.133 130.852 171.271V172.924C130.852 173.062 130.782 173.2 130.641 173.2L129.234 174.027C129.164 174.096 129.023 174.027 129.023 173.889V172.304C129.094 172.167 129.164 172.029 129.234 171.96Z",
    fill: "white"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M138.445 166.793L139.852 165.966C139.922 165.897 140.063 165.966 140.063 166.104V167.757C140.063 167.895 139.993 168.033 139.852 168.033L138.445 168.86C138.375 168.928 138.234 168.86 138.234 168.722V167.137C138.234 166.999 138.305 166.862 138.445 166.793Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M141.26 165.208L142.666 164.381C142.737 164.312 142.877 164.381 142.877 164.519V166.173C142.877 166.31 142.807 166.448 142.666 166.448L141.26 167.275C141.189 167.344 141.049 167.275 141.049 167.137V165.553C141.049 165.346 141.119 165.277 141.26 165.208Z",
    fill: "white"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M112.918 172.787L111.512 171.96C111.441 171.891 111.301 171.96 111.301 172.098V173.752C111.301 173.889 111.371 174.027 111.512 174.027L112.918 174.854C112.989 174.923 113.129 174.854 113.129 174.716V173.131C113.059 172.994 112.989 172.856 112.918 172.787Z",
    fill: "white"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M110.034 171.133L108.627 170.307C108.557 170.238 108.416 170.307 108.416 170.444V172.098C108.416 172.236 108.486 172.374 108.627 172.374L110.034 173.2C110.104 173.269 110.244 173.2 110.244 173.063V171.478C110.244 171.34 110.174 171.202 110.034 171.133Z",
    fill: "white"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M107.15 169.549L105.743 168.722C105.673 168.653 105.532 168.722 105.532 168.86V170.513C105.532 170.651 105.603 170.789 105.743 170.789L107.15 171.616C107.22 171.684 107.361 171.616 107.361 171.478V169.893C107.361 169.755 107.29 169.618 107.15 169.549Z",
    fill: "white"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M104.337 167.964L102.931 167.137C102.86 167.068 102.72 167.137 102.72 167.275V168.929C102.72 169.066 102.79 169.204 102.931 169.204L104.337 170.031C104.408 170.1 104.548 170.031 104.548 169.893V168.308C104.548 168.171 104.478 168.033 104.337 167.964Z",
    fill: "white"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1947 162.728L93.7881 161.901C93.7178 161.832 93.5771 161.901 93.5771 162.039V163.693C93.5771 163.83 93.6475 163.968 93.7881 163.968L95.1947 164.795C95.265 164.864 95.4056 164.795 95.4056 164.657V163.072C95.4056 162.935 95.3353 162.797 95.1947 162.728Z",
    fill: "white"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3109 161.143L90.9043 160.317C90.834 160.248 90.6934 160.317 90.6934 160.454V162.108C90.6934 162.246 90.7637 162.383 90.9043 162.383L92.3109 163.21C92.3812 163.279 92.5218 163.21 92.5218 163.072V161.488C92.5218 161.35 92.4515 161.212 92.3109 161.143Z",
    fill: "white"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M112.918 176.783L111.512 175.956C111.441 175.887 111.301 175.956 111.301 176.094V177.747C111.301 177.885 111.371 178.023 111.512 178.023L112.918 178.85C112.989 178.919 113.129 178.85 113.129 178.712V177.127C113.059 176.989 112.989 176.852 112.918 176.783Z",
    fill: "white"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M110.034 175.198L108.627 174.371C108.557 174.302 108.416 174.371 108.416 174.509V176.163C108.416 176.3 108.486 176.438 108.627 176.438L110.034 177.265C110.104 177.334 110.244 177.265 110.244 177.127V175.543C110.244 175.405 110.174 175.267 110.034 175.198Z",
    fill: "white"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M107.15 173.545L105.743 172.718C105.673 172.649 105.532 172.718 105.532 172.856V174.509C105.532 174.647 105.603 174.785 105.743 174.785L107.15 175.612C107.22 175.68 107.361 175.612 107.361 175.474V173.889C107.361 173.751 107.29 173.614 107.15 173.545Z",
    fill: "white"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M104.337 171.96L102.931 171.133C102.86 171.064 102.72 171.133 102.72 171.271V172.925C102.72 173.062 102.79 173.2 102.931 173.2L104.337 174.027C104.408 174.096 104.548 174.027 104.548 173.889V172.305C104.548 172.167 104.478 172.029 104.337 171.96Z",
    fill: "white"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1947 166.793L93.7881 165.966C93.7178 165.897 93.5771 165.966 93.5771 166.104V167.757C93.5771 167.895 93.6475 168.033 93.7881 168.033L95.1947 168.86C95.265 168.928 95.4056 168.86 95.4056 168.722V167.137C95.4056 166.999 95.3353 166.862 95.1947 166.793Z",
    fill: "white"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3109 165.208L90.9043 164.381C90.834 164.313 90.6934 164.381 90.6934 164.519V166.173C90.6934 166.31 90.7637 166.448 90.9043 166.448L92.3109 167.275C92.3812 167.344 92.5218 167.275 92.5218 167.137V165.553C92.5218 165.346 92.4515 165.277 92.3109 165.208Z",
    fill: "white"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M138.232 153.978V153.22L136.755 153.358L136.544 153.633L117.908 143.092C117.275 142.748 116.431 142.748 115.798 143.092L97.3021 153.565L97.1615 153.289L95.4736 153.22V154.047C95.4736 154.253 95.6143 154.529 95.8253 154.667L115.868 165.966C116.501 166.31 117.345 166.31 117.978 165.966L138.021 154.667C138.091 154.46 138.232 154.254 138.232 153.978Z",
    fill: "url(#paint128_linear)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M117.839 165.139L137.882 153.84C138.304 153.565 138.304 152.945 137.882 152.669L117.839 141.37C117.206 141.026 116.363 141.026 115.73 141.37L95.6866 152.669C95.2646 152.945 95.2646 153.565 95.6866 153.84L115.73 165.139C116.363 165.484 117.206 165.484 117.839 165.139Z",
    fill: "url(#paint129_linear)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M117.769 164.037L135.983 153.771C136.405 153.565 136.405 152.944 135.983 152.738L117.769 142.472C117.136 142.128 116.432 142.128 115.87 142.472L97.6553 152.738C97.2334 152.944 97.2334 153.565 97.6553 153.771L115.87 164.037C116.432 164.381 117.136 164.381 117.769 164.037Z",
    stroke: "url(#paint130_linear)",
    strokeWidth: 0.1863,
    strokeMiterlimit: 10
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M126.914 152.6V151.705L126.211 151.774L126.141 151.912L117.279 146.882C116.998 146.675 116.576 146.675 116.295 146.882L107.574 151.843L107.504 151.705L106.66 151.636V152.532C106.66 152.669 106.73 152.738 106.801 152.807L116.295 158.181C116.576 158.388 116.998 158.388 117.279 158.181L126.773 152.807C126.914 152.876 126.914 152.738 126.914 152.6Z",
    fill: "url(#paint131_linear)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M117.279 157.354L126.773 151.98C126.984 151.842 126.984 151.567 126.773 151.429L117.279 146.055C116.998 145.848 116.576 145.848 116.295 146.055L106.801 151.429C106.59 151.567 106.59 151.842 106.801 151.98L116.295 157.354C116.576 157.561 116.998 157.561 117.279 157.354Z",
    fill: "url(#paint132_linear)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M120.724 219.774L122.13 218.948C122.201 218.879 122.341 218.948 122.341 219.085V220.739C122.341 220.877 122.271 221.015 122.13 221.015L120.724 221.841C120.653 221.91 120.513 221.841 120.513 221.703V220.119C120.513 219.981 120.583 219.843 120.724 219.774Z",
    fill: "white"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M123.538 218.19L124.945 217.363C125.015 217.294 125.156 217.363 125.156 217.501V219.154C125.156 219.292 125.085 219.43 124.945 219.43L123.538 220.256C123.468 220.325 123.327 220.256 123.327 220.119V218.534C123.327 218.396 123.397 218.258 123.538 218.19Z",
    fill: "white"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M126.419 216.536L127.826 215.709C127.896 215.64 128.036 215.709 128.036 215.847V217.5C128.036 217.638 127.966 217.776 127.826 217.776L126.419 218.603C126.349 218.672 126.208 218.603 126.208 218.465V216.88C126.208 216.743 126.278 216.605 126.419 216.536Z",
    fill: "white"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M129.233 214.951L130.64 214.125C130.71 214.056 130.851 214.125 130.851 214.262V215.916C130.851 216.054 130.781 216.191 130.64 216.191L129.233 217.018C129.163 217.087 129.022 217.018 129.022 216.88V215.296C129.093 215.158 129.163 215.02 129.233 214.951Z",
    fill: "white"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M138.444 209.784L139.851 208.957C139.921 208.889 140.062 208.957 140.062 209.095V210.749C140.062 210.887 139.992 211.024 139.851 211.024L138.444 211.851C138.374 211.92 138.233 211.851 138.233 211.713V210.129C138.233 209.991 138.304 209.853 138.444 209.784Z",
    fill: "white"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M141.259 208.131L142.665 207.304C142.736 207.235 142.876 207.304 142.876 207.442V209.095C142.876 209.233 142.806 209.371 142.665 209.371L141.259 210.198C141.189 210.267 141.048 210.198 141.048 210.06V208.475C141.048 208.337 141.118 208.2 141.259 208.131Z",
    fill: "white"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M120.724 223.839L122.13 223.012C122.201 222.943 122.341 223.012 122.341 223.15V224.804C122.341 224.941 122.271 225.079 122.13 225.079L120.724 225.906C120.653 225.975 120.513 225.906 120.513 225.768V224.183C120.513 223.977 120.583 223.908 120.724 223.839Z",
    fill: "white"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M123.538 222.186L124.945 221.359C125.015 221.29 125.156 221.359 125.156 221.497V223.15C125.156 223.288 125.085 223.426 124.945 223.426L123.538 224.252C123.468 224.321 123.327 224.252 123.327 224.115V222.53C123.327 222.392 123.397 222.254 123.538 222.186Z",
    fill: "white"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M126.419 220.601L127.826 219.774C127.896 219.706 128.036 219.774 128.036 219.912V221.566C128.036 221.704 127.966 221.841 127.826 221.841L126.419 222.668C126.349 222.737 126.208 222.668 126.208 222.53V220.946C126.208 220.808 126.278 220.67 126.419 220.601Z",
    fill: "white"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M129.233 218.947L130.64 218.121C130.71 218.052 130.851 218.121 130.851 218.259V219.912C130.851 220.05 130.781 220.188 130.64 220.188L129.233 221.014C129.163 221.083 129.022 221.014 129.022 220.877V219.292C129.093 219.154 129.163 219.016 129.233 218.947Z",
    fill: "white"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M138.444 213.78L139.851 212.954C139.921 212.885 140.062 212.954 140.062 213.091V214.745C140.062 214.883 139.992 215.02 139.851 215.02L138.444 215.847C138.374 215.916 138.233 215.847 138.233 215.709V214.125C138.233 213.987 138.304 213.849 138.444 213.78Z",
    fill: "white"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M141.259 212.196L142.665 211.369C142.736 211.3 142.876 211.369 142.876 211.507V213.16C142.876 213.298 142.806 213.436 142.665 213.436L141.259 214.263C141.189 214.331 141.048 214.263 141.048 214.125V212.54C141.048 212.402 141.118 212.265 141.259 212.196Z",
    fill: "white"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M112.917 219.499L111.511 218.672C111.44 218.603 111.3 218.672 111.3 218.81V220.463C111.3 220.601 111.37 220.739 111.511 220.739L112.917 221.565C112.988 221.634 113.128 221.565 113.128 221.428V219.843C113.058 219.705 112.988 219.567 112.917 219.499Z",
    fill: "white"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M110.032 217.914L108.625 217.087C108.555 217.018 108.414 217.087 108.414 217.225V218.878C108.414 219.016 108.484 219.154 108.625 219.154L110.032 219.981C110.102 220.05 110.243 219.981 110.243 219.843V218.258C110.243 218.052 110.172 217.983 110.032 217.914Z",
    fill: "white"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M107.151 216.26L105.744 215.434C105.674 215.365 105.533 215.434 105.533 215.572V217.225C105.533 217.363 105.604 217.501 105.744 217.501L107.151 218.327C107.221 218.396 107.362 218.327 107.362 218.19V216.605C107.362 216.467 107.291 216.329 107.151 216.26Z",
    fill: "white"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M104.337 214.676L102.931 213.849C102.86 213.78 102.72 213.849 102.72 213.987V215.64C102.72 215.778 102.79 215.916 102.931 215.916L104.337 216.743C104.408 216.812 104.548 216.743 104.548 216.605V215.02C104.548 214.883 104.478 214.745 104.337 214.676Z",
    fill: "white"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1956 209.44L93.7891 208.613C93.7188 208.544 93.5781 208.613 93.5781 208.751V210.404C93.5781 210.542 93.6485 210.68 93.7891 210.68L95.1956 211.507C95.266 211.576 95.4066 211.507 95.4066 211.369V209.784C95.4066 209.647 95.3363 209.509 95.1956 209.44Z",
    fill: "white"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3109 207.855L90.9043 207.028C90.834 206.959 90.6934 207.028 90.6934 207.166V208.82C90.6934 208.957 90.7637 209.095 90.9043 209.095L92.3109 209.922C92.3812 209.991 92.5218 209.922 92.5218 209.784V208.2C92.5218 208.062 92.4515 207.924 92.3109 207.855Z",
    fill: "white"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M112.917 223.495L111.511 222.668C111.44 222.599 111.3 222.668 111.3 222.806V224.459C111.3 224.597 111.37 224.735 111.511 224.735L112.917 225.562C112.988 225.631 113.128 225.562 113.128 225.424V223.839C113.058 223.701 112.988 223.564 112.917 223.495Z",
    fill: "white"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M110.032 221.91L108.625 221.083C108.555 221.014 108.414 221.083 108.414 221.221V222.874C108.414 223.012 108.484 223.15 108.625 223.15L110.032 223.977C110.102 224.046 110.243 223.977 110.243 223.839V222.254C110.243 222.117 110.172 221.979 110.032 221.91Z",
    fill: "white"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M107.151 220.325L105.744 219.498C105.674 219.43 105.533 219.498 105.533 219.636V221.29C105.533 221.428 105.604 221.565 105.744 221.565L107.151 222.392C107.221 222.461 107.362 222.392 107.362 222.254V220.67C107.362 220.463 107.291 220.394 107.151 220.325Z",
    fill: "white"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M104.337 218.672L102.931 217.845C102.86 217.776 102.72 217.845 102.72 217.983V219.636C102.72 219.774 102.79 219.912 102.931 219.912L104.337 220.739C104.408 220.807 104.548 220.739 104.548 220.601V219.016C104.548 218.878 104.478 218.741 104.337 218.672Z",
    fill: "white"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1956 213.505L93.7891 212.678C93.7188 212.609 93.5781 212.678 93.5781 212.816V214.469C93.5781 214.607 93.6485 214.745 93.7891 214.745L95.1956 215.572C95.266 215.641 95.4066 215.572 95.4066 215.434V213.849C95.4066 213.711 95.3363 213.574 95.1956 213.505Z",
    fill: "white"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3109 211.92L90.9043 211.093C90.834 211.024 90.6934 211.093 90.6934 211.231V212.885C90.6934 213.022 90.7637 213.16 90.9043 213.16L92.3109 213.987C92.3812 214.056 92.5218 213.987 92.5218 213.849V212.264C92.5218 212.127 92.4515 211.989 92.3109 211.92Z",
    fill: "white"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5882 255.81L26.3294 219.769C21.8823 217.3 18.4235 213.351 15.9529 208.167C13.4823 202.983 12 196.318 12 188.418C12 176.816 14.9647 164.226 20.4 152.131C25.5882 140.035 33 128.679 41.8941 119.299C47.8235 113.128 54.247 107.697 60.9176 103.994C63.8823 102.266 66.847 100.785 69.8117 99.7974L132.071 135.591C129.106 136.579 126.141 138.06 123.176 139.788C116.506 143.738 110.082 148.921 104.153 155.093C95.2588 164.473 87.847 175.829 82.6588 187.925C77.4705 200.02 74.2588 212.61 74.2588 224.212C74.2588 231.865 75.7411 238.53 78.2117 243.961C80.6823 249.391 84.1411 253.341 88.5882 255.81Z",
    fill: "url(#paint133_linear)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M217.551 25.7404L279.81 61.7812C278.822 61.2875 277.833 60.7938 276.845 60.5469C270.669 58.3252 262.516 59.3127 253.869 64.4966C250.657 66.2246 247.445 68.6931 244.48 71.1617L182.222 35.1209C185.186 32.4055 188.398 30.1838 191.61 28.4558C200.257 23.5187 208.41 22.2844 214.586 24.5061C215.822 24.753 216.81 25.2467 217.551 25.7404Z",
    fill: "url(#paint134_linear)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M244.729 71.1621L182.471 35.1213C185.435 32.4059 188.647 30.1842 191.859 28.4562C192.6 27.9625 193.588 27.4688 194.33 27.2219L256.588 63.2627C255.847 63.7564 254.859 64.0033 254.118 64.497C250.906 66.225 247.694 68.4467 244.729 71.1621Z",
    fill: "url(#paint135_linear)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M256.34 63.0159L194.328 26.9751C201.987 23.0254 209.152 22.2848 214.834 24.5065C215.822 24.7534 216.81 25.2471 217.799 25.7408L280.057 61.7816C279.069 61.2879 278.081 60.7942 277.093 60.5473C271.163 58.5725 264.246 59.313 256.34 63.0159Z",
    fill: "url(#paint136_linear)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M166.164 3.77104L228.423 39.8119C225.706 38.3307 222.988 37.0965 219.776 36.6027C210.635 34.8748 199.764 37.0964 188.153 43.7615C180.247 48.2049 172.835 54.3763 166.164 61.5351C156.035 72.3967 147.388 85.48 141.459 99.3039C136.27 111.153 132.811 123.743 132.07 135.592L69.8115 99.5507C70.5527 87.7017 74.0115 75.1121 79.1998 63.2631C85.3762 49.4392 93.7762 36.109 103.906 25.4943C110.576 18.3355 117.988 12.1641 125.894 7.72072C137.506 1.05564 148.623 -1.16605 157.517 0.56193C160.729 1.05564 163.694 2.04306 166.164 3.77104Z",
    fill: "url(#paint137_linear)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M249.917 36.1089L312.176 72.1497C310.446 71.1623 308.717 70.4217 306.74 70.1748C301.552 69.1874 295.376 70.1748 288.705 73.3839L226.446 37.3431C233.117 34.134 239.293 32.8997 244.482 34.134C246.458 34.6277 248.435 35.1214 249.917 36.1089Z",
    fill: "url(#paint138_linear)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M288.705 73.6308L226.446 37.59L288.705 73.6308Z",
    fill: "url(#paint139_linear)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M288.705 73.6299L226.446 37.5891C233.117 34.38 239.046 33.3926 244.235 34.38C246.211 34.8737 248.187 35.3674 249.67 36.3548L311.929 72.3956C310.199 71.4082 308.47 70.6677 306.493 70.4208C301.552 69.1865 295.376 70.174 288.705 73.6299Z",
    fill: "url(#paint140_linear)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M319.835 81.0367C321.564 84.9863 322.8 89.9234 322.8 95.6011C322.8 104.241 320.576 113.622 316.623 122.508C312.67 131.395 307.235 139.788 300.812 146.947C296.365 151.637 291.67 155.587 286.729 158.302L123.423 252.354C113.294 258.278 103.906 260.006 96 258.525C88.0941 257.044 81.9176 251.86 78.2117 243.961C75.7411 238.777 74.2588 232.112 74.2588 224.213C74.2588 212.61 77.2235 200.021 82.6588 187.925C87.847 175.829 95.2588 164.474 104.153 155.093C110.082 148.922 116.506 143.491 123.176 139.788C126.141 138.06 129.106 136.579 132.071 135.592C132.812 123.743 136.271 111.153 141.459 99.3039C147.635 85.48 156.035 72.1499 166.165 61.5351C172.835 54.3763 180.247 48.2049 188.153 43.7616C199.765 37.0965 210.882 34.8748 219.776 36.6028C228.917 38.3307 236.082 44.2553 240.282 53.3889C242.506 58.326 244.235 64.2505 244.729 71.1625C247.694 68.447 250.906 66.2254 254.117 64.4974C262.765 59.5603 270.917 58.326 277.094 60.5477C282.529 62.5225 286.729 66.9659 288.953 73.631C295.623 70.4219 301.8 69.1876 306.988 70.4219C312.423 71.4093 317.117 75.1121 319.835 81.0367ZM312.67 114.115C314.153 109.425 314.894 104.735 314.894 100.291C314.894 93.6263 313.164 88.4423 309.953 84.9863C306.988 81.5304 302.541 80.0492 297.6 80.2961C294.141 80.5429 290.435 81.7772 286.482 83.9989C286.235 83.9989 285.988 84.2458 285.741 84.4926C283.765 85.7269 282.035 84.9863 281.788 83.2583C280.306 76.8401 276.847 72.3967 271.906 70.6687C266.965 68.9408 260.788 69.6813 254.117 73.631C249.917 76.0995 246.212 79.3087 242.506 83.0115C242.012 83.5052 241.517 83.9989 240.776 84.2458C240.035 84.7395 239.294 84.9863 238.553 84.7395C237.318 84.4926 236.823 83.5052 236.823 81.7772C236.823 81.2835 236.823 80.7898 236.823 80.5429C236.823 68.9408 233.612 60.054 228.423 54.1295C223.235 48.2049 215.823 45.4895 206.929 46.2301C201 46.7238 194.823 48.9455 188.153 52.6483C178.023 58.5729 168.882 67.2128 160.976 77.8275C153.318 88.1954 147.141 100.291 143.435 112.387C140.965 120.533 139.729 128.68 139.729 136.332C139.729 138.06 139.235 139.788 138.247 141.269C137.506 142.257 136.765 142.997 135.776 143.491C135.282 143.738 135.035 143.985 134.541 143.985C130.835 144.972 126.882 146.453 122.929 148.675C114.529 153.612 106.623 161.018 99.9529 169.904C93.5294 178.791 88.3411 188.912 85.1294 199.033C83.1529 205.945 81.9176 212.61 81.9176 219.275C81.9176 229.15 84.6353 236.555 89.0823 241.492C93.5294 246.429 99.7058 248.898 107.118 248.157C112.059 247.664 117.494 245.936 123.176 242.727L286.482 148.675C292.412 145.219 297.847 140.035 302.294 134.11C306.741 128.186 310.447 121.274 312.67 114.115Z",
    fill: "url(#paint141_linear)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M67.267 529.15C156.851 576.95 302.228 576.95 391.812 529.15C481.396 481.35 481.396 403.755 391.812 355.85C302.123 308.05 156.851 308.05 67.267 355.85C-22.4223 403.755 -22.4223 481.35 67.267 529.15Z",
    fill: "#02439F"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M313.892 192.496L252.902 227.763C251.771 228.424 250.828 230.027 250.828 231.347V399.104C250.828 400.425 251.771 402.028 252.902 402.688L313.892 437.955C315.023 438.616 316.814 438.616 317.946 437.955L378.936 402.688C380.067 402.028 381.01 400.425 381.01 399.104V231.253C381.01 229.932 380.067 228.329 378.936 227.669L318.04 192.496C316.909 191.836 315.023 191.836 313.892 192.496Z",
    fill: "#0044A7"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M381.01 231.253V399.011C381.01 400.331 380.067 401.934 378.936 402.594L317.946 437.862C317.38 438.239 316.626 438.334 315.872 438.334V265.861C316.626 265.861 317.38 265.673 317.946 265.39L378.936 230.122L379.502 229.65L380.256 229.085C380.727 229.745 381.01 230.499 381.01 231.253Z",
    fill: "#062E67"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M260.538 247.756L306.257 274.159C307.388 274.819 308.331 276.423 308.331 277.743V295.188C308.331 296.508 307.388 296.98 306.257 296.414L260.538 270.01C259.407 269.35 258.464 267.747 258.464 266.427V248.982C258.558 247.661 259.407 247.19 260.538 247.756Z",
    fill: "#0064F3"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 255.488C262.329 256.714 263.272 258.223 264.403 258.883L302.392 280.855C303.523 281.515 304.466 281.043 304.466 279.817C304.466 278.591 303.523 277.083 302.392 276.423L264.309 254.451C263.272 253.791 262.329 254.262 262.329 255.488Z",
    fill: "#EFB118"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 264.352C262.329 265.578 263.272 267.087 264.403 267.747L302.486 289.719C303.618 290.379 304.56 289.907 304.56 288.681C304.56 287.455 303.618 285.947 302.486 285.287L264.403 263.315C263.272 262.655 262.329 263.126 262.329 264.352Z",
    fill: "#062E67"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M264.403 263.315L285.33 275.385V279.817L264.403 267.747C263.272 267.087 262.329 265.578 262.329 264.352C262.329 263.126 263.272 262.655 264.403 263.315Z",
    fill: "#EFB118"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M260.538 278.78L306.257 305.184C307.388 305.844 308.331 307.447 308.331 308.767V326.212C308.331 327.532 307.388 328.004 306.257 327.438L260.538 301.035C259.407 300.374 258.464 298.771 258.464 297.451V280.006C258.558 278.591 259.407 278.12 260.538 278.78Z",
    fill: "#0064F3"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 286.418C262.329 287.644 263.272 289.153 264.403 289.813L302.486 311.785C303.618 312.445 304.56 311.973 304.56 310.747C304.56 309.521 303.618 308.013 302.486 307.353L264.403 285.381C263.272 284.721 262.329 285.192 262.329 286.418Z",
    fill: "#EFB118"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 295.282C262.329 296.508 263.272 298.017 264.403 298.677L302.486 320.649C303.618 321.309 304.56 320.837 304.56 319.611C304.56 318.386 303.618 316.877 302.486 316.217L264.403 294.245C263.272 293.585 262.329 294.056 262.329 295.282Z",
    fill: "#062E67"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M264.403 294.245L296.83 313.011V317.443L264.403 298.677C263.272 298.017 262.329 296.508 262.329 295.282C262.329 294.056 263.272 293.585 264.403 294.245Z",
    fill: "#EFB118"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M260.538 309.71L306.257 336.114C307.388 336.774 308.331 338.377 308.331 339.697V357.142C308.331 358.462 307.388 358.934 306.257 358.368L260.538 331.965C259.407 331.304 258.464 329.701 258.464 328.381V310.936C258.558 309.616 259.407 309.05 260.538 309.71Z",
    fill: "#0064F3"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 317.348C262.329 318.574 263.272 320.083 264.403 320.743L302.392 342.715C303.523 343.375 304.466 342.903 304.466 341.677C304.466 340.451 303.523 338.943 302.392 338.283L264.403 316.311C263.272 315.745 262.329 316.122 262.329 317.348Z",
    fill: "#EFB118"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 326.212C262.329 327.438 263.272 328.947 264.403 329.607L302.486 351.579C303.618 352.239 304.56 351.767 304.56 350.541C304.56 349.315 303.618 347.807 302.486 347.147L264.403 325.175C263.272 324.515 262.329 324.986 262.329 326.212Z",
    fill: "#062E67"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M264.403 325.175L277.694 332.813V337.245L264.403 329.607C263.272 328.947 262.329 327.438 262.329 326.212C262.329 324.986 263.272 324.515 264.403 325.175Z",
    fill: "#EFB118"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M260.538 340.64L306.257 367.044C307.388 367.704 308.331 369.307 308.331 370.627V388.072C308.331 389.392 307.388 389.864 306.257 389.298L260.538 362.894C259.407 362.234 258.464 360.631 258.464 359.311V341.866C258.558 340.546 259.407 340.074 260.538 340.64Z",
    fill: "#0064F3"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 348.373C262.329 349.598 263.272 351.107 264.403 351.767L302.486 373.739C303.618 374.399 304.56 373.927 304.56 372.702C304.56 371.476 303.618 369.967 302.486 369.307L264.403 347.335C263.272 346.675 262.329 347.147 262.329 348.373Z",
    fill: "#EFB118"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 357.237C262.329 358.462 263.272 359.971 264.403 360.631L302.486 382.603C303.618 383.263 304.56 382.792 304.56 381.566C304.56 380.34 303.618 378.831 302.486 378.171L264.403 356.199C263.272 355.539 262.329 356.011 262.329 357.237Z",
    fill: "#062E67"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M264.403 356.199L285.33 368.27V372.702L264.403 360.631C263.272 359.971 262.329 358.462 262.329 357.237C262.329 356.011 263.272 355.539 264.403 356.199Z",
    fill: "#EFB118"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M260.538 371.664L306.257 398.068C307.388 398.728 308.331 400.331 308.331 401.651V419.097C308.331 420.417 307.388 420.888 306.257 420.323L260.538 393.919C259.407 393.259 258.464 391.656 258.464 390.335V372.89C258.558 371.476 259.407 371.004 260.538 371.664Z",
    fill: "#0064F3"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 379.303C262.329 380.528 263.272 382.037 264.403 382.697L302.486 404.669C303.618 405.329 304.56 404.857 304.56 403.632C304.56 402.406 303.618 400.897 302.486 400.237L264.403 378.265C263.272 377.605 262.329 378.077 262.329 379.303Z",
    fill: "#EFB118"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M262.329 388.167C262.329 389.392 263.272 390.901 264.403 391.561L302.486 413.533C303.618 414.193 304.56 413.722 304.56 412.496C304.56 411.27 303.618 409.761 302.486 409.101L264.403 387.129C263.272 386.469 262.329 386.941 262.329 388.167Z",
    fill: "#062E67"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M264.403 387.129L292.966 403.632V408.064L264.403 391.561C263.272 390.901 262.329 389.392 262.329 388.167C262.329 386.941 263.272 386.469 264.403 387.129Z",
    fill: "#EFB118"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M325.487 276.517C327.561 275.291 329.352 276.423 329.352 278.969V380.151C329.352 382.792 327.655 385.903 325.487 387.129C323.413 388.355 321.622 387.224 321.622 384.678V283.495C321.716 280.855 323.413 277.743 325.487 276.517Z",
    fill: "#0044A7"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M325.487 384.866C326.524 384.3 327.372 382.697 327.372 381.377V279.912C327.372 278.591 326.524 278.026 325.487 278.686C324.45 279.251 323.602 280.855 323.602 282.175V383.64C323.602 384.866 324.45 385.432 325.487 384.866Z",
    fill: "#062E67"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M325.487 384.866C326.524 384.3 327.373 382.697 327.373 381.377V332.908L323.508 335.076V383.546C323.602 384.866 324.45 385.432 325.487 384.866Z",
    fill: "#EFB118"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M336.988 269.822C339.062 268.596 340.853 269.727 340.853 272.273V373.456C340.853 376.096 339.156 379.208 336.988 380.434C334.914 381.66 333.123 380.528 333.123 377.982V276.8C333.217 274.159 334.914 271.047 336.988 269.822Z",
    fill: "#0044A7"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M336.988 378.171C338.025 377.605 338.873 376.002 338.873 374.682V273.216C338.873 271.896 338.025 271.33 336.988 271.991C335.951 272.556 335.103 274.159 335.103 275.48V376.945C335.103 378.265 335.951 378.831 336.988 378.171Z",
    fill: "#EFB118"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M348.488 263.221C350.562 261.995 352.353 263.126 352.353 265.672V366.855C352.353 369.495 350.656 372.607 348.488 373.833C346.414 375.059 344.623 373.928 344.623 371.381V270.199C344.717 267.558 346.414 264.447 348.488 263.221Z",
    fill: "#0044A7"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M348.488 371.57C349.525 371.004 350.373 369.401 350.373 368.081V266.615C350.373 265.295 349.525 264.729 348.488 265.39C347.451 265.955 346.603 267.558 346.603 268.879V370.344C346.603 371.57 347.451 372.136 348.488 371.57Z",
    fill: "#062E67"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M348.488 371.57C349.525 371.004 350.374 369.401 350.374 368.081V289.719L346.509 291.888V370.25C346.603 371.57 347.451 372.136 348.488 371.57Z",
    fill: "#EFB118"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M359.988 256.62C362.062 255.394 363.853 256.525 363.853 259.072V360.254C363.853 362.894 362.156 366.006 359.988 367.232C357.914 368.458 356.123 367.327 356.123 364.78V263.504C356.123 260.958 357.914 257.846 359.988 256.62Z",
    fill: "#0044A7"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M359.989 364.969C361.026 364.403 361.874 362.8 361.874 361.48V260.015C361.874 258.694 361.026 258.129 359.989 258.789C358.952 259.354 358.104 260.958 358.104 262.278V363.743C358.104 364.969 358.952 365.535 359.989 364.969Z",
    fill: "#062E67"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M359.988 364.969C361.025 364.403 361.874 362.8 361.874 361.48V344.318L358.009 346.487V363.649C358.103 364.969 358.951 365.535 359.988 364.969Z",
    fill: "#EFB118"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M371.489 249.925C373.563 248.699 375.354 249.83 375.354 252.376V353.559C375.354 356.199 373.657 359.311 371.489 360.537C369.415 361.763 367.624 360.631 367.624 358.085V256.903C367.624 254.262 369.415 251.15 371.489 249.925Z",
    fill: "#0044A7"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M371.489 358.274C372.526 357.708 373.374 356.105 373.374 354.785V253.319C373.374 251.999 372.526 251.433 371.489 252.093C370.452 252.659 369.604 254.262 369.604 255.583V357.048C369.604 358.368 370.452 358.934 371.489 358.274Z",
    fill: "#062E67"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M371.488 358.274C372.525 357.708 373.374 356.105 373.374 354.785V301.883L369.509 304.052V356.954C369.603 358.368 370.451 358.934 371.488 358.274Z",
    fill: "#EFB118"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M323.318 399.388L373.656 370.344C374.599 369.778 375.259 370.25 375.259 371.287V389.675C375.259 390.713 374.505 391.939 373.656 392.504L323.318 421.548C322.376 422.114 321.716 421.643 321.716 420.605V402.217C321.716 401.18 322.47 399.86 323.318 399.388Z",
    fill: "#0044A7"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M325.393 404.857C325.393 406.083 326.335 406.555 327.466 405.895L369.603 381.566C370.735 380.906 371.677 379.397 371.677 378.171C371.677 376.945 370.735 376.474 369.603 377.134L327.466 401.463C326.335 402.123 325.393 403.632 325.393 404.857Z",
    fill: "#062E67"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M325.393 404.857C325.393 406.083 326.335 406.555 327.466 405.895L358.103 388.167V383.735L327.466 401.463C326.335 402.123 325.393 403.632 325.393 404.857Z",
    fill: "#EFB118"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M325.393 413.627C325.393 414.853 326.335 415.325 327.466 414.665L369.603 390.335C370.735 389.675 371.677 388.167 371.677 386.941C371.677 385.715 370.735 385.243 369.603 385.903L327.466 410.233C326.335 410.893 325.393 412.401 325.393 413.627Z",
    fill: "#062E67"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M325.393 413.627C325.393 414.853 326.335 415.325 327.466 414.665L338.967 408.064V403.632L327.466 410.233C326.335 410.893 325.393 412.401 325.393 413.627Z",
    fill: "#EFB118"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M379.03 227.764L318.039 192.497C316.908 191.837 315.117 191.837 313.986 192.497L252.996 227.764C251.865 228.424 251.865 229.462 252.996 230.122L313.892 265.39C315.023 266.05 316.814 266.05 317.945 265.39L378.935 230.122C380.161 229.462 380.161 228.424 379.03 227.764Z",
    fill: "#0064F3"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M314.74 256.997L267.419 229.65C266.759 229.273 266.193 228.33 266.193 227.481V225.878C266.193 225.124 266.759 224.181 267.419 223.709L314.74 196.363C315.4 195.986 316.531 195.986 317.191 196.363L364.513 223.709C365.173 224.087 365.738 225.03 365.738 225.878V227.481C365.738 228.236 365.173 229.179 364.513 229.65L317.191 256.997C316.531 257.374 315.4 257.374 314.74 256.997Z",
    fill: "#062E67"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M267.419 225.218L314.74 252.565C315.4 252.942 316.531 252.942 317.191 252.565L364.513 225.218C365.173 224.841 365.173 224.181 364.513 223.804L317.191 197.4C316.531 197.023 315.4 197.023 314.74 197.4L267.419 223.804C266.759 224.181 266.759 224.841 267.419 225.218Z",
    fill: "#0064F3"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M315.966 252.848V257.28C315.494 257.28 315.117 257.186 314.74 256.997L267.419 229.65C266.759 229.273 266.193 228.33 266.193 227.481V225.878C266.193 225.218 266.57 224.37 267.23 223.898C266.759 224.275 266.853 224.841 267.419 225.124L314.74 252.471C315.117 252.753 315.494 252.848 315.966 252.848Z",
    fill: "#0044A7"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M314.741 243.701L282.69 225.218C282.03 224.841 281.465 223.898 281.465 223.049V221.446C281.465 220.692 282.03 219.749 282.69 219.277L303.24 207.396C303.9 207.019 304.843 206.17 305.314 205.51L315.118 192.308C315.589 191.648 316.532 191.459 317.192 191.837L349.242 210.319C349.902 210.696 350.468 211.639 350.468 212.488V222.955C350.468 223.71 349.902 224.653 349.242 225.124L317.192 243.607C316.532 244.078 315.401 244.078 314.741 243.701Z",
    fill: "#062E67"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M317.192 239.269L337.742 227.387C338.024 227.199 338.496 226.916 338.779 226.633C339.156 226.256 339.533 225.878 339.815 225.595L349.619 212.394C350.09 211.734 349.902 210.979 349.242 210.508L317.192 192.025C316.532 191.648 315.589 191.837 315.118 192.497L305.314 205.698C304.843 206.359 304.089 207.207 303.429 207.584L282.69 219.372C282.03 219.749 282.03 220.409 282.69 220.786L314.741 239.269C315.401 239.646 316.532 239.646 317.192 239.269Z",
    fill: "#0064F3"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M349.242 210.508L317.192 192.025C316.532 191.648 315.589 191.837 315.118 192.497L305.314 205.698C305.031 205.981 304.749 206.359 304.277 206.736L338.779 226.633C339.156 226.256 339.533 225.878 339.816 225.595L349.619 212.394C350.091 211.734 349.902 210.885 349.242 210.508Z",
    fill: "#0044A7"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M290.514 219.655C291.268 219.183 292.588 219.183 293.342 219.655C294.096 220.126 294.096 220.881 293.342 221.352C292.588 221.824 291.268 221.824 290.514 221.352C289.666 220.881 289.666 220.126 290.514 219.655Z",
    fill: "#EFB118"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M296.264 223.049C297.018 222.578 298.338 222.578 299.092 223.049C299.846 223.521 299.846 224.275 299.092 224.747C298.338 225.218 297.018 225.218 296.264 224.747C295.416 224.181 295.416 223.521 296.264 223.049Z",
    fill: "#EFB118"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M302.014 226.35C302.768 225.878 304.088 225.878 304.842 226.35C305.596 226.821 305.596 227.576 304.842 228.047C304.088 228.519 302.768 228.519 302.014 228.047C301.166 227.576 301.166 226.821 302.014 226.35Z",
    fill: "#062E67"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M307.765 229.65C308.519 229.179 309.839 229.179 310.593 229.65C311.347 230.122 311.347 230.876 310.593 231.348C309.839 231.819 308.519 231.819 307.765 231.348C306.917 230.876 306.917 230.122 307.765 229.65Z",
    fill: "#062E67"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M296.264 219.183C297.41 219.183 298.338 218.677 298.338 218.052C298.338 217.427 297.41 216.92 296.264 216.92C295.119 216.92 294.19 217.427 294.19 218.052C294.19 218.677 295.119 219.183 296.264 219.183Z",
    fill: "#EFB118"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M300.506 220.503C301.26 220.032 302.58 220.032 303.334 220.503C304.088 220.975 304.088 221.729 303.334 222.201C302.58 222.672 301.26 222.672 300.506 222.201C299.752 221.729 299.752 220.975 300.506 220.503Z",
    fill: "#062E67"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M307.765 225.784C308.911 225.784 309.839 225.277 309.839 224.653C309.839 224.028 308.911 223.521 307.765 223.521C306.62 223.521 305.691 224.028 305.691 224.653C305.691 225.277 306.62 225.784 307.765 225.784Z",
    fill: "#EFB118"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M312.007 227.199C312.761 226.727 314.081 226.727 314.835 227.199C315.589 227.67 315.589 228.424 314.835 228.896C314.081 229.367 312.761 229.367 312.007 228.896C311.253 228.33 311.253 227.576 312.007 227.199Z",
    fill: "#062E67"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M299.093 214.751C299.847 214.28 301.167 214.28 301.921 214.751C302.675 215.223 302.675 215.977 301.921 216.449C301.167 216.92 299.847 216.92 299.093 216.449C298.339 215.883 298.339 215.223 299.093 214.751Z",
    fill: "#062E67"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M304.843 218.052C305.597 217.58 306.917 217.58 307.671 218.052C308.425 218.523 308.425 219.277 307.671 219.749C306.917 220.22 305.597 220.22 304.843 219.749C304.089 219.277 304.089 218.523 304.843 218.052Z",
    fill: "#EFB118"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M310.593 221.352C311.347 220.881 312.667 220.881 313.421 221.352C314.175 221.824 314.175 222.578 313.421 223.049C312.667 223.521 311.347 223.521 310.593 223.049C309.839 222.578 309.839 221.824 310.593 221.352Z",
    fill: "#062E67"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M313.515 232.856C314.269 232.385 315.589 232.385 316.343 232.856C317.097 233.328 317.097 234.082 316.343 234.554C315.589 235.025 314.269 235.025 313.515 234.554C312.667 234.082 312.667 233.328 313.515 232.856Z",
    fill: "#EFB118"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M319.265 232.385C320.411 232.385 321.339 231.878 321.339 231.253C321.339 230.628 320.411 230.122 319.265 230.122C318.12 230.122 317.191 230.628 317.191 231.253C317.191 231.878 318.12 232.385 319.265 232.385Z",
    fill: "#062E67"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M316.343 224.653C317.097 224.181 318.417 224.181 319.171 224.653C319.925 225.124 319.925 225.878 319.171 226.35C318.417 226.821 317.097 226.821 316.343 226.35C315.589 225.878 315.589 225.124 316.343 224.653Z",
    fill: "#062E67"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M303.428 212.205C304.182 211.734 305.502 211.734 306.256 212.205C307.01 212.677 307.01 213.431 306.256 213.902C305.502 214.374 304.182 214.374 303.428 213.902C302.58 213.431 302.58 212.677 303.428 212.205Z",
    fill: "#EFB118"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M310.593 217.486C311.739 217.486 312.667 216.979 312.667 216.354C312.667 215.729 311.739 215.223 310.593 215.223C309.448 215.223 308.52 215.729 308.52 216.354C308.52 216.979 309.448 217.486 310.593 217.486Z",
    fill: "#062E67"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M314.929 218.9C315.683 218.429 317.003 218.429 317.757 218.9C318.511 219.372 318.511 220.126 317.757 220.598C317.003 221.069 315.683 221.069 314.929 220.598C314.081 220.032 314.081 219.372 314.929 218.9Z",
    fill: "#EFB118"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M322.093 224.181C323.239 224.181 324.167 223.674 324.167 223.049C324.167 222.424 323.239 221.918 322.093 221.918C320.948 221.918 320.02 222.424 320.02 223.049C320.02 223.674 320.948 224.181 322.093 224.181Z",
    fill: "#062E67"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M322.093 227.953C322.847 227.481 324.167 227.481 324.921 227.953C325.675 228.424 325.675 229.179 324.921 229.65C324.167 230.122 322.847 230.122 322.093 229.65C321.339 229.085 321.339 228.424 322.093 227.953Z",
    fill: "#EFB118"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M326.429 225.407C327.183 224.935 328.503 224.935 329.257 225.407C330.011 225.878 330.011 226.633 329.257 227.104C328.503 227.576 327.183 227.576 326.429 227.104C325.581 226.633 325.581 225.878 326.429 225.407Z",
    fill: "#062E67"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M316.061 239.552V243.984C315.589 243.984 315.118 243.889 314.741 243.701L282.69 225.218C282.03 224.841 281.465 223.898 281.465 223.049V221.446C281.465 220.786 281.842 219.938 282.502 219.466C282.03 219.843 282.125 220.409 282.69 220.692L314.741 239.175C315.118 239.457 315.589 239.552 316.061 239.552Z",
    fill: "#0044A7"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M309.557 205.133C309.934 204.661 310.499 204.567 310.971 204.85L338.873 220.975C339.345 221.258 339.439 221.824 339.156 222.201C338.873 222.578 338.214 222.767 337.742 222.484L309.934 206.359C309.368 206.076 309.274 205.51 309.557 205.133Z",
    fill: "#062E67"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M309.557 205.133C309.934 204.661 310.499 204.567 310.971 204.85L331.709 216.826L330.578 218.334L309.839 206.359C309.368 206.076 309.274 205.51 309.557 205.133Z",
    fill: "#EFB118"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M311.818 202.021C312.196 201.549 312.761 201.455 313.232 201.738L341.135 217.863C341.607 218.146 341.701 218.712 341.418 219.089C341.135 219.466 340.475 219.655 340.004 219.372L312.196 203.247C311.63 202.964 311.536 202.492 311.818 202.021Z",
    fill: "#062E67"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M311.819 202.021C312.196 201.549 312.762 201.455 313.233 201.738L320.115 205.698L318.983 207.207L312.102 203.247C311.631 202.964 311.536 202.492 311.819 202.021Z",
    fill: "#EFB118"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M314.176 198.909C314.553 198.437 315.118 198.343 315.59 198.626L343.492 214.751C343.964 215.034 344.058 215.6 343.775 215.977C343.492 216.354 342.833 216.543 342.361 216.26L314.458 200.135C313.987 199.946 313.893 199.38 314.176 198.909Z",
    fill: "#062E67"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M314.176 198.909C314.553 198.437 315.118 198.343 315.59 198.626L330.107 207.019L328.975 208.527L314.458 200.135C313.987 199.946 313.893 199.38 314.176 198.909Z",
    fill: "#EFB118"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M316.438 195.891C316.815 195.42 317.381 195.326 317.852 195.608L345.755 211.639C346.226 211.922 346.321 212.488 346.038 212.865C345.755 213.242 345.095 213.431 344.624 213.148L316.721 197.117C316.25 196.834 316.156 196.269 316.438 195.891Z",
    fill: "#062E67"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M316.438 195.891C316.815 195.42 317.381 195.326 317.852 195.608L343.116 210.225L341.984 211.639L316.721 197.117C316.25 196.834 316.156 196.269 316.438 195.891Z",
    fill: "#EFB118"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M228.847 246.688L167.857 281.956C166.726 282.616 165.783 284.219 165.783 285.539V453.296C165.783 454.617 166.726 456.22 167.857 456.88L228.847 492.148C229.978 492.808 231.769 492.808 232.901 492.148L293.891 456.88C295.022 456.22 295.965 454.617 295.965 453.296V285.445C295.965 284.125 295.022 282.521 293.891 281.861L232.995 246.688C231.864 246.028 229.978 246.028 228.847 246.688Z",
    fill: "#0044A7"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M295.965 285.446V453.203C295.965 454.523 295.022 456.126 293.891 456.786L232.901 492.054C232.335 492.431 231.581 492.526 230.827 492.526V320.053C231.581 320.053 232.335 319.865 232.901 319.582L293.891 284.314L294.457 283.843L295.211 283.277C295.682 283.937 295.965 284.786 295.965 285.446Z",
    fill: "#062E67"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M175.493 301.948L221.212 328.352C222.343 329.012 223.286 330.615 223.286 331.935V349.38C223.286 350.7 222.343 351.172 221.212 350.512L175.493 324.108C174.362 323.448 173.419 321.845 173.419 320.525V303.079C173.513 301.854 174.362 301.382 175.493 301.948Z",
    fill: "#0064F3"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 309.68C177.284 310.906 178.227 312.415 179.358 313.075L217.442 335.047C218.573 335.707 219.515 335.235 219.515 334.01C219.515 332.784 218.573 331.275 217.442 330.615L179.358 308.643C178.227 307.983 177.284 308.455 177.284 309.68Z",
    fill: "#EFB118"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 318.544C177.284 319.77 178.227 321.279 179.358 321.939L217.442 343.911C218.573 344.571 219.515 344.099 219.515 342.874C219.515 341.648 218.573 340.139 217.442 339.479L179.358 317.507C178.227 316.847 177.284 317.319 177.284 318.544Z",
    fill: "#062E67"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M179.358 317.507L200.285 329.577V334.009L179.358 321.939C178.227 321.279 177.284 319.77 177.284 318.544C177.284 317.319 178.227 316.847 179.358 317.507Z",
    fill: "#EFB118"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M175.493 332.972L221.212 359.376C222.343 360.036 223.286 361.639 223.286 362.959V380.404C223.286 381.725 222.343 382.196 221.212 381.536L175.493 355.132C174.362 354.472 173.419 352.869 173.419 351.549V334.104C173.513 332.784 174.362 332.312 175.493 332.972Z",
    fill: "#0064F3"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 340.61C177.284 341.836 178.227 343.345 179.358 344.005L217.442 365.977C218.573 366.637 219.515 366.165 219.515 364.939C219.515 363.714 218.573 362.205 217.442 361.545L179.358 339.573C178.227 338.913 177.284 339.384 177.284 340.61Z",
    fill: "#EFB118"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 349.474C177.284 350.7 178.227 352.209 179.358 352.869L217.442 374.841C218.573 375.501 219.515 375.029 219.515 373.804C219.515 372.578 218.573 371.069 217.442 370.409L179.358 348.437C178.227 347.777 177.284 348.249 177.284 349.474Z",
    fill: "#062E67"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M179.358 348.437L211.786 367.203V371.635L179.358 352.869C178.227 352.209 177.284 350.7 177.284 349.474C177.284 348.249 178.227 347.777 179.358 348.437Z",
    fill: "#EFB118"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M175.493 363.902L221.212 390.306C222.343 390.966 223.286 392.569 223.286 393.889V411.334C223.286 412.655 222.343 413.126 221.212 412.466L175.493 386.062C174.362 385.402 173.419 383.799 173.419 382.479V365.034C173.513 363.808 174.362 363.242 175.493 363.902Z",
    fill: "#0064F3"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 371.54C177.284 372.766 178.227 374.275 179.358 374.935L217.347 396.907C218.478 397.567 219.421 397.095 219.421 395.869C219.421 394.644 218.478 393.135 217.347 392.475L179.358 370.503C178.227 369.937 177.284 370.315 177.284 371.54Z",
    fill: "#EFB118"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 380.404C177.284 381.63 178.227 383.139 179.358 383.799L217.442 405.771C218.573 406.431 219.515 405.959 219.515 404.734C219.515 403.508 218.573 401.999 217.442 401.339L179.358 379.367C178.227 378.707 177.284 379.179 177.284 380.404Z",
    fill: "#062E67"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M179.358 379.367L192.65 387.005V391.437L179.358 383.799C178.227 383.139 177.284 381.63 177.284 380.404C177.284 379.179 178.227 378.707 179.358 379.367Z",
    fill: "#EFB118"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M175.493 394.832L221.212 421.236C222.343 421.896 223.286 423.499 223.286 424.819V442.264C223.286 443.585 222.343 444.056 221.212 443.396L175.493 416.992C174.362 416.332 173.419 414.729 173.419 413.409V395.964C173.513 394.738 174.362 394.266 175.493 394.832Z",
    fill: "#0064F3"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 402.565C177.284 403.79 178.227 405.299 179.358 405.959L217.442 427.931C218.573 428.591 219.515 428.12 219.515 426.894C219.515 425.668 218.573 424.159 217.442 423.499L179.358 401.527C178.227 400.867 177.284 401.339 177.284 402.565Z",
    fill: "#EFB118"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 411.429C177.284 412.655 178.227 414.163 179.358 414.824L217.442 436.795C218.573 437.455 219.515 436.984 219.515 435.758C219.515 434.532 218.573 433.023 217.442 432.363L179.358 410.391C178.227 409.731 177.284 410.203 177.284 411.429Z",
    fill: "#062E67"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M179.358 410.391L200.285 422.462V426.894L179.358 414.824C178.227 414.163 177.284 412.655 177.284 411.429C177.284 410.203 178.227 409.731 179.358 410.391Z",
    fill: "#EFB118"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M175.493 425.856L221.212 452.26C222.343 452.92 223.286 454.523 223.286 455.843V473.289C223.286 474.609 222.343 475.08 221.212 474.42L175.493 448.017C174.362 447.357 173.419 445.753 173.419 444.433V426.988C173.513 425.668 174.362 425.196 175.493 425.856Z",
    fill: "#0064F3"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 433.495C177.284 434.721 178.227 436.229 179.358 436.889L217.442 458.861C218.573 459.521 219.515 459.05 219.515 457.824C219.515 456.598 218.573 455.089 217.442 454.429L179.358 432.457C178.227 431.797 177.284 432.269 177.284 433.495Z",
    fill: "#EFB118"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M177.284 442.359C177.284 443.585 178.227 445.093 179.358 445.754L217.442 467.725C218.573 468.385 219.515 467.914 219.515 466.688C219.515 465.462 218.573 463.953 217.442 463.293L179.358 441.321C178.227 440.661 177.284 441.133 177.284 442.359Z",
    fill: "#062E67"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M179.358 441.321L207.921 457.824V462.256L179.358 445.754C178.227 445.093 177.284 443.585 177.284 442.359C177.284 441.133 178.227 440.661 179.358 441.321Z",
    fill: "#EFB118"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M240.442 330.709C242.516 329.483 244.307 330.615 244.307 333.161V434.343C244.307 436.984 242.61 440.096 240.442 441.321C238.368 442.547 236.577 441.416 236.577 438.87V337.687C236.671 335.047 238.368 331.935 240.442 330.709Z",
    fill: "#0044A7"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M240.442 439.058C241.479 438.492 242.327 436.889 242.327 435.569V334.104C242.327 332.784 241.479 332.218 240.442 332.878C239.405 333.444 238.557 335.047 238.557 336.367V437.832C238.557 439.058 239.405 439.624 240.442 439.058Z",
    fill: "#062E67"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M240.442 439.058C241.479 438.492 242.328 436.889 242.328 435.569V387.1L238.463 389.268V437.738C238.557 439.058 239.406 439.624 240.442 439.058Z",
    fill: "#EFB118"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M251.942 324.014C254.016 322.788 255.807 323.919 255.807 326.466V427.648C255.807 430.288 254.11 433.4 251.942 434.626C249.868 435.852 248.077 434.72 248.077 432.174V330.992C248.171 328.352 249.868 325.24 251.942 324.014Z",
    fill: "#0044A7"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M251.943 432.363C252.98 431.797 253.828 430.194 253.828 428.874V327.409C253.828 326.088 252.98 325.523 251.943 326.183C250.906 326.748 250.058 328.352 250.058 329.672V431.137C250.058 432.457 250.906 433.023 251.943 432.363Z",
    fill: "#EFB118"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M263.443 317.413C265.517 316.187 267.308 317.319 267.308 319.865V421.047C267.308 423.688 265.611 426.799 263.443 428.025C261.369 429.251 259.578 428.12 259.578 425.574V324.391C259.672 321.751 261.369 318.639 263.443 317.413Z",
    fill: "#0044A7"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M263.443 425.762C264.48 425.196 265.328 423.593 265.328 422.273V320.808C265.328 319.487 264.48 318.922 263.443 319.582C262.406 320.148 261.558 321.751 261.558 323.071V424.536C261.558 425.762 262.406 426.328 263.443 425.762Z",
    fill: "#062E67"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M263.443 425.762C264.48 425.196 265.329 423.593 265.329 422.273V343.911L261.464 346.08V424.442C261.558 425.762 262.407 426.328 263.443 425.762Z",
    fill: "#EFB118"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M274.943 310.812C277.017 309.586 278.808 310.718 278.808 313.264V414.446C278.808 417.087 277.111 420.199 274.943 421.424C272.869 422.65 271.078 421.519 271.078 418.973V317.79C271.078 315.15 272.869 312.038 274.943 310.812Z",
    fill: "#0044A7"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M274.944 419.161C275.981 418.595 276.829 416.992 276.829 415.672V314.207C276.829 312.887 275.981 312.321 274.944 312.981C273.907 313.641 273.059 315.15 273.059 316.47V417.935C273.059 419.161 273.907 419.727 274.944 419.161Z",
    fill: "#062E67"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M274.943 419.161C275.98 418.595 276.829 416.992 276.829 415.672V398.51L272.964 400.679V417.841C273.058 419.161 273.907 419.727 274.943 419.161Z",
    fill: "#EFB118"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M286.444 304.117C288.518 302.891 290.309 304.022 290.309 306.568V407.751C290.309 410.391 288.612 413.503 286.444 414.729C284.37 415.955 282.579 414.823 282.579 412.277V311.095C282.579 308.454 284.37 305.343 286.444 304.117Z",
    fill: "#0044A7"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M286.444 412.466C287.481 411.9 288.329 410.297 288.329 408.977V307.511C288.329 306.191 287.481 305.626 286.444 306.286C285.407 306.851 284.559 308.454 284.559 309.775V411.24C284.559 412.56 285.407 413.126 286.444 412.466Z",
    fill: "#062E67"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M286.443 412.466C287.48 411.9 288.329 410.297 288.329 408.977V356.075L284.464 358.244V411.146C284.558 412.56 285.407 413.126 286.443 412.466Z",
    fill: "#EFB118"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M238.273 453.58L288.611 424.536C289.554 423.97 290.214 424.442 290.214 425.479V443.867C290.214 444.905 289.46 446.131 288.611 446.696L238.273 475.741C237.331 476.306 236.671 475.835 236.671 474.798V456.409C236.671 455.372 237.425 454.052 238.273 453.58Z",
    fill: "#0044A7"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M240.348 459.05C240.348 460.275 241.29 460.747 242.422 460.087L284.558 435.758C285.69 435.098 286.632 433.589 286.632 432.363C286.632 431.137 285.69 430.666 284.558 431.326L242.422 455.655C241.29 456.315 240.348 457.824 240.348 459.05Z",
    fill: "#062E67"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M240.348 459.05C240.348 460.275 241.29 460.747 242.422 460.087L273.058 442.359V437.927L242.422 455.655C241.29 456.315 240.348 457.824 240.348 459.05Z",
    fill: "#EFB118"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M240.348 467.819C240.348 469.045 241.29 469.517 242.422 468.857L284.558 444.528C285.69 443.867 286.632 442.359 286.632 441.133C286.632 439.907 285.69 439.435 284.558 440.096L242.422 464.425C241.29 465.085 240.348 466.594 240.348 467.819Z",
    fill: "#062E67"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M240.348 467.819C240.348 469.045 241.29 469.517 242.422 468.857L253.922 462.256V457.824L242.422 464.425C241.29 465.085 240.348 466.593 240.348 467.819Z",
    fill: "#EFB118"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M293.985 281.957L232.995 246.689C231.863 246.029 230.072 246.029 228.941 246.689L167.951 281.957C166.82 282.617 166.82 283.654 167.951 284.314L228.847 319.582C229.978 320.242 231.769 320.242 232.9 319.582L293.89 284.314C295.116 283.654 295.116 282.617 293.985 281.957Z",
    fill: "#0064F3"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M229.695 311.189L182.374 283.843C181.714 283.465 181.148 282.522 181.148 281.674V280.071C181.148 279.316 181.714 278.373 182.374 277.902L229.695 250.555C230.355 250.178 231.487 250.178 232.146 250.555L279.468 277.902C280.128 278.279 280.693 279.222 280.693 280.071V281.674C280.693 282.428 280.128 283.371 279.468 283.843L232.146 311.189C231.487 311.566 230.355 311.566 229.695 311.189Z",
    fill: "#062E67"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M182.374 279.41L229.695 306.757C230.355 307.134 231.486 307.134 232.146 306.757L279.468 279.41C280.128 279.033 280.128 278.373 279.468 277.996L232.146 251.592C231.486 251.215 230.355 251.215 229.695 251.592L182.374 277.996C181.714 278.373 181.714 279.033 182.374 279.41Z",
    fill: "#0064F3"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M230.921 307.04V311.472C230.45 311.472 230.073 311.378 229.695 311.189L182.374 283.843C181.714 283.465 181.148 282.522 181.148 281.674V280.071C181.148 279.411 181.526 278.562 182.185 278.09C181.714 278.468 181.808 279.033 182.374 279.316L229.695 306.663C230.073 306.946 230.45 307.04 230.921 307.04Z",
    fill: "#0044A7"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M229.696 297.893L197.645 279.41C196.986 279.033 196.42 278.09 196.42 277.242V275.639C196.42 274.884 196.986 273.941 197.645 273.47L218.195 261.588C218.855 261.211 219.798 260.362 220.269 259.702L230.073 246.5C230.544 245.84 231.487 245.652 232.147 246.029L264.197 264.511C264.857 264.888 265.423 265.831 265.423 266.68V277.147C265.423 277.902 264.857 278.845 264.197 279.316L232.147 297.799C231.487 298.27 230.356 298.27 229.696 297.893Z",
    fill: "#062E67"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M232.147 293.461L252.697 281.579C252.979 281.391 253.451 281.108 253.734 280.825C254.111 280.448 254.488 280.071 254.771 279.788L264.574 266.586C265.046 265.926 264.857 265.171 264.197 264.7L232.147 246.217C231.487 245.84 230.544 246.029 230.073 246.689L220.269 259.891C219.798 260.551 219.044 261.399 218.384 261.777L197.645 273.564C196.985 273.941 196.985 274.601 197.645 274.978L229.696 293.461C230.356 293.838 231.487 293.838 232.147 293.461Z",
    fill: "#0064F3"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M264.197 264.7L232.147 246.217C231.487 245.84 230.544 246.029 230.073 246.689L220.269 259.891C219.987 260.174 219.704 260.551 219.232 260.928L253.734 280.825C254.111 280.448 254.488 280.071 254.771 279.788L264.574 266.586C265.046 265.926 264.857 265.077 264.197 264.7Z",
    fill: "#0044A7"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M205.469 273.847C206.223 273.375 207.543 273.375 208.297 273.847C209.051 274.318 209.051 275.073 208.297 275.544C207.543 276.016 206.223 276.016 205.469 275.544C204.621 275.073 204.621 274.318 205.469 273.847Z",
    fill: "#EFB118"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M211.219 277.242C211.973 276.77 213.293 276.77 214.047 277.242C214.801 277.713 214.801 278.468 214.047 278.939C213.293 279.41 211.973 279.41 211.219 278.939C210.371 278.373 210.371 277.713 211.219 277.242Z",
    fill: "#EFB118"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M216.969 280.542C217.723 280.071 219.043 280.071 219.797 280.542C220.551 281.014 220.551 281.768 219.797 282.239C219.043 282.711 217.723 282.711 216.969 282.239C216.121 281.768 216.121 281.014 216.969 280.542Z",
    fill: "#062E67"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M222.72 283.843C223.474 283.371 224.794 283.371 225.548 283.843C226.302 284.314 226.302 285.068 225.548 285.54C224.794 286.011 223.474 286.011 222.72 285.54C221.872 285.068 221.872 284.314 222.72 283.843Z",
    fill: "#062E67"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M209.711 271.395C210.465 270.924 211.785 270.924 212.539 271.395C213.293 271.867 213.293 272.621 212.539 273.093C211.785 273.564 210.465 273.564 209.711 273.093C208.957 272.621 208.957 271.867 209.711 271.395Z",
    fill: "#EFB118"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M216.969 276.676C218.115 276.676 219.043 276.169 219.043 275.544C219.043 274.919 218.115 274.413 216.969 274.413C215.824 274.413 214.896 274.919 214.896 275.544C214.896 276.169 215.824 276.676 216.969 276.676Z",
    fill: "#062E67"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M221.212 277.996C221.966 277.525 223.286 277.525 224.04 277.996C224.794 278.468 224.794 279.222 224.04 279.693C223.286 280.165 221.966 280.165 221.212 279.693C220.458 279.222 220.458 278.468 221.212 277.996Z",
    fill: "#EFB118"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M228.376 283.277C229.521 283.277 230.449 282.77 230.449 282.145C230.449 281.52 229.521 281.014 228.376 281.014C227.23 281.014 226.302 281.52 226.302 282.145C226.302 282.77 227.23 283.277 228.376 283.277Z",
    fill: "#062E67"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M214.048 268.943C214.802 268.472 216.122 268.472 216.876 268.943C217.63 269.415 217.63 270.169 216.876 270.641C216.122 271.112 214.802 271.112 214.048 270.641C213.294 270.075 213.294 269.415 214.048 268.943Z",
    fill: "#062E67"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M219.798 272.244C220.552 271.772 221.872 271.772 222.626 272.244C223.38 272.715 223.38 273.47 222.626 273.941C221.872 274.413 220.552 274.413 219.798 273.941C219.044 273.47 219.044 272.715 219.798 272.244Z",
    fill: "#EFB118"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M225.548 275.544C226.302 275.073 227.622 275.073 228.376 275.544C229.13 276.016 229.13 276.77 228.376 277.242C227.622 277.713 226.302 277.713 225.548 277.242C224.794 276.77 224.794 276.016 225.548 275.544Z",
    fill: "#062E67"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M228.47 287.049C229.224 286.577 230.544 286.577 231.298 287.049C232.052 287.52 232.052 288.275 231.298 288.746C230.544 289.218 229.224 289.218 228.47 288.746C227.622 288.275 227.622 287.52 228.47 287.049Z",
    fill: "#EFB118"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M232.712 284.597C233.466 284.125 234.786 284.125 235.54 284.597C236.294 285.068 236.294 285.823 235.54 286.294C234.786 286.766 233.466 286.766 232.712 286.294C231.958 285.823 231.958 285.068 232.712 284.597Z",
    fill: "#062E67"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M231.298 278.845C232.052 278.373 233.372 278.373 234.126 278.845C234.88 279.316 234.88 280.071 234.126 280.542C233.372 281.014 232.052 281.014 231.298 280.542C230.544 280.071 230.544 279.316 231.298 278.845Z",
    fill: "#062E67"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M219.797 268.378C220.943 268.378 221.871 267.871 221.871 267.246C221.871 266.621 220.943 266.114 219.797 266.114C218.652 266.114 217.724 266.621 217.724 267.246C217.724 267.871 218.652 268.378 219.797 268.378Z",
    fill: "#EFB118"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M224.134 269.792C224.888 269.321 226.208 269.321 226.962 269.792C227.716 270.264 227.716 271.018 226.962 271.489C226.208 271.961 224.888 271.961 224.134 271.489C223.286 270.924 223.286 270.169 224.134 269.792Z",
    fill: "#062E67"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M231.298 274.978C232.444 274.978 233.372 274.472 233.372 273.847C233.372 273.222 232.444 272.715 231.298 272.715C230.153 272.715 229.225 273.222 229.225 273.847C229.225 274.472 230.153 274.978 231.298 274.978Z",
    fill: "#EFB118"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M235.634 276.393C236.388 275.921 237.708 275.921 238.462 276.393C239.216 276.864 239.216 277.619 238.462 278.09C237.708 278.562 236.388 278.562 235.634 278.09C234.786 277.619 234.786 276.864 235.634 276.393Z",
    fill: "#062E67"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M237.048 282.145C237.802 281.674 239.122 281.674 239.876 282.145C240.63 282.617 240.63 283.371 239.876 283.843C239.122 284.314 237.802 284.314 237.048 283.843C236.294 283.277 236.294 282.617 237.048 282.145Z",
    fill: "#EFB118"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M242.798 281.579C243.944 281.579 244.872 281.073 244.872 280.448C244.872 279.823 243.944 279.316 242.798 279.316C241.653 279.316 240.725 279.823 240.725 280.448C240.725 281.073 241.653 281.579 242.798 281.579Z",
    fill: "#062E67"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M231.016 293.744V298.176C230.544 298.176 230.073 298.082 229.696 297.893L197.645 279.41C196.986 279.033 196.42 278.09 196.42 277.242V275.639C196.42 274.978 196.797 274.13 197.457 273.658C196.986 274.035 197.08 274.601 197.645 274.884L229.696 293.367C230.073 293.65 230.544 293.744 231.016 293.744Z",
    fill: "#0044A7"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M224.512 259.325C224.889 258.853 225.454 258.759 225.926 259.042L253.828 275.167C254.3 275.45 254.394 276.016 254.111 276.393C253.828 276.77 253.168 276.959 252.697 276.676L224.794 260.551C224.323 260.268 224.229 259.702 224.512 259.325Z",
    fill: "#062E67"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M224.511 259.325C224.888 258.853 225.454 258.759 225.925 259.042L246.664 271.018L245.438 272.527L224.7 260.551C224.323 260.268 224.228 259.702 224.511 259.325Z",
    fill: "#EFB118"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M226.773 256.213C227.15 255.742 227.716 255.647 228.187 255.93L256.09 272.055C256.561 272.338 256.656 272.904 256.373 273.281C256.09 273.658 255.43 273.847 254.959 273.564L227.056 257.439C226.585 257.156 226.491 256.685 226.773 256.213Z",
    fill: "#062E67"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M226.773 256.213C227.15 255.742 227.716 255.647 228.187 255.93L235.069 259.891L233.938 261.399L227.056 257.439C226.585 257.156 226.491 256.685 226.773 256.213Z",
    fill: "#EFB118"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M229.13 253.101C229.507 252.63 230.072 252.535 230.544 252.818L258.447 268.943C258.918 269.226 259.012 269.792 258.729 270.169C258.447 270.546 257.787 270.735 257.315 270.452L229.413 254.327C228.941 254.138 228.847 253.573 229.13 253.101Z",
    fill: "#062E67"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M229.13 253.101C229.507 252.63 230.072 252.535 230.544 252.818L245.061 261.117L243.93 262.625L229.413 254.327C228.941 254.138 228.847 253.573 229.13 253.101Z",
    fill: "#EFB118"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M231.392 250.084C231.77 249.612 232.335 249.518 232.806 249.801L260.709 265.831C261.181 266.114 261.275 266.68 260.992 267.057C260.709 267.435 260.049 267.623 259.578 267.34L231.675 251.309C231.204 251.027 231.11 250.461 231.392 250.084Z",
    fill: "#062E67"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M231.392 250.084C231.77 249.612 232.335 249.518 232.806 249.801L258.07 264.417L256.939 265.926L231.675 251.309C231.204 251.027 231.11 250.461 231.392 250.084Z",
    fill: "#EFB118"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M138.064 297.757L77.0739 333.025C75.9427 333.685 75 335.288 75 336.608V504.366C75 505.686 75.9427 507.289 77.0739 507.949L138.064 543.217C139.195 543.877 140.986 543.877 142.117 543.217L203.108 507.949C204.239 507.289 205.181 505.686 205.181 504.366V336.514C205.181 335.194 204.239 333.591 203.108 332.93L142.212 297.757C141.081 297.097 139.195 297.097 138.064 297.757Z",
    fill: "#0044A7"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M205.182 336.515V504.272C205.182 505.592 204.239 507.195 203.108 507.856L142.118 543.123C141.552 543.501 140.798 543.595 140.044 543.595V371.122C140.798 371.122 141.552 370.934 142.118 370.651L203.108 335.383L203.674 334.912L204.428 334.346C204.899 335.006 205.182 335.855 205.182 336.515Z",
    fill: "#062E67"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7096 353.017L130.429 379.421C131.56 380.081 132.502 381.684 132.502 383.004V400.449C132.502 401.769 131.56 402.241 130.429 401.581L84.7096 375.177C83.5784 374.517 82.6357 372.914 82.6357 371.594V354.149C82.73 352.923 83.5784 352.451 84.7096 353.017Z",
    fill: "#0064F3"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 360.75C86.501 361.975 87.4436 363.484 88.5748 364.144L126.658 386.116C127.79 386.776 128.732 386.304 128.732 385.079C128.732 383.853 127.79 382.344 126.658 381.684L88.5748 359.712C87.4436 359.052 86.501 359.524 86.501 360.75Z",
    fill: "#EFB118"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 369.614C86.501 370.839 87.4436 372.348 88.5748 373.008L126.658 394.98C127.79 395.64 128.732 395.169 128.732 393.943C128.732 392.717 127.79 391.208 126.658 390.548L88.5748 368.576C87.4436 367.916 86.501 368.388 86.501 369.614Z",
    fill: "#062E67"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5748 368.576L109.502 380.646V385.079L88.5748 373.008C87.4436 372.348 86.501 370.839 86.501 369.614C86.501 368.388 87.4436 367.916 88.5748 368.576Z",
    fill: "#EFB118"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7096 384.041L130.429 410.445C131.56 411.105 132.502 412.708 132.502 414.028V431.473C132.502 432.794 131.56 433.265 130.429 432.605L84.7096 406.201C83.5784 405.541 82.6357 403.938 82.6357 402.618V385.173C82.73 383.853 83.5784 383.381 84.7096 384.041Z",
    fill: "#0064F3"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 391.679C86.501 392.905 87.4436 394.414 88.5748 395.074L126.658 417.046C127.79 417.706 128.732 417.234 128.732 416.009C128.732 414.783 127.79 413.274 126.658 412.614L88.5748 390.642C87.4436 389.982 86.501 390.454 86.501 391.679Z",
    fill: "#EFB118"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 400.544C86.501 401.769 87.4436 403.278 88.5748 403.938L126.658 425.91C127.79 426.57 128.732 426.099 128.732 424.873C128.732 423.647 127.79 422.138 126.658 421.478L88.5748 399.506C87.4436 398.846 86.501 399.318 86.501 400.544Z",
    fill: "#062E67"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5748 399.506L121.002 418.272V422.704L88.5748 403.938C87.4436 403.278 86.501 401.769 86.501 400.544C86.501 399.318 87.4436 398.846 88.5748 399.506Z",
    fill: "#EFB118"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7096 414.971L130.429 441.375C131.56 442.035 132.502 443.638 132.502 444.958V462.404C132.502 463.724 131.56 464.195 130.429 463.535L84.7096 437.131C83.5784 436.471 82.6357 434.868 82.6357 433.548V416.103C82.73 414.877 83.5784 414.311 84.7096 414.971Z",
    fill: "#0064F3"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 422.61C86.501 423.835 87.4436 425.344 88.5748 426.004L126.564 447.976C127.695 448.636 128.638 448.164 128.638 446.939C128.638 445.713 127.695 444.204 126.564 443.544L88.5748 421.572C87.4436 421.006 86.501 421.384 86.501 422.61Z",
    fill: "#EFB118"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 431.474C86.501 432.699 87.4436 434.208 88.5748 434.868L126.658 456.84C127.79 457.5 128.732 457.029 128.732 455.803C128.732 454.577 127.79 453.068 126.658 452.408L88.5748 430.436C87.4436 429.776 86.501 430.248 86.501 431.474Z",
    fill: "#062E67"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5748 430.436L101.866 438.074V442.506L88.5748 434.868C87.4436 434.208 86.501 432.699 86.501 431.474C86.501 430.248 87.4436 429.776 88.5748 430.436Z",
    fill: "#EFB118"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7096 445.901L130.429 472.305C131.56 472.965 132.502 474.568 132.502 475.888V493.334C132.502 494.654 131.56 495.125 130.429 494.465L84.7096 468.061C83.5784 467.401 82.6357 465.798 82.6357 464.478V447.033C82.73 445.807 83.5784 445.335 84.7096 445.901Z",
    fill: "#0064F3"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 453.634C86.501 454.86 87.4436 456.368 88.5748 457.028L126.658 479C127.79 479.66 128.732 479.189 128.732 477.963C128.732 476.737 127.79 475.228 126.658 474.568L88.5748 452.596C87.4436 451.936 86.501 452.408 86.501 453.634Z",
    fill: "#EFB118"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 462.498C86.501 463.724 87.4436 465.233 88.5748 465.893L126.658 487.864C127.79 488.524 128.732 488.053 128.732 486.827C128.732 485.601 127.79 484.092 126.658 483.432L88.5748 461.461C87.4436 460.8 86.501 461.272 86.501 462.498Z",
    fill: "#062E67"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5748 461.461L109.502 473.531V477.963L88.5748 465.893C87.4436 465.233 86.501 463.724 86.501 462.498C86.501 461.272 87.4436 460.8 88.5748 461.461Z",
    fill: "#EFB118"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7096 476.926L130.429 503.329C131.56 503.989 132.502 505.592 132.502 506.913V524.358C132.502 525.678 131.56 526.15 130.429 525.489L84.7096 499.086C83.5784 498.426 82.6357 496.823 82.6357 495.502V478.057C82.73 476.737 83.5784 476.266 84.7096 476.926Z",
    fill: "#0064F3"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 484.564C86.501 485.79 87.4436 487.299 88.5748 487.959L126.658 509.93C127.79 510.59 128.732 510.119 128.732 508.893C128.732 507.667 127.79 506.158 126.658 505.498L88.5748 483.527C87.4436 482.866 86.501 483.338 86.501 484.564Z",
    fill: "#EFB118"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M86.501 493.428C86.501 494.654 87.4436 496.163 88.5748 496.823L126.658 518.794C127.79 519.454 128.732 518.983 128.732 517.757C128.732 516.531 127.79 515.022 126.658 514.362L88.5748 492.391C87.4436 491.73 86.501 492.202 86.501 493.428Z",
    fill: "#062E67"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5748 492.391L117.137 508.893V513.325L88.5748 496.823C87.4436 496.163 86.501 494.654 86.501 493.428C86.501 492.202 87.4436 491.73 88.5748 492.391Z",
    fill: "#EFB118"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 381.778C151.733 380.552 153.524 381.684 153.524 384.23V485.412C153.524 488.053 151.827 491.165 149.659 492.391C147.585 493.616 145.794 492.485 145.794 489.939V388.756C145.888 386.116 147.585 383.004 149.659 381.778Z",
    fill: "#0044A7"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 490.127C150.696 489.562 151.544 487.958 151.544 486.638V385.173C151.544 383.853 150.696 383.287 149.659 383.947C148.622 384.513 147.773 386.116 147.773 387.436V488.901C147.773 490.127 148.622 490.693 149.659 490.127Z",
    fill: "#062E67"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M149.659 490.127C150.696 489.562 151.545 487.958 151.545 486.638V438.169L147.68 440.338V488.807C147.774 490.127 148.622 490.693 149.659 490.127Z",
    fill: "#EFB118"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M161.159 375.083C163.233 373.857 165.024 374.989 165.024 377.535V478.717C165.024 481.358 163.327 484.469 161.159 485.695C159.085 486.921 157.294 485.79 157.294 483.244V382.061C157.388 379.421 159.085 376.309 161.159 375.083Z",
    fill: "#0044A7"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M161.16 483.432C162.197 482.866 163.045 481.263 163.045 479.943V378.478C163.045 377.157 162.197 376.592 161.16 377.252C160.123 377.818 159.274 379.421 159.274 380.741V482.206C159.274 483.526 160.123 484.092 161.16 483.432Z",
    fill: "#EFB118"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M172.66 368.482C174.734 367.256 176.525 368.388 176.525 370.934V472.116C176.525 474.757 174.828 477.869 172.66 479.094C170.586 480.32 168.795 479.189 168.795 476.643V375.46C168.889 372.82 170.586 369.708 172.66 368.482Z",
    fill: "#0044A7"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M172.66 476.831C173.697 476.265 174.545 474.662 174.545 473.342V371.877C174.545 370.557 173.697 369.991 172.66 370.651C171.623 371.217 170.774 372.82 170.774 374.14V475.605C170.774 476.831 171.623 477.397 172.66 476.831Z",
    fill: "#062E67"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M172.66 476.831C173.697 476.265 174.546 474.662 174.546 473.342V394.98L170.681 397.149V475.511C170.775 476.831 171.623 477.397 172.66 476.831Z",
    fill: "#EFB118"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M184.16 361.881C186.234 360.655 188.025 361.787 188.025 364.333V465.515C188.025 468.156 186.328 471.268 184.16 472.493C182.086 473.719 180.295 472.588 180.295 470.042V368.859C180.295 366.219 182.086 363.107 184.16 361.881Z",
    fill: "#0044A7"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M184.161 470.23C185.198 469.665 186.046 468.061 186.046 466.741V365.276C186.046 363.956 185.198 363.39 184.161 364.05C183.124 364.71 182.275 366.219 182.275 367.539V469.004C182.275 470.23 183.124 470.796 184.161 470.23Z",
    fill: "#062E67"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M184.16 470.23C185.197 469.665 186.046 468.061 186.046 466.741V449.579L182.181 451.748V468.91C182.275 470.23 183.123 470.796 184.16 470.23Z",
    fill: "#EFB118"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M195.661 355.186C197.735 353.96 199.526 355.092 199.526 357.638V458.82C199.526 461.461 197.829 464.572 195.661 465.798C193.587 467.024 191.796 465.893 191.796 463.346V362.164C191.796 359.524 193.587 356.412 195.661 355.186Z",
    fill: "#0044A7"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M195.661 463.535C196.698 462.969 197.546 461.366 197.546 460.046V358.581C197.546 357.26 196.698 356.695 195.661 357.355C194.624 357.92 193.775 359.524 193.775 360.844V462.309C193.775 463.629 194.624 464.195 195.661 463.535Z",
    fill: "#062E67"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M195.66 463.535C196.697 462.969 197.546 461.366 197.546 460.046V407.144L193.681 409.313V462.215C193.775 463.629 194.623 464.195 195.66 463.535Z",
    fill: "#EFB118"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M147.49 504.649L197.828 475.605C198.771 475.04 199.431 475.511 199.431 476.548V494.937C199.431 495.974 198.677 497.2 197.828 497.766L147.49 526.81C146.548 527.375 145.888 526.904 145.888 525.867V507.478C145.888 506.441 146.642 505.121 147.49 504.649Z",
    fill: "#0044A7"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M149.564 510.119C149.564 511.345 150.507 511.816 151.638 511.156L193.775 486.827C194.906 486.167 195.849 484.658 195.849 483.432C195.849 482.206 194.906 481.735 193.775 482.395L151.638 506.724C150.507 507.384 149.564 508.893 149.564 510.119Z",
    fill: "#062E67"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M149.564 510.119C149.564 511.344 150.507 511.816 151.638 511.156L182.275 493.428V488.996L151.638 506.724C150.507 507.384 149.564 508.893 149.564 510.119Z",
    fill: "#EFB118"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M149.564 518.888C149.564 520.114 150.507 520.586 151.638 519.926L193.775 495.597C194.906 494.937 195.849 493.428 195.849 492.202C195.849 490.976 194.906 490.505 193.775 491.165L151.638 515.494C150.507 516.154 149.564 517.663 149.564 518.888Z",
    fill: "#062E67"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M149.564 518.888C149.564 520.114 150.507 520.586 151.638 519.926L163.139 513.325V508.893L151.638 515.494C150.507 516.154 149.564 517.663 149.564 518.888Z",
    fill: "#EFB118"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M203.201 333.026L142.211 297.758C141.08 297.098 139.289 297.098 138.158 297.758L77.1677 333.026C76.0365 333.686 76.0365 334.723 77.1677 335.383L138.064 370.651C139.195 371.311 140.986 371.311 142.117 370.651L203.107 335.383C204.333 334.723 204.333 333.686 203.201 333.026Z",
    fill: "#0064F3"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M138.912 362.258L91.5907 334.912C90.9308 334.534 90.3652 333.591 90.3652 332.743V331.14C90.3652 330.385 90.9308 329.442 91.5907 328.971L138.912 301.624C139.572 301.247 140.703 301.247 141.363 301.624L188.685 328.971C189.345 329.348 189.91 330.291 189.91 331.14V332.743C189.91 333.497 189.345 334.44 188.685 334.912L141.363 362.258C140.703 362.635 139.572 362.635 138.912 362.258Z",
    fill: "#062E67"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5906 330.48L138.912 357.826C139.572 358.203 140.703 358.203 141.363 357.826L188.685 330.48C189.344 330.102 189.344 329.442 188.685 329.065L141.363 302.661C140.703 302.284 139.572 302.284 138.912 302.661L91.5906 329.065C90.9307 329.442 90.9307 330.102 91.5906 330.48Z",
    fill: "#0064F3"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M140.138 358.109V362.541C139.666 362.541 139.289 362.447 138.912 362.258L91.5907 334.912C90.9308 334.534 90.3652 333.591 90.3652 332.743V331.14C90.3652 330.48 90.7423 329.631 91.4022 329.159C90.9308 329.537 91.0251 330.102 91.5907 330.385L138.912 357.732C139.289 358.015 139.666 358.109 140.138 358.109Z",
    fill: "#0044A7"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M138.913 348.962L106.862 330.48C106.202 330.102 105.637 329.159 105.637 328.311V326.708C105.637 325.953 106.202 325.01 106.862 324.539L127.412 312.657C128.072 312.28 129.015 311.431 129.486 310.771L139.29 297.569C139.761 296.909 140.704 296.721 141.364 297.098L173.414 315.58C174.074 315.958 174.639 316.901 174.639 317.749V328.216C174.639 328.971 174.074 329.914 173.414 330.385L141.364 348.868C140.704 349.339 139.572 349.339 138.913 348.962Z",
    fill: "#062E67"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M141.363 344.53L161.913 332.648C162.196 332.46 162.668 332.177 162.95 331.894C163.327 331.517 163.705 331.14 163.987 330.857L173.791 317.655C174.262 316.995 174.074 316.24 173.414 315.769L141.363 297.286C140.704 296.909 139.761 297.098 139.29 297.758L129.486 310.96C129.015 311.62 128.26 312.469 127.601 312.846L106.862 324.633C106.202 325.01 106.202 325.67 106.862 326.048L138.913 344.53C139.572 344.907 140.704 344.907 141.363 344.53Z",
    fill: "#0064F3"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M173.414 315.769L141.364 297.286C140.704 296.909 139.761 297.098 139.29 297.758L129.486 310.96C129.203 311.243 128.921 311.62 128.449 311.997L162.951 331.894C163.328 331.517 163.705 331.14 163.988 330.857L173.791 317.655C174.263 316.995 174.074 316.146 173.414 315.769Z",
    fill: "#0044A7"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M114.686 324.916C115.44 324.445 116.76 324.445 117.514 324.916C118.268 325.387 118.268 326.142 117.514 326.613C116.76 327.085 115.44 327.085 114.686 326.613C113.838 326.142 113.838 325.387 114.686 324.916Z",
    fill: "#EFB118"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M120.436 328.311C121.19 327.839 122.51 327.839 123.264 328.311C124.018 328.782 124.018 329.537 123.264 330.008C122.51 330.48 121.19 330.48 120.436 330.008C119.588 329.442 119.588 328.782 120.436 328.311Z",
    fill: "#EFB118"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M126.186 331.611C126.94 331.14 128.26 331.14 129.014 331.611C129.768 332.083 129.768 332.837 129.014 333.309C128.26 333.78 126.94 333.78 126.186 333.309C125.338 332.837 125.338 332.083 126.186 331.611Z",
    fill: "#062E67"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M131.937 334.912C132.691 334.44 134.011 334.44 134.765 334.912C135.519 335.383 135.519 336.138 134.765 336.609C134.011 337.081 132.691 337.081 131.937 336.609C131.089 336.138 131.089 335.383 131.937 334.912Z",
    fill: "#062E67"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M118.928 322.464C119.682 321.993 121.002 321.993 121.756 322.464C122.51 322.936 122.51 323.69 121.756 324.162C121.002 324.633 119.682 324.633 118.928 324.162C118.174 323.69 118.174 322.936 118.928 322.464Z",
    fill: "#EFB118"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M126.186 327.745C127.332 327.745 128.26 327.238 128.26 326.613C128.26 325.988 127.332 325.482 126.186 325.482C125.041 325.482 124.112 325.988 124.112 326.613C124.112 327.238 125.041 327.745 126.186 327.745Z",
    fill: "#062E67"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M130.429 329.065C131.183 328.594 132.503 328.594 133.257 329.065C134.011 329.537 134.011 330.291 133.257 330.762C132.503 331.234 131.183 331.234 130.429 330.762C129.675 330.291 129.675 329.537 130.429 329.065Z",
    fill: "#EFB118"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M137.592 334.346C138.738 334.346 139.666 333.839 139.666 333.214C139.666 332.589 138.738 332.083 137.592 332.083C136.447 332.083 135.519 332.589 135.519 333.214C135.519 333.839 136.447 334.346 137.592 334.346Z",
    fill: "#062E67"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M123.265 320.012C124.019 319.541 125.339 319.541 126.093 320.012C126.847 320.484 126.847 321.238 126.093 321.71C125.339 322.181 124.019 322.181 123.265 321.71C122.511 321.144 122.511 320.484 123.265 320.012Z",
    fill: "#062E67"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M129.015 323.313C129.769 322.841 131.089 322.841 131.843 323.313C132.597 323.784 132.597 324.539 131.843 325.01C131.089 325.482 129.769 325.482 129.015 325.01C128.261 324.539 128.261 323.784 129.015 323.313Z",
    fill: "#EFB118"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M134.765 326.613C135.519 326.142 136.839 326.142 137.593 326.613C138.347 327.085 138.347 327.839 137.593 328.311C136.839 328.782 135.519 328.782 134.765 328.311C134.011 327.839 134.011 327.085 134.765 326.613Z",
    fill: "#062E67"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M137.687 338.118C138.441 337.646 139.761 337.646 140.515 338.118C141.269 338.589 141.269 339.344 140.515 339.815C139.761 340.287 138.441 340.287 137.687 339.815C136.839 339.344 136.839 338.589 137.687 338.118Z",
    fill: "#EFB118"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M141.929 335.666C142.683 335.195 144.003 335.195 144.757 335.666C145.511 336.137 145.511 336.892 144.757 337.363C144.003 337.835 142.683 337.835 141.929 337.363C141.175 336.892 141.175 336.137 141.929 335.666Z",
    fill: "#062E67"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M140.515 329.914C141.269 329.442 142.589 329.442 143.343 329.914C144.097 330.385 144.097 331.14 143.343 331.611C142.589 332.083 141.269 332.083 140.515 331.611C139.761 331.14 139.761 330.385 140.515 329.914Z",
    fill: "#062E67"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M129.014 319.447C130.16 319.447 131.088 318.94 131.088 318.315C131.088 317.69 130.16 317.183 129.014 317.183C127.869 317.183 126.94 317.69 126.94 318.315C126.94 318.94 127.869 319.447 129.014 319.447Z",
    fill: "#EFB118"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M133.351 320.861C134.105 320.39 135.425 320.39 136.179 320.861C136.933 321.333 136.933 322.087 136.179 322.559C135.425 323.03 134.105 323.03 133.351 322.559C132.503 321.993 132.503 321.238 133.351 320.861Z",
    fill: "#062E67"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M140.515 326.048C141.661 326.048 142.589 325.541 142.589 324.916C142.589 324.291 141.661 323.784 140.515 323.784C139.37 323.784 138.441 324.291 138.441 324.916C138.441 325.541 139.37 326.048 140.515 326.048Z",
    fill: "#EFB118"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M144.851 327.462C145.605 326.991 146.925 326.991 147.679 327.462C148.433 327.934 148.433 328.688 147.679 329.159C146.925 329.631 145.605 329.631 144.851 329.159C144.003 328.688 144.003 327.934 144.851 327.462Z",
    fill: "#062E67"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M146.265 333.214C147.019 332.743 148.339 332.743 149.093 333.214C149.847 333.686 149.847 334.44 149.093 334.912C148.339 335.383 147.019 335.383 146.265 334.912C145.511 334.346 145.511 333.686 146.265 333.214Z",
    fill: "#EFB118"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M152.015 332.648C153.161 332.648 154.089 332.142 154.089 331.517C154.089 330.892 153.161 330.385 152.015 330.385C150.87 330.385 149.941 330.892 149.941 331.517C149.941 332.142 150.87 332.648 152.015 332.648Z",
    fill: "#062E67"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M140.232 344.813V349.245C139.761 349.245 139.29 349.151 138.913 348.962L106.862 330.48C106.202 330.102 105.637 329.159 105.637 328.311V326.708C105.637 326.048 106.014 325.199 106.674 324.727C106.202 325.105 106.297 325.67 106.862 325.953L138.913 344.436C139.29 344.719 139.761 344.813 140.232 344.813Z",
    fill: "#0044A7"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M133.728 310.394C134.105 309.922 134.671 309.828 135.142 310.111L163.045 326.236C163.516 326.519 163.611 327.085 163.328 327.462C163.045 327.839 162.385 328.028 161.914 327.745L134.011 311.62C133.54 311.337 133.446 310.771 133.728 310.394Z",
    fill: "#062E67"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M133.728 310.394C134.105 309.922 134.671 309.828 135.142 310.111L155.88 322.087L154.655 323.596L133.916 311.62C133.539 311.337 133.445 310.771 133.728 310.394Z",
    fill: "#EFB118"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M135.99 307.282C136.367 306.811 136.933 306.716 137.404 306.999L165.307 323.124C165.778 323.407 165.872 323.973 165.59 324.35C165.307 324.727 164.647 324.916 164.176 324.633L136.273 308.508C135.802 308.225 135.707 307.754 135.99 307.282Z",
    fill: "#062E67"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M135.99 307.282C136.367 306.811 136.933 306.716 137.404 306.999L144.286 310.96L143.154 312.469L136.273 308.508C135.802 308.225 135.707 307.754 135.99 307.282Z",
    fill: "#EFB118"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M138.347 304.17C138.724 303.699 139.289 303.604 139.761 303.887L167.663 320.012C168.135 320.295 168.229 320.861 167.946 321.238C167.663 321.616 167.003 321.804 166.532 321.521L138.629 305.396C138.158 305.208 138.064 304.642 138.347 304.17Z",
    fill: "#062E67"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M138.347 304.17C138.724 303.699 139.289 303.604 139.761 303.887L154.278 312.186L153.146 313.694L138.629 305.396C138.158 305.208 138.064 304.642 138.347 304.17Z",
    fill: "#EFB118"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M140.609 301.153C140.986 300.681 141.552 300.587 142.023 300.87L169.926 316.901C170.397 317.183 170.492 317.749 170.209 318.126C169.926 318.504 169.266 318.692 168.795 318.409L140.892 302.379C140.421 302.096 140.326 301.53 140.609 301.153Z",
    fill: "#062E67"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M140.609 301.153C140.986 300.681 141.552 300.587 142.023 300.87L167.287 315.486L166.155 316.995L140.892 302.379C140.421 302.096 140.326 301.53 140.609 301.153Z",
    fill: "#EFB118"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 224.291,
    y1: 113.46,
    x2: 312.638,
    y2: 113.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 224.291,
    y1: 113.46,
    x2: 312.638,
    y2: 113.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 244.291,
    y1: 79.8899,
    x2: 314.87,
    y2: 79.8899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 250.459,
    y1: 94.8399,
    x2: 313.387,
    y2: 94.8399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 244.043,
    y1: 78.7802,
    x2: 314.622,
    y2: 78.7802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 211.925,
    y1: 60.0278,
    x2: 282.75,
    y2: 60.0278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 211.925,
    y1: 60.0278,
    x2: 282.75,
    y2: 60.0278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 61.3371,
    y1: 177.982,
    x2: 286.399,
    y2: 177.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 160.541,
    y1: 49.1547,
    x2: 238.03,
    y2: 49.1547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 160.541,
    y1: 49.1547,
    x2: 238.03,
    y2: 49.1547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 32.0813,
    y1: 227.955,
    x2: 123.389,
    y2: 227.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 32.0791,
    y1: 228.697,
    x2: 120.426,
    y2: 228.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 58.4975,
    y1: 225.797,
    x2: 123.4,
    y2: 225.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 216.402,
    y1: 139.678,
    x2: 285.292,
    y2: 139.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 216.399,
    y1: 137.608,
    x2: 285.291,
    y2: 137.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 221.063,
    y1: 132.853,
    x2: 280.632,
    y2: 132.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 221.06,
    y1: 125.444,
    x2: 280.632,
    y2: 125.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 221.062,
    y1: 145.749,
    x2: 280.631,
    y2: 145.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 223.168,
    y1: 123.239,
    x2: 278.527,
    y2: 123.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 223.166,
    y1: 119.411,
    x2: 278.528,
    y2: 119.411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 221.063,
    y1: 119.289,
    x2: 280.632,
    y2: 119.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 221.06,
    y1: 117.499,
    x2: 280.632,
    y2: 117.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 223.168,
    y1: 115.46,
    x2: 278.527,
    y2: 115.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 223.166,
    y1: 111.632,
    x2: 278.528,
    y2: 111.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 221.063,
    y1: 111.51,
    x2: 280.632,
    y2: 111.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 221.06,
    y1: 109.72,
    x2: 280.632,
    y2: 109.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 223.168,
    y1: 107.68,
    x2: 278.527,
    y2: 107.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 223.166,
    y1: 103.853,
    x2: 278.528,
    y2: 103.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 221.063,
    y1: 103.731,
    x2: 280.632,
    y2: 103.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 221.06,
    y1: 101.941,
    x2: 280.632,
    y2: 101.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 223.168,
    y1: 99.9015,
    x2: 278.527,
    y2: 99.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 223.166,
    y1: 96.0742,
    x2: 278.528,
    y2: 96.0742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 221.063,
    y1: 95.9522,
    x2: 280.632,
    y2: 95.9522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 221.06,
    y1: 94.1617,
    x2: 280.632,
    y2: 94.1617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 223.168,
    y1: 87.0757,
    x2: 278.527,
    y2: 87.0757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 223.167,
    y1: 78.4716,
    x2: 278.529,
    y2: 78.4716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 225.608,
    y1: 78.4717,
    x2: 276.084,
    y2: 78.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 223.167,
    y1: 100.781,
    x2: 278.526,
    y2: 100.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 229.428,
    y1: 78.4108,
    x2: 272.267,
    y2: 78.4108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 229.425,
    y1: 77.1234,
    x2: 272.266,
    y2: 77.1234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 231.322,
    y1: 77.1232,
    x2: 270.368,
    y2: 77.1232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 240.7,
    y1: 76.5207,
    x2: 260.994,
    y2: 76.5207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 240.701,
    y1: 75.6515,
    x2: 260.996,
    y2: 75.6515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 171.119,
    y1: 165.039,
    x2: 240.009,
    y2: 165.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 171.117,
    y1: 162.968,
    x2: 240.009,
    y2: 162.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 175.778,
    y1: 158.214,
    x2: 235.348,
    y2: 158.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 175.777,
    y1: 150.804,
    x2: 235.349,
    y2: 150.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 175.778,
    y1: 171.11,
    x2: 235.347,
    y2: 171.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 177.884,
    y1: 148.599,
    x2: 233.243,
    y2: 148.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 177.885,
    y1: 144.772,
    x2: 233.246,
    y2: 144.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear",
    x1: 175.778,
    y1: 144.65,
    x2: 235.348,
    y2: 144.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear",
    x1: 175.777,
    y1: 142.86,
    x2: 235.349,
    y2: 142.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear",
    x1: 177.884,
    y1: 140.82,
    x2: 233.243,
    y2: 140.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear",
    x1: 177.885,
    y1: 136.993,
    x2: 233.246,
    y2: 136.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear",
    x1: 175.778,
    y1: 136.871,
    x2: 235.348,
    y2: 136.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear",
    x1: 175.777,
    y1: 135.081,
    x2: 235.349,
    y2: 135.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear",
    x1: 177.884,
    y1: 133.041,
    x2: 233.243,
    y2: 133.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear",
    x1: 177.885,
    y1: 129.214,
    x2: 233.246,
    y2: 129.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear",
    x1: 175.778,
    y1: 129.092,
    x2: 235.348,
    y2: 129.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear",
    x1: 175.777,
    y1: 127.302,
    x2: 235.349,
    y2: 127.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear",
    x1: 177.884,
    y1: 125.262,
    x2: 233.243,
    y2: 125.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear",
    x1: 177.885,
    y1: 121.435,
    x2: 233.246,
    y2: 121.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear",
    x1: 175.778,
    y1: 121.313,
    x2: 235.348,
    y2: 121.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear",
    x1: 175.777,
    y1: 119.523,
    x2: 235.349,
    y2: 119.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear",
    x1: 177.884,
    y1: 112.436,
    x2: 233.243,
    y2: 112.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear",
    x1: 177.883,
    y1: 103.832,
    x2: 233.244,
    y2: 103.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear",
    x1: 180.324,
    y1: 103.833,
    x2: 230.8,
    y2: 103.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear",
    x1: 177.883,
    y1: 126.142,
    x2: 233.242,
    y2: 126.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear",
    x1: 184.142,
    y1: 103.772,
    x2: 226.982,
    y2: 103.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear",
    x1: 184.141,
    y1: 102.484,
    x2: 226.982,
    y2: 102.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear",
    x1: 186.037,
    y1: 102.484,
    x2: 225.083,
    y2: 102.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear",
    x1: 195.416,
    y1: 101.882,
    x2: 215.71,
    y2: 101.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear",
    x1: 195.417,
    y1: 101.012,
    x2: 215.712,
    y2: 101.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear",
    x1: 126.983,
    y1: 190.4,
    x2: 195.872,
    y2: 190.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear",
    x1: 126.981,
    y1: 188.329,
    x2: 195.873,
    y2: 188.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear",
    x1: 131.642,
    y1: 183.575,
    x2: 191.211,
    y2: 183.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear",
    x1: 131.64,
    y1: 176.165,
    x2: 191.212,
    y2: 176.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear",
    x1: 131.642,
    y1: 196.471,
    x2: 191.211,
    y2: 196.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear",
    x1: 133.744,
    y1: 173.96,
    x2: 189.103,
    y2: 173.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear",
    x1: 133.745,
    y1: 170.133,
    x2: 189.107,
    y2: 170.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear",
    x1: 131.642,
    y1: 170.011,
    x2: 191.211,
    y2: 170.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear",
    x1: 131.64,
    y1: 168.221,
    x2: 191.212,
    y2: 168.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear",
    x1: 133.744,
    y1: 166.181,
    x2: 189.103,
    y2: 166.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear",
    x1: 133.745,
    y1: 162.354,
    x2: 189.107,
    y2: 162.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear",
    x1: 131.642,
    y1: 162.232,
    x2: 191.211,
    y2: 162.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear",
    x1: 131.64,
    y1: 160.442,
    x2: 191.212,
    y2: 160.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear",
    x1: 133.744,
    y1: 158.402,
    x2: 189.103,
    y2: 158.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear",
    x1: 133.745,
    y1: 154.575,
    x2: 189.107,
    y2: 154.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear",
    x1: 131.642,
    y1: 154.453,
    x2: 191.211,
    y2: 154.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear",
    x1: 131.64,
    y1: 152.663,
    x2: 191.212,
    y2: 152.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear",
    x1: 133.744,
    y1: 150.623,
    x2: 189.103,
    y2: 150.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear",
    x1: 133.745,
    y1: 146.796,
    x2: 189.107,
    y2: 146.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear",
    x1: 131.642,
    y1: 146.674,
    x2: 191.211,
    y2: 146.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear",
    x1: 131.64,
    y1: 144.883,
    x2: 191.212,
    y2: 144.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear",
    x1: 133.744,
    y1: 137.797,
    x2: 189.103,
    y2: 137.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear",
    x1: 133.745,
    y1: 129.193,
    x2: 189.107,
    y2: 129.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear",
    x1: 136.185,
    y1: 129.193,
    x2: 186.66,
    y2: 129.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear",
    x1: 133.743,
    y1: 151.503,
    x2: 189.102,
    y2: 151.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear",
    x1: 140.008,
    y1: 129.133,
    x2: 182.847,
    y2: 129.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear",
    x1: 140.005,
    y1: 127.845,
    x2: 182.846,
    y2: 127.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear",
    x1: 141.903,
    y1: 127.845,
    x2: 180.95,
    y2: 127.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear",
    x1: 151.281,
    y1: 127.243,
    x2: 171.575,
    y2: 127.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear",
    x1: 151.281,
    y1: 126.373,
    x2: 171.576,
    y2: 126.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear",
    x1: 82.3536,
    y1: 215.76,
    x2: 151.243,
    y2: 215.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear",
    x1: 82.3521,
    y1: 213.69,
    x2: 151.245,
    y2: 213.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear",
    x1: 87.0138,
    y1: 208.935,
    x2: 146.583,
    y2: 208.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear",
    x1: 87.0115,
    y1: 201.526,
    x2: 146.583,
    y2: 201.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear",
    x1: 87.0129,
    y1: 221.832,
    x2: 146.582,
    y2: 221.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear",
    x1: 89.1223,
    y1: 199.321,
    x2: 144.481,
    y2: 199.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear",
    x1: 89.12,
    y1: 195.494,
    x2: 144.482,
    y2: 195.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear",
    x1: 87.0138,
    y1: 195.372,
    x2: 146.583,
    y2: 195.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear",
    x1: 87.0115,
    y1: 193.581,
    x2: 146.583,
    y2: 193.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear",
    x1: 89.1223,
    y1: 191.542,
    x2: 144.481,
    y2: 191.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear",
    x1: 89.12,
    y1: 187.715,
    x2: 144.482,
    y2: 187.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear",
    x1: 87.0138,
    y1: 187.593,
    x2: 146.583,
    y2: 187.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear",
    x1: 87.0115,
    y1: 185.802,
    x2: 146.583,
    y2: 185.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear",
    x1: 89.1223,
    y1: 183.763,
    x2: 144.481,
    y2: 183.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear",
    x1: 89.12,
    y1: 179.935,
    x2: 144.482,
    y2: 179.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear",
    x1: 87.0138,
    y1: 179.813,
    x2: 146.583,
    y2: 179.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear",
    x1: 87.0115,
    y1: 178.023,
    x2: 146.583,
    y2: 178.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear",
    x1: 89.1223,
    y1: 175.984,
    x2: 144.481,
    y2: 175.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear",
    x1: 89.12,
    y1: 172.156,
    x2: 144.482,
    y2: 172.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear",
    x1: 87.0138,
    y1: 172.034,
    x2: 146.583,
    y2: 172.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear",
    x1: 87.0115,
    y1: 170.244,
    x2: 146.583,
    y2: 170.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear",
    x1: 89.1175,
    y1: 163.158,
    x2: 144.477,
    y2: 163.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0088FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear",
    x1: 89.1181,
    y1: 154.554,
    x2: 144.48,
    y2: 154.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear",
    x1: 91.5576,
    y1: 154.554,
    x2: 142.033,
    y2: 154.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear",
    x1: 89.1165,
    y1: 176.864,
    x2: 144.475,
    y2: 176.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEFCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear",
    x1: 95.3749,
    y1: 154.493,
    x2: 138.215,
    y2: 154.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear",
    x1: 95.3759,
    y1: 153.206,
    x2: 138.218,
    y2: 153.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear",
    x1: 97.273,
    y1: 153.206,
    x2: 136.32,
    y2: 153.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear",
    x1: 106.652,
    y1: 152.603,
    x2: 126.946,
    y2: 152.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00295A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear",
    x1: 106.652,
    y1: 151.734,
    x2: 126.947,
    y2: 151.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3D6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear",
    x1: 12.0927,
    y1: 177.721,
    x2: 132.027,
    y2: 177.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear",
    x1: 182.297,
    y1: 47.2772,
    x2: 279.775,
    y2: 47.2772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear",
    x1: 182.528,
    y1: 49.1689,
    x2: 256.562,
    y2: 49.1689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear",
    x1: 194.394,
    y1: 43.1218,
    x2: 280.027,
    y2: 43.1218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear",
    x1: 69.934,
    y1: 67.7244,
    x2: 228.366,
    y2: 67.7244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear",
    x1: 226.513,
    y1: 53.5026,
    x2: 312.145,
    y2: 53.5026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear",
    x1: 226.494,
    y1: 55.5915,
    x2: 288.683,
    y2: 55.5915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear",
    x1: 226.512,
    y1: 53.8008,
    x2: 311.898,
    y2: 53.8008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear",
    x1: 74.4508,
    y1: 147.416,
    x2: 322.71,
    y2: 147.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselPublicApi);
export default __webpack_public_path__ + "static/media/carousel-public-api.9f770d200ca824d5b8b15fc42d4c8338.svg";
export { ForwardRef as ReactComponent };